webpackJsonp([24],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRef", function() { return createRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rerender", function() { return rerender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

function applyRef(ref, value) {
  if (ref) {
    if (typeof ref == 'function') ref(value);else ref.current = value;
  }
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p;
	while (p = items.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		applyRef(old, null);
		applyRef(value, node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.shift()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null) applyRef(node['__preactattr_'].ref, null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	applyRef(component.__ref, component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.push(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] != null) applyRef(base['__preactattr_'].ref, null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	applyRef(component.__ref, null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

function createRef() {
	return {};
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	createRef: createRef,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* harmony default export */ __webpack_exports__["default"] = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__connect__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createComponent__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createComponentWithProxy__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FelaComponent__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FelaTheme__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Provider__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__withTheme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fe__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_0__connect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createComponent", function() { return __WEBPACK_IMPORTED_MODULE_1__createComponent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createComponentWithProxy", function() { return __WEBPACK_IMPORTED_MODULE_2__createComponentWithProxy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FelaComponent", function() { return __WEBPACK_IMPORTED_MODULE_3__FelaComponent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FelaTheme", function() { return __WEBPACK_IMPORTED_MODULE_4__FelaTheme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_5__Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return __WEBPACK_IMPORTED_MODULE_7__withTheme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fe", function() { return __WEBPACK_IMPORTED_MODULE_8__fe__["a"]; });












/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = arrayReduce;

function arrayReduce(arr, reducer, initialValue) {
  for (var i = 0, len = arr.length; i < len; ++i) {
    initialValue = reducer(initialValue, arr[i], i, len, arr);
  }

  return initialValue;
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAttrsGtm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getCookie = getCookie;
exports.headerBifrostAu = headerBifrostAu;
exports.defaultHeaders = defaultHeaders;
exports.http = http;
exports.isSafari = isSafari;
exports.parseJSON = parseJSON;
exports.request = request;

var _store = __webpack_require__(14);

var _store2 = _interopRequireDefault(_store);

var _constants = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function headerBifrostAu() {
  var headers = {};
  // if (isSafari()) {
  var xBifrostAu = getCookie('Valgrind-AU');
  if (xBifrostAu) {
    headers['X-Bifrost-Authorization'] = xBifrostAu;
  }
  // }

  return headers;
}

function defaultHeaders() {
  var apikey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var bifrost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return _extends({
    Accept: 'application/json',
    'content-type': 'application/json'
  }, apikey ? { 'X-Application-Key': apikey } : null, bifrost ? { 'X-Bifrost-Authorization': bifrost } : null);
}

function http(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return fetch(url, _extends({
    method: 'GET',
    // credentials: 'include',
    mode: 'cors'
  }, options)).then(function (response) {
    var contentType = response.headers.get("content-type");
    if (response.ok) {
      if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json();
      }

      return response;
    }
  });
}

function isSafari() {
  return navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
}

function parseJSON(json) {
  try {
    return json !== '' ? JSON.parse(json) : '';
  } catch (error) {
    return json;
  }
}

function request(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  var headers = options.headers || {};
  var method = options.method || 'GET';

  var state = _store2.default.getState();

  var req = new XMLHttpRequest();

  req.open(method, '' + url);
  req.setRequestHeader('Content-Type', 'application/json');

  Object.keys(headers).forEach(function (key) {
    req.setRequestHeader(key, headers[key]);
  });

  if (options.type === _constants.ECRED) {
    var apiKey = state.heimdall.ecred.apiKey;

    req.setRequestHeader('X-Application-Key', apiKey);
  } else {
    req.withCredentials = true;
  }

  if (state.profile) {
    req.setRequestHeader('X-Bifrost-Authorization', state.profile.token);
  }

  req.onreadystatechange = function () {
    if (req.readyState < 4) {
      return;
    }

    callback(req.status < 200 || req.status > 299, {
      status: req.status,
      responseText: req.responseText,
      response: parseJSON(req.responseText)
    });
  };

  req.send();
}

var getAttrsGtm = exports.getAttrsGtm = function getAttrsGtm(name, params) {
  var _ref = params || {},
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'click' : _ref$type,
      _ref$clicktype = _ref.clicktype,
      clicktype = _ref$clicktype === undefined ? 'link' : _ref$clicktype;

  return {
    "data-gtm-type": type,
    "data-gtm-clicktype": clicktype,
    "data-gtm-name": name
  };
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyKeysInOrder__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clusterCache__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cssifySupportRules__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generateCombinedMediaQuery__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__generateCSSRule__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generateCSSSelector__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__generateCSSSupportRule__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generateUniqueHash__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getRuleScore__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isMediaQuery__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isNestedSelector__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isSupport__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isUndefinedValue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__isValidHTMLElement__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__normalizeNestedProperty__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__processStyleWithPlugins__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sheetMap__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styleTypes__ = __webpack_require__(27);
/* unused harmony reexport applyKeysInOrder */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__clusterCache__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__cssifySupportRules__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__generateCombinedMediaQuery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__generateCSSRule__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__generateCSSSelector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__generateCSSSupportRule__["a"]; });
/* unused harmony reexport generateUniqueHash */
/* unused harmony reexport getRuleScore */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_9__isMediaQuery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__isNestedSelector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__isSupport__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__isUndefinedValue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_13__isValidHTMLElement__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_14__normalizeNestedProperty__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__processStyleWithPlugins__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_16__sheetMap__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__styleTypes__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_17__styleTypes__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_17__styleTypes__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__styleTypes__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_17__styleTypes__["a"]; });





















/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = objectReduce;

function objectReduce(obj, reducer, initialValue) {
  for (var key in obj) {
    initialValue = reducer(initialValue, obj[key], key, obj);
  }

  return initialValue;
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleMenuDropdown = exports.goMenu = exports.goSignUp = exports.goLogin = exports.goBrandPath = exports.goSerasaConsumidor = exports.readNotifications = exports.unreadNotifications = exports.notifications = exports.notification = exports.logout = exports.reset = exports.metric = exports.signUp = exports.login = exports.product = exports.brand = exports.gradient = exports.menus = exports.config = exports.init = exports.analyticsEvent = undefined;

var _bifrost = __webpack_require__(32);

var _bifrost2 = _interopRequireDefault(_bifrost);

var _store = __webpack_require__(14);

var _store2 = _interopRequireDefault(_store);

var _types = __webpack_require__(25);

var _constants = __webpack_require__(9);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsEvent = exports.analyticsEvent = function analyticsEvent(label, value) {
  if (window.dataLayer == null) {
    return;
  }

  var state = _store2.default.getState();

  window.dataLayer.push({
    event: 'event',
    category: state.metric.category || 'header-' + state.product,
    action: 'header',
    label: label,
    value: value
  });
};

var init = exports.init = function init(state) {
  return {
    type: _types.INIT,
    payload: state
  };
};

var config = exports.config = function config(newConfig) {
  return {
    type: _types.CONFIG,
    payload: newConfig
  };
};

var menus = exports.menus = function menus(newMenus) {
  return {
    type: _types.MENUS,
    payload: newMenus
  };
};

var gradient = exports.gradient = function gradient(newGradient, newColor) {
  return {
    type: _types.GRADIENT,
    payload: {
      gradient: newGradient,
      color: newColor
    }
  };
};

var brand = exports.brand = function brand(newBrand) {
  return {
    type: _types.BRAND,
    payload: newBrand
  };
};

var product = exports.product = function product(newProduct) {
  return {
    type: _types.PRODUCT,
    payload: newProduct
  };
};

var login = exports.login = function login(logged, user) {
  return {
    type: _types.LOGGED,
    payload: {
      logged: logged,
      user: logged ? user : null
    }
  };
};

var signUp = exports.signUp = function signUp(newSignUp) {
  return {
    type: _types.SIGNUP,
    payload: newSignUp
  };
};

var metric = exports.metric = function metric(newMetric) {
  return {
    type: _types.METRIC,
    payload: newMetric
  };
};

var reset = exports.reset = function reset(newStore) {
  return {
    type: _types.RESET,
    payload: newStore
  };
};

var logout = exports.logout = function logout() {
  var state = _store2.default.getState();

  var token = state.profile.token;

  analyticsEvent('logout');

  _bifrost2.default.logout(token, function () {
    if (typeof state.logout.callback === 'function') {
      state.logout.callback();
    } else {
      document.location.reload();
    }

    _store2.default.dispatch({ type: _types.LOGOUT });
  });
};

var notification = exports.notification = function notification(active) {
  return {
    type: _types.NOTIFICATION,
    payload: active
  };
};

var notifications = exports.notifications = function notifications() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  var state = _store2.default.getState();
  var _state$heimdall = state.heimdall,
      ecred = _state$heimdall.ecred,
      endpoints = _state$heimdall.endpoints;


  if (state.notification.loading) {
    return { type: _types.NOOP };
  }

  _store2.default.dispatch({
    type: _types.NOTIFICATIONS_LOADING,
    payload: true
  });

  (0, _utils.request)(ecred.api + endpoints.notification.get({ offset: offset, limit: limit }), {
    type: _constants.ECRED
  }, function (err, req) {
    if (err) {
      _store2.default.dispatch({ type: _types.NOTIFICATIONS_ERROR });
      return;
    }

    _store2.default.dispatch({
      type: _types.NOTIFICATIONS_SUCCESS,
      payload: req.response.data
    });
  });
};

var unreadNotifications = exports.unreadNotifications = function unreadNotifications() {
  var state = _store2.default.getState();
  var _state$heimdall2 = state.heimdall,
      ecred = _state$heimdall2.ecred,
      endpoints = _state$heimdall2.endpoints;


  if (state.notification.loading || state.notification.unreadLoaded) {
    return { type: _types.NOOP };
  }

  _store2.default.dispatch({
    type: _types.NOTIFICATIONS_LOADING,
    payload: true
  });

  (0, _utils.request)(ecred.api + endpoints.notification.unread, {
    type: _constants.ECRED
  }, function (err, req) {
    if (err) {
      _store2.default.dispatch({ type: _types.NOTIFICATIONS_UNREAD, payload: 0 });
      return;
    }

    _store2.default.dispatch({
      type: _types.NOTIFICATIONS_UNREAD,
      payload: req.response.data.count
    });
  });
};

var readNotifications = exports.readNotifications = function readNotifications(id, url, index) {
  var state = _store2.default.getState();
  var _state$heimdall3 = state.heimdall,
      ecred = _state$heimdall3.ecred,
      endpoints = _state$heimdall3.endpoints;


  if (state.notification.loading) {
    return { type: _types.NOOP };
  }

  _store2.default.dispatch({
    type: _types.NOTIFICATIONS_LOADING,
    payload: true
  });

  (0, _utils.request)(ecred.api + endpoints.notification.read(id), {
    method: 'PUT',
    type: _constants.ECRED
  }, function (err, req) {
    window.location.href = url;

    if (err) {
      _store2.default.dispatch({ type: _types.NOTIFICATIONS_READ, payload: state.notification.list });
      return;
    }

    var list = state.notification.list;
    list[index].isRead = true;

    _store2.default.dispatch({
      type: _types.NOTIFICATIONS_READ,
      payload: req.response.data
    });
  });
};

var goSerasaConsumidor = exports.goSerasaConsumidor = function goSerasaConsumidor(evt) {
  var state = _store2.default.getState();

  analyticsEvent('logo-sc');

  if (state.config.proxy) {
    state.config.proxy(evt);
  }
};

var goBrandPath = exports.goBrandPath = function goBrandPath(evt) {
  var state = _store2.default.getState();

  if (typeof state.brand.callback === 'function') {
    state.brand.callback(evt);
  }

  return { type: _types.NOOP };
};

var goLogin = exports.goLogin = function goLogin(evt) {
  var state = _store2.default.getState();
  analyticsEvent('entrar');

  if (state.heimdall.dropdown.menu) {
    _store2.default.dispatch(toggleMenuDropdown());
  }

  if (typeof state.login.callback === 'function') {
    state.login.callback(evt);
  }

  return { type: _types.NOOP };
};

var goSignUp = exports.goSignUp = function goSignUp(evt, key) {
  var state = _store2.default.getState();
  analyticsEvent('cadastro_' + key);

  if (state.heimdall.dropdown.menu) {
    _store2.default.dispatch(toggleMenuDropdown());
  }

  if (typeof state.signUp.callback === 'function') {
    state.signUp.callback(evt);
  }

  return { type: _types.NOOP };
};

var goMenu = exports.goMenu = function goMenu(evt, menu) {
  if (menu.scroll) {
    evt.preventDefault();
    var element = document.querySelector(menu.url);

    if (element == null) {
      return { type: _types.NOOP };
    }

    var scrollY = window.scrollY || window.pageYOffset;
    var top = element.getBoundingClientRect().top + scrollY;

    window.scrollTo({
      top: top - (top > 128 ? 56 : top),
      left: 0,
      behavior: 'smooth'
    });
  }

  if (menu.callback) {
    menu.callback(evt);
  }

  return { type: _types.NOOP };
};

/*-------------------------------------------------------------*/
/*                     DROPDOWN                                */
/*-------------------------------------------------------------*/

var toggleMenuDropdown = exports.toggleMenuDropdown = function toggleMenuDropdown() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'menu';

  var state = _store2.default.getState();

  var methodClass = 'add';
  var paddingRightStyle = null;
  var body$ = document.querySelector('body');

  if (state.heimdall.dropdown[menu]) {
    methodClass = 'remove';
  } else {
    paddingRightStyle = window.innerWidth - document.documentElement.clientWidth;
  }

  body$.classList[methodClass]('ecs_hl_overflow');
  body$.style.paddingRight = paddingRightStyle;

  return {
    type: _types.TOGGLE_DROPDOWN,
    payload: menu
  };
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var t=__webpack_require__(0);function n(t,n){for(var r in n)t[r]=n[r];return t}function r(t){this.getChildContext=function(){return{store:t.store}}}r.prototype.render=function(t){return t.children&&t.children[0]||t.children},exports.connect=function(r,e){var o;return"function"!=typeof r&&("string"==typeof(o=r||{})&&(o=o.split(/\s*,\s*/)),r=function(t){for(var n={},r=0;r<o.length;r++)n[o[r]]=t[o[r]];return n}),function(o){function i(i,u){var c=this,f=u.store,s=r(f?f.getState():{},i),a=e?function(t,n){"function"==typeof t&&(t=t(n));var r={};for(var e in t)r[e]=n.action(t[e]);return r}(e,f):{store:f},p=function(){var t=r(f?f.getState():{},i);for(var n in t)if(t[n]!==s[n])return s=t,c.setState({});for(var e in s)if(!(e in t))return s=t,c.setState({})};this.componentWillReceiveProps=function(t){i=t,p()},this.componentDidMount=function(){f.subscribe(p)},this.componentWillUnmount=function(){f.unsubscribe(p)},this.render=function(r){return t.h(o,n(n(n({},a),r),s))}}return(i.prototype=new t.Component).constructor=i}},exports.Provider=r;
//# sourceMappingURL=preact.js.map


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__connectFactory__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createComponentFactory__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FelaComponentFactory__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FelaThemeFactory__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProviderFactory__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProviderFactory__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__withThemeFactory__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__createTheme__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__feFactory__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__themeChannel__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__connectFactory__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__createComponentFactory__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__FelaComponentFactory__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__FelaThemeFactory__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__ProviderFactory__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__ThemeProviderFactory__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__withThemeFactory__["a"]; });
/* unused harmony reexport createTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__feFactory__["a"]; });
/* unused harmony reexport THEME_CHANNEL */













/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PRODUCTS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SERASA = exports.SERASA = 'serasa';
var ECRED = exports.ECRED = 'ecred';
var ANTIFRAUDE = exports.ANTIFRAUDE = 'antifraude';
var PREMIUM = exports.PREMIUM = 'premium';
var LIMPA_NOME = exports.LIMPA_NOME = 'limpa-nome';
var SCORE = exports.SCORE = 'score';
var CADASTRO_POSITIVO = exports.CADASTRO_POSITIVO = 'cadastro-positivo';
var VOCE_CONSULTA = exports.VOCE_CONSULTA = 'voce-consulta';
var ENSINA = exports.ENSINA = 'ensina';
var CARTEIRA_DIGITAL = exports.CARTEIRA_DIGITAL = 'carteira-digital';

var EXTERNAL_SITE_MESSAGE = exports.EXTERNAL_SITE_MESSAGE = 'abre em site externo.';

var BREAKPOINT = exports.BREAKPOINT = {
  TABLET: '',
  DESKTOP: '1023px'
};

var PREFIX = '/lno/static-webfiles';
var PREFIX_PRODUCTS = PREFIX + '/common/products';

var PRODUCTS = exports.PRODUCTS = (_PRODUCTS = {}, _defineProperty(_PRODUCTS, SERASA, {
  key: SERASA,
  name: 'Serasa',
  url: '/',
  logo: PREFIX + '/logo/serasa.svg',
  logoWhite: PREFIX + '/logo/serasa-white.svg',
  logoGray: PREFIX + '/logo/serasa-gray.svg',
  square: PREFIX + '/logo/serasa-icon.svg'
}), _defineProperty(_PRODUCTS, ECRED, {
  key: ECRED,
  name: 'Serasa Crédito',
  url: '/credito/',
  logo: PREFIX_PRODUCTS + '/serasa-credito.svg',
  logoWhite: PREFIX_PRODUCTS + '/serasa-credito-white.svg',
  square: PREFIX_PRODUCTS + '/square/credito.svg'
}), _defineProperty(_PRODUCTS, ANTIFRAUDE, {
  key: ANTIFRAUDE,
  name: 'Serasa Antifraude',
  url: '/antifraude/',
  logo: PREFIX_PRODUCTS + '/antifraude.svg',
  logoWhite: PREFIX_PRODUCTS + '/antifraude-white.svg',
  square: PREFIX_PRODUCTS + '/square/antifraude.svg'
}), _defineProperty(_PRODUCTS, PREMIUM, {
  key: PREMIUM,
  name: 'Serasa Premium',
  url: '/premium/',
  logo: PREFIX_PRODUCTS + '/serasa-premium.svg',
  logoWhite: PREFIX_PRODUCTS + '/serasa-premium-white.svg',
  square: PREFIX_PRODUCTS + '/square/serasa-premium.svg'
}), _defineProperty(_PRODUCTS, LIMPA_NOME, {
  key: LIMPA_NOME,
  name: 'Serasa Limpa Nome',
  url: '/limpa-nome-online/',
  logo: PREFIX_PRODUCTS + '/limpa-nome.svg',
  logoWhite: PREFIX_PRODUCTS + '/limpa-nome-white.svg',
  square: PREFIX_PRODUCTS + '/square/limpa-nome.svg'
}), _defineProperty(_PRODUCTS, SCORE, {
  key: SCORE,
  name: 'Serasa Score',
  url: '/score/',
  logo: PREFIX_PRODUCTS + '/score.svg',
  logoWhite: PREFIX_PRODUCTS + '/score-white.svg',
  square: PREFIX_PRODUCTS + '/square/score.svg'
}), _defineProperty(_PRODUCTS, CADASTRO_POSITIVO, {
  key: CADASTRO_POSITIVO,
  name: 'Serasa Cadastro Positivo',
  url: '/cadastro-positivo/',
  logo: PREFIX_PRODUCTS + '/cadastro-positivo.svg',
  logoWhite: PREFIX_PRODUCTS + '/cadastro-positivo-white.svg',
  square: PREFIX_PRODUCTS + '/square/cadastro-positivo.svg'
}), _defineProperty(_PRODUCTS, VOCE_CONSULTA, {
  key: VOCE_CONSULTA,
  name: 'Você Consulta',
  url: '/voceconsulta/',
  square: PREFIX_PRODUCTS + '/square/vcep.svg'
}), _defineProperty(_PRODUCTS, CARTEIRA_DIGITAL, {
  key: CARTEIRA_DIGITAL,
  name: 'Serasa Carteira Digital',
  url: '/carteira-digital/',
  square: PREFIX_PRODUCTS + '/square/serasa-premium.svg'
}), _PRODUCTS);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(11);

Object.defineProperty(exports, 'Button', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

var _Dividir = __webpack_require__(55);

Object.defineProperty(exports, 'Dividir', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Dividir).default;
  }
});

var _Link = __webpack_require__(56);

Object.defineProperty(exports, 'Link', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Link).default;
  }
});

var _Dropdown = __webpack_require__(190);

Object.keys(_Dropdown).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Dropdown[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preactFela = __webpack_require__(1);

var button = function button(_ref) {
  var color = _ref.color,
      background = _ref.background,
      dense = _ref.dense,
      padding = _ref.padding;
  return {
    color: color || '#ffffff',
    cursor: 'pointer',
    margin: '0',
    border: '0',
    display: 'inline-flex',
    padding: padding || (dense ? '4px 14px' : '10px 16px'),
    outline: 'none',
    position: 'relative',
    userSelect: 'none',
    alignItems: 'center',
    borderRadius: '2px',
    verticalAlign: 'middle',
    justifyContent: 'center',
    MozAppearance: 'none',
    textDecoration: 'none',
    backgroundColor: background || 'transparent',
    WebkitAppearance: 'none',
    WebkitTapHighlightColor: 'transparent',
    boxSizing: 'border-box',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '10px',
    fontWeight: 'normal',
    lineHeight: 'normal',
    textTransform: 'uppercase',
    ':hover': {
      textDecoration: 'none',
      color: color
    },
    ':focus': {
      outline: 'none',
      textDecoration: 'none'
    }
  };
};

exports.default = (0, _preactFela.createComponentWithProxy)(button, 'button');

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = arrayEach;

function arrayEach(arr, iterator) {
  for (var i = 0, len = arr.length; i < len; ++i) {
    iterator(arr[i], i, len, arr);
  }
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = objectEach;

function objectEach(obj, iterator) {
  for (var key in obj) {
    iterator(obj[key], key, obj);
  }
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entries = __webpack_require__(71);

var _entries2 = _interopRequireDefault(_entries);

var _unistore = __webpack_require__(99);

var _unistore2 = _interopRequireDefault(_unistore);

var _reducer = __webpack_require__(100);

var _reducer2 = _interopRequireDefault(_reducer);

var _types = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WHITE = '#ffffff';

var initialState = {
  product: null,

  menus: [],

  profile: null,
  loggedIn: false,

  config: {
    color: null,
    inverseColor: WHITE,
    textColor: WHITE,

    background: null,
    backgroundInScroll: null,

    gradient: false,
    gradientColor: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(178, 178, 178, 0))',

    full: false,
    singleCTA: false,
    profileDisabled: false
  },

  brand: {
    path: '/',
    logo: {
      default: null,
      negative: null,
      alt: ''
    },
    callback: undefined
  },

  login: {
    path: '/entrar',
    callback: undefined,
    loginAccessibleLabel: 'Fazer login na Serasa',
    text: 'Login',
    disabledInNavbar: false,
    disabledInProfile: false
  },

  signUp: {
    path: '/cadastrar',
    callback: undefined,
    text: 'Cadastre-se',
    textInMenu: 'Cadastre-se',
    signUpAccessibleLabel: 'Fazer cadastro na Serasa',
    accessibleTextLabel: 'Fazer cadastro na Serasa',
    disabledInNavbar: false,
    disabledInProfile: false
  },

  logout: {
    callback: undefined
  },

  notification: {
    active: false,
    loading: false,
    unreadLoaded: false,
    unread: 0,
    list: []
  },

  metric: {
    category: null
  },

  environment: 'development',

  // Private
  heimdall: {
    host: '',
    api: '',
    notificationApi: '',
    notificationApiKey: '',
    dropdown: {
      menu: false
    },
    pages: [{ id: 1, label: 'Consultar meu CPF', url: '/consultar-meu-cpf' }, { id: 3, label: 'Pedir empréstimo on-line', url: '/ecred' }, { id: 4, label: 'Consultar pontuação do Score', url: '/score' }, { id: 5, label: 'Monitorar meu CPF', url: '/premium/monitoramento-cpf' }, { id: 6, label: 'Limpar meu nome', url: '/limpa-nome-online' }, { id: 7, label: 'Negociar minhas dívidas', url: '/limpa-nome-online' }, { id: 8, label: 'Falar com a Serasa', url: '/atendimento' }, { id: 9, label: 'Atualizar meus dados', url: '/meus-dados/alterar-dados/' }, { id: 10, label: 'Soluções para empresas', url: '//empresas.serasaexperian.com.br' }, { id: 11, label: 'Proteção de Dados Pessoais', url: '/protecao-dados-pessoais/' }],
    products: [{ key: 'ecred', name: 'Serasa Crédito', url: '/credito' }, { key: 'premium', name: 'Serasa Premium', url: '/premium/' }, { key: 'limpa-nome', name: 'Serasa Limpa Nome', url: '/limpa-nome-online/' }, { key: 'score', name: 'Serasa Score', url: '/score/' }, { key: 'carteira-digital', name: 'Serasa Carteira Digital', url: '/carteira-digital' }, { key: 'cadastro-positivo', name: 'Serasa Cadastro Positivo', url: '/cadastro-positivo/' }, { key: 'voce-consulta', name: 'Você Consulta', url: '/voceconsulta/' }],
    profiles: [{ key: 'perfil', label: 'Meu perfil', path: '/meu-perfil' }, { key: 'edit', label: 'Editar dados', path: '/meus-dados/alterar-dados/' }, { key: 'logout', label: 'Sair', logout: true }],
    endpoints: {
      logout: '/user/logout',
      notification: {
        get: function get() {
          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { offset: 0, limit: 5 },
              offset = _ref.offset,
              limit = _ref.limit;

          return '/ecred/v1/notifications?offset=' + offset + '&limit=' + limit;
        }, // GET
        unread: '/ecred/v1/notifications/count', // GET
        read: function read(notificationId) {
          return '/ecred/v1/notifications/' + notificationId;
        } // PUT
      }
    },
    environments: {
      development: {
        host: 'https://serasa.dev',
        api: 'https://api-auth.serasa.dev/v1',
        ecred: {
          api: 'https://apigw-ecred-hml.ecsbr.net',
          apiKey: '8ifkjacsEu4AwRC9dPPJBwLqxi4dFGbg'
        }
      },
      homologation: {
        host: 'https://serasa.dev',
        api: 'https://api-auth.serasa.dev/v1',
        apiKey: 'KLZAVgYVU58DfvpbCUeTd1ojj3CIVkn4awJJyrRa',
        ecred: {
          api: 'https://apigw-ecred-hml.ecsbr.net',
          apiKey: '8ifkjacsEu4AwRC9dPPJBwLqxi4dFGbg'
        }
      },
      production: {
        host: 'https://www.serasa.com.br',
        api: 'https://api-auth.serasa.com.br/v1',
        apiKey: 'LFGO3deJs38Pr0n5DLFVL52YNcl2vUjV6aXFTe0j',
        ecred: {
          api: 'https://apigw-ecred-prd.ecsbr.net',
          apiKey: '8ifkjacsEu4AwRC9dPPJBwLqxi4dFGbg'
        }
      }
    }
  }
};

function createReducerStore(state, reducer) {
  var store = (0, _unistore2.default)(state);

  // our reducer is actually an action (they're the same thing!):
  var reduce = store.action(reducer);

  // replacing store.action lets us change how connect() works:
  store.action = function (fn) {
    return function () {
      var action = fn.apply(undefined, arguments);
      if (action && action.then) {
        return action.then(reduce);
      }
      return reduce(action || { type: _types.NOOP });
    };
  };

  // creating store.actions allows passing an object of actions
  store.actions = function (actions) {
    return (0, _entries2.default)(actions).reduce(function (acc, cur) {
      acc[cur[0]] = store.action(cur[1]);
      return acc;
    }, {});
  };

  store.dispatch = function (args) {
    return reduce(args);
  };

  return store;
}

var store = createReducerStore(initialState, _reducer2.default);

exports.default = store;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(34)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRenderer__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineRules__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enhance__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRenderer", function() { return __WEBPACK_IMPORTED_MODULE_0__createRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineRules", function() { return __WEBPACK_IMPORTED_MODULE_1__combineRules__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "enhance", function() { return __WEBPACK_IMPORTED_MODULE_2__enhance__["a"]; });






/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return THEME_CHANNEL; });
var THEME_CHANNEL = '_FELA_THEME_';

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_bindings__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_fela_bindings__["h" /* withThemeFactory */])(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"], __WEBPACK_IMPORTED_MODULE_0_preact__["h"]));

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var ChevronIcon = function ChevronIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      placement = _ref.placement,
      className = _ref.className;

  var rotate = placement === 'bottom' ? '0' : placement === 'top' ? '0' : placement === 'left' ? '-90' : '0';
  return (0, _preact.h)(
    'svg',
    {
      'aria-hidden': true,
      xmlns: 'http://www.w3.org/2000/svg',
      width: width,
      height: height,
      viewBox: '0 0 11 7',
      transform: 'rotate(' + rotate + ')',
      className: className
    },
    (0, _preact.h)('path', { fill: color, 'fill-rule': 'evenodd', d: 'M9.743.793l.707.707L5.5 6.45.55 1.5l.707-.707L5.5 5.036 9.743.793z' })
  );
};

ChevronIcon.defaultProps = {
  width: 11,
  height: 7,
  color: 'currentColor',
  placement: 'bottom'
};

exports.default = ChevronIcon;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.deleteCookie = deleteCookie;
exports.isSafari = isSafari;
exports.parseJSON = parseJSON;
function isServer() {
  return typeof window === 'undefined';
}

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

function setCookie(cname, cvalue, exdays, cdomain) {
  var now = new Date();
  now.setTime(now.getTime() + exdays * 24 * 60 * 60e3);
  var expires = 'expires=' + now.toUTCString();
  var domain = cdomain ? 'domain=' + cdomain + ';' : '';
  var secure = domain ? 'secure;' : '';
  document.cookie = cname + '=' + cvalue + ';' + domain + secure + expires + ';path=/';
}

function deleteCookie(cname, cdomain) {
  setCookie(cname, null, -1, cdomain);
}

function isSafari() {
  return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
}

function parseJSON(json) {
  try {
    return json !== '' ? JSON.parse(json) : '';
  } catch (error) {
    return json;
  }
}

var setSessionStorage = exports.setSessionStorage = function setSessionStorage(key, value) {
  try {
    var valueParsed = value;
    if (typeof value !== 'string') {
      valueParsed = JSON.stringify(value);
    }

    window.sessionStorage.setItem(key, valueParsed);
  } catch (error) {
    throw new Error('Não foi possível escrever em sessionStorage');
  }
};

var getSessionStorage = exports.getSessionStorage = function getSessionStorage(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {
    throw new Error('Não foi possível ler item em sessionStorage');
  }
};

var deleteSessionStorage = exports.deleteSessionStorage = function deleteSessionStorage(key) {
  try {
    window.sessionStorage.removeItem(key);
  } catch (error) {
    throw new Error('Não foi possível remover o item em sessionStorage');
  }
};

var getDomain = exports.getDomain = function getDomain(host) {
  if (isServer()) {
    return null;
  }

  host = host || document.domain;

  var firstTLDs = ['dev', 'br'];
  var secondTLDs = ['com'];

  var domain = host.replace(/^www\./, '');

  var parts = domain.split('.');

  while (parts.length > 3) {
    parts.shift();
  }

  if (parts.length === 3 && (parts[1].length > 2 && parts[2].length > 2 || secondTLDs.indexOf(parts[1]) === -1 && firstTLDs.indexOf(parts[2]) === -1)) {
    parts.shift();
  }

  return parts.join('.');
};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(87);
var defined = __webpack_require__(89);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT = exports.INIT = 'INIT';
var RESET = exports.RESET = 'RESET';
var CONFIG = exports.CONFIG = 'CONFIG';
var MENUS = exports.MENUS = 'MENUS';
var BRAND = exports.BRAND = 'BRAND';
var GRADIENT = exports.GRADIENT = 'GRADIENT';
var PRODUCT = exports.PRODUCT = 'PRODUCT';
var LOGGED = exports.LOGGED = 'LOGGED';
var LOGOUT = exports.LOGOUT = 'LOGOUT';
var METRIC = exports.METRIC = 'METRIC';
var NOOP = exports.NOOP = 'NOOP';
var NOTIFICATION = exports.NOTIFICATION = 'NOTIFICATION';
var NOTIFICATIONS_SUCCESS = exports.NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS_SUCCESS';
var NOTIFICATIONS_ERROR = exports.NOTIFICATIONS_ERROR = 'NOTIFICATIONS_ERROR';
var NOTIFICATIONS_READ = exports.NOTIFICATIONS_READ = 'NOTIFICATIONS_READ';
var NOTIFICATIONS_UNREAD = exports.NOTIFICATIONS_UNREAD = 'NOTIFICATIONS_UNREAD';
var NOTIFICATIONS_LOADING = exports.NOTIFICATIONS_LOADING = 'NOTIFICATIONS_LOADING';
var SIGNUP = exports.SIGNUP = 'SIGNUP';

var TOGGLE_DROPDOWN = exports.TOGGLE_DROPDOWN = 'TOGGLE_DROPDOWN';

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _fela = __webpack_require__(16);

var _preactFela = __webpack_require__(1);

var _preact2 = __webpack_require__(7);

var _felaPluginNamedKeys = __webpack_require__(53);

var _felaPluginNamedKeys2 = _interopRequireDefault(_felaPluginNamedKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var namedKeysPlugin = (0, _felaPluginNamedKeys2.default)({
  desktop: '@media (min-width: 1023px)'
});

var renderer = exports.renderer = (0, _fela.createRenderer)({
  selectorPrefix: 'ecs_hl_',
  plugins: [namedKeysPlugin]
});

var Styled = function (_Component) {
  _inherits(Styled, _Component);

  function Styled() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Styled);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Styled.__proto__ || Object.getPrototypeOf(Styled)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      theme: {}
    }, _this.handleTheme = function () {
      var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.product;
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.config;

      _this.setState({
        theme: {
          key: product,
          full: config.full,
          background: config.background,
          backgroundInScroll: config.backgroundInScroll,
          color: config.color,
          gradient: (config.gradient || false).toString(),
          gradientColor: config.gradientColor,
          inverseColor: config.inverseColor
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Styled, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleTheme();

      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.type = 'text/css';
      style.appendChild(document.createTextNode('.ecs_hl_overflow{position:fixed;overflow:hidden;}'));
      head.appendChild(style);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.handleTheme(props.product, props.config);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var theme = this.state.theme;


      return (0, _preact.h)(
        _preactFela.Provider,
        { renderer: renderer },
        (0, _preact.h)(
          _preactFela.ThemeProvider,
          { theme: theme },
          children
        )
      );
    }
  }]);

  return Styled;
}(_preact.Component);

exports.default = (0, _preact2.connect)(function (_ref2) {
  var product = _ref2.product,
      config = _ref2.config;
  return {
    product: product,
    config: config
  };
})(Styled);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RULE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEYFRAME_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FONT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STATIC_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_TYPE; });
var RULE_TYPE = 'RULE';
var KEYFRAME_TYPE = 'KEYFRAME';
var FONT_TYPE = 'FONT';
var STATIC_TYPE = 'STATIC';
var CLEAR_TYPE = 'CLEAR';

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = cssifyObject;

var _cssifyDeclaration = __webpack_require__(37);

var _cssifyDeclaration2 = _interopRequireDefault(_cssifyDeclaration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function cssifyObject(style) {
  var css = '';

  for (var property in style) {
    var value = style[property];

    if (typeof value !== 'string' && typeof value !== 'number') {
      continue;
    } // prevents the semicolon after
    // the last rule declaration


    if (css) {
      css += ';';
    }

    css += (0, _cssifyDeclaration2["default"])(property, value);
  }

  return css;
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hoistStatics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var basicStatics = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var mergableStatics = ['contextTypes', 'defaultProps'];
var blockedStatics = {
  childContextTypes: true,
  propTypes: true,
  getDerivedStateFromProps: true
};

function hoistStatics(target, source) {
  if (typeof source === 'string') {
    return target;
  }

  var statics = Object.getOwnPropertyNames(source).filter(function (property) {
    return !basicStatics[property];
  });

  __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach___default()(statics, function (property) {
    if (!target.hasOwnProperty(property) && !blockedStatics[property]) {
      try {
        // Avoid failures from read-only properties
        var descriptor = Object.getOwnPropertyDescriptor(source, property);
        Object.defineProperty(target, property, descriptor);
      } catch (e) {}
    }
  });

  __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach___default()(mergableStatics, function (property) {
    if (source[property]) {
      var targetStatics = target[property] || {};

      target[property] = _extends({}, source[property], targetStatics);
    }
  });

  return target;
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var ArrowIcon = function ArrowIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      className = _ref.className;
  return (0, _preact.h)(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 17 11", className: className },
    (0, _preact.h)("path", { fill: color, "fill-rule": "nonzero", d: "M.43 5.597a.5.5 0 0 1 .5-.5h13.998l-3.68-3.674a.497.497 0 0 1 0-.707.5.5 0 0 1 .707 0l4.54 4.531a.5.5 0 0 1-.098.784.506.506 0 0 1-.077.1l-4.365 4.363a.5.5 0 1 1-.707-.707l3.69-3.69H.93a.5.5 0 0 1-.5-.5z" })
  );
};

ArrowIcon.defaultProps = {
  width: 17,
  height: 11,
  color: '#ffffff'
};

exports.default = ArrowIcon;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

exports.default = function (props) {
  var name = props && props.name ? props.name.toString().split(' ')[0] : '';
  var prefix = props.prefix === undefined || props.prefix === true ? 'Olá, ' : '';

  return '' + prefix + name;
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _booster = __webpack_require__(65);

var _booster2 = _interopRequireDefault(_booster);

var _config = __webpack_require__(33);

var _utils = __webpack_require__(20);

var _request = __webpack_require__(70);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CONFIG = null;

var Bifrost = function () {
  function Bifrost() {
    _classCallCheck(this, Bifrost);
  }

  _createClass(Bifrost, null, [{
    key: 'initialize',
    value: function initialize(config) {
      CONFIG = (0, _config.setConfig)(config);
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      return _extends({}, CONFIG);
    }
  }, {
    key: 'getValgrindAI',
    value: function getValgrindAI() {
      return (0, _utils.getCookie)(CONFIG.cookie.key.ai);
    }
  }, {
    key: 'setValgrindAI',
    value: function setValgrindAI() {
      (0, _utils.setCookie)(CONFIG.cookie.key.ai, Boolean(true).toString(), 1, CONFIG.cookie.domain);
    }
  }, {
    key: 'setValgrind',
    value: function setValgrind(session) {
      (0, _utils.setCookie)(CONFIG.cookie.key.ai, Boolean(true).toString(), 1, CONFIG.cookie.domain);
      (0, _utils.setCookie)(CONFIG.cookie.key.au, session.token, 1, CONFIG.cookie.domain);

      _booster2.default.emit('BOOSTER_USER', session);
    }
  }, {
    key: 'deleteValgrind',
    value: function deleteValgrind() {
      (0, _utils.deleteCookie)(CONFIG.cookie.key.ai, CONFIG.cookie.domain);
      (0, _utils.deleteCookie)(CONFIG.cookie.key.au, CONFIG.cookie.domain);
    }
  }, {
    key: 'getCpfValgrind',
    value: function getCpfValgrind() {
      return (0, _utils.getSessionStorage)('valgrind-userCpf');
    }
  }, {
    key: 'setCpfValgrind',
    value: function setCpfValgrind(cpf) {
      (0, _utils.setSessionStorage)('valgrind-userCpf', cpf);
    }
  }, {
    key: 'session',
    value: function session(callback) {
      var ok = function ok(response) {
        _booster2.default.emit('BOOSTER_USER', response);

        callback(null, response);
      };

      var authenticated = Bifrost.getValgrindAI();

      if (CONFIG.cookie.check && authenticated !== 'true') {
        callback(true, { status: 1 });
        return;
      }

      (0, _request2.default)('/session', null, function (err, req) {
        if (err) {
          if (req.status === 401 || req.status === 419) {
            Bifrost.deleteValgrind();
          }

          _booster2.default.emit('BOOSTER_GA', {
            category: 'exception',
            action: 'sessao',
            label: req.status
          });

          callback(err, req);
        } else {
          ok(req.response);
        }
      });
    }
  }, {
    key: 'sessionify',
    value: function sessionify() {
      return new Promise(function (resolve, reject) {
        Bifrost.session(function (err, req) {
          if (err) {
            reject(req);
            return;
          }

          resolve(req);
        });
      });
    }
  }, {
    key: 'logout',
    value: function logout(token, callback) {
      Bifrost.deleteValgrind();

      (0, _request2.default)('/user/logout', { token: token }, function (error, response) {
        callback(error, response);
      });
    }
  }]);

  return Bifrost;
}();

exports.default = Bifrost;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setConfig = setConfig;
exports.getConfig = getConfig;

var _utils = __webpack_require__(20);

var COOKIE = {
  check: true,
  key: {
    ai: 'Valgrind-AI',
    au: 'Valgrind-AU'
  },
  domain: null
};

var ENVIRONMENTS = {
  mock: {
    host: function host() {
      return 'http://localhost:5000';
    },
    apiKey: null,
    cookie: {
      check: false
    }
  },
  development: {
    host: function host(domain) {
      if (domain === 'serasaconsumidor.com.br') {
        return 'https://apigw-portal-hml.ecsbr.net/v1';
      }

      return 'https://api-auth.serasa.dev/v1';
    },
    apiKey: 'KLZAVgYVU58DfvpbCUeTd1ojj3CIVkn4awJJyrRa',
    cookie: {
      check: false,
      domain: null
    }
  },
  homologation: {
    host: function host(domain) {
      if (domain === 'serasaconsumidor.com.br') {
        return 'https://apigw-portal-hml.ecsbr.net/v1';
      }

      return 'https://api-auth.serasa.dev/v1';
    },
    apiKey: 'KLZAVgYVU58DfvpbCUeTd1ojj3CIVkn4awJJyrRa'
  },
  production: {
    host: function host(domain) {
      if (domain === 'serasaconsumidor.com.br') {
        return 'https://apigw-portal-prd.ecsbr.net/v1';
      }

      return 'https://api-auth.serasa.com.br/v1';
    },
    apiKey: 'LFGO3deJs38Pr0n5DLFVL52YNcl2vUjV6aXFTe0j'
  }
};

var config = null;

function setConfig() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$environment = _ref.environment,
      environment = _ref$environment === undefined ? 'development' : _ref$environment,
      applicationId = _ref.applicationId,
      host = _ref.host,
      domain = _ref.domain;

  config = _extends({}, ENVIRONMENTS[environment]);
  config.environment = environment;
  config.domain = (0, _utils.getDomain)(domain);
  config.host = host || config.host(config.domain);
  config.applicationId = applicationId || undefined;
  config.cookie = _extends({}, COOKIE, {
    domain: config.domain
  }, config.cookie || {});

  return config;
}

function getConfig() {
  return config;
}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = cssifyDeclaration;

var _hyphenateProperty = __webpack_require__(103);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function cssifyDeclaration(property, value) {
  return (0, _hyphenateProperty2["default"])(property) + ':' + value;
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyKeysInOrder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);


function applyKeysInOrder(order) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(order, function (mediaMap, query) {
    mediaMap[query] = initialValue;
    return mediaMap;
  }, {});
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateCSSRule;
function generateCSSRule(selector, cssDeclaration) {
  return selector + "{" + cssDeclaration + "}";
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRuleScore;
function getRuleScore() {
  var ruleOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var pseudo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (ruleOrder.length === 0 || pseudo.length === 0) {
    return 0;
  }

  return ruleOrder.indexOf(ruleOrder.find(function (regex) {
    return pseudo.match(regex) !== null;
  })) + 1;
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateCSSSupportRule;
function generateCSSSupportRule(support, cssRules) {
  return "@supports " + support + "{" + cssRules + "}";
}

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFontUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isBase64__ = __webpack_require__(44);


function getFontUrl(src) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isBase64__["a" /* default */])(src)) {
    return src;
  }

  return '\'' + src + '\'';
}

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isBase64;
function isBase64(property) {
  return property.substr(0, 5) === 'data:';
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFontFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isBase64__ = __webpack_require__(44);


var formats = {
  '.woff': 'woff',
  '.woff2': 'woff2',
  '.eot': 'embedded-opentype',
  '.ttf': 'truetype',
  '.otf': 'opentype',
  '.svg': 'svg',
  '.svgz': 'svg'
};

var base64Formats = {
  'image/svg+xml': 'svg',
  'application/x-font-woff': 'woff',
  'application/font-woff': 'woff',
  'application/x-font-woff2': 'woff2',
  'application/font-woff2': 'woff2',
  'font/woff2': 'woff2',
  'application/octet-stream': 'truetype',
  'application/x-font-ttf': 'truetype',
  'application/x-font-truetype': 'truetype',
  'application/x-font-opentype': 'opentype',
  'application/vnd.ms-fontobject': 'embedded-opentype',
  'application/font-sfnt': 'sfnt'
};

function getFontFormat(src) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isBase64__["a" /* default */])(src)) {
    var mime = '';
    for (var i = 5;; i++) {
      // 'data:'.length === 5
      var c = src.charAt(i);

      if (c === ';' || c === ',') {
        break;
      }

      mime += c;
    }

    var fmt = base64Formats[mime];
    if (fmt) {
      return fmt;
    }

    console.warn('A invalid base64 font was used. Please use one of the following mime type: ' + Object.keys(base64Formats).join(', ') + '.');
  } else {
    var extension = '';
    for (var _i = src.length - 1;; _i--) {
      var _c = src.charAt(_i);

      if (_c === '.') {
        extension = _c + extension;
        break;
      }

      extension = _c + extension;
    }

    var _fmt = formats[extension];
    if (_fmt) {
      return _fmt;
    }

    console.warn('A invalid font-format was used in "' + src + '". Use one of these: ' + Object.keys(formats).join(', ') + '.');
  }
  return '';
}

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderToString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cssifyMediaQueryRules__ = __webpack_require__(142);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function renderToString(renderer) {
  var _clusterCache = Object(__WEBPACK_IMPORTED_MODULE_1_fela_utils__["f" /* clusterCache */])(renderer.cache, renderer.mediaQueryOrder, renderer.supportQueryOrder, renderer.ruleOrder),
      fontFaces = _clusterCache.fontFaces,
      statics = _clusterCache.statics,
      keyframes = _clusterCache.keyframes,
      rules = _clusterCache.rules,
      mediaRules = _clusterCache.mediaRules,
      supportRules = _clusterCache.supportRules,
      supportMediaRules = _clusterCache.supportMediaRules;

  var basicCSS = fontFaces + statics + keyframes + rules + Object(__WEBPACK_IMPORTED_MODULE_1_fela_utils__["g" /* cssifySupportRules */])(supportRules);

  var mediaKeys = Object.keys(_extends({}, supportMediaRules, mediaRules));

  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(mediaKeys, function (css, query) {
    var mediaCSS = mediaRules[query] || '';
    var supportCSS = Object(__WEBPACK_IMPORTED_MODULE_1_fela_utils__["g" /* cssifySupportRules */])(supportMediaRules[query] || {});

    return css + Object(__WEBPACK_IMPORTED_MODULE_2__cssifyMediaQueryRules__["a" /* default */])(query, mediaCSS + supportCSS);
  }, basicCSS);
}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDOMNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createDOMNode__ = __webpack_require__(159);


function getDOMNode(nodes, baseNode, type) {
  var media = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var support = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var key = type + media + (support ? 'support' : '');

  if (!nodes.hasOwnProperty(key)) {
    nodes[key] = Object(__WEBPACK_IMPORTED_MODULE_0__createDOMNode__["a" /* default */])(type, baseNode, media, support);
  }

  return nodes[key];
}

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rehydrateRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fela_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCacheEntry__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generateDeclarationReference__ = __webpack_require__(168);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






var DECL_REGEX = /[.]([0-9a-z_-]+)([^{]+)?{([^:]+):([^}]+)}/gi;

function rehydrateRules(css) {
  var media = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var support = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var cache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var decl = void 0;

  // This excellent parsing implementation was originally taken from Styletron and modified to fit Fela
  // https://github.com/rtsao/styletron/blob/master/packages/styletron-client/src/index.js#L47
  /* eslint-disable no-unused-vars,no-cond-assign */
  while (decl = DECL_REGEX.exec(css)) {
    // $FlowFixMe
    var _decl = decl,
        _decl2 = _slicedToArray(_decl, 5),
        ruleSet = _decl2[0],
        className = _decl2[1],
        pseudo = _decl2[2],
        property = _decl2[3],
        value = _decl2[4];
    /* eslint-enable */

    var declarationReference = Object(__WEBPACK_IMPORTED_MODULE_2__generateDeclarationReference__["a" /* default */])(property, value, pseudo, media, support);

    cache[declarationReference] = Object(__WEBPACK_IMPORTED_MODULE_1__generateCacheEntry__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_fela_utils__["d" /* RULE_TYPE */], className, property, value, pseudo, media, support);
  }

  return cache;
}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRehydrationIndex;


var SELECTOR_PREFIX_REGEXP = /^[a-z0-9_-]*$/gi;


function getRehydrationIndex(renderer) {
  if (renderer.selectorPrefix.length === 0 || renderer.selectorPrefix.match(SELECTOR_PREFIX_REGEXP) !== null) {
    return renderer.uniqueRuleIdentifier;
  }

  return -1;
}

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function createTheme() {
  var themeProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var previousTheme = arguments[1];

  var theme = {
    listeners: [],
    properties: themeProperties,

    update: function update(newProperties) {
      theme.properties = newProperties;
      theme._emitChange();
    },
    get: function get() {
      return _extends({}, theme.previousProperties, theme.properties);
    },
    subscribe: function subscribe(listener) {
      theme.listeners.push(listener);

      return function () {
        return theme.listeners.splice(theme.listeners.indexOf(listener), 1);
      };
    },
    _emitChange: function _emitChange() {
      var properties = theme.get();

      __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach___default()(theme.listeners, function (listener) {
        return listener(properties);
      });
    }
  };

  if (previousTheme) {
    theme.previousProperties = previousTheme.get();
    previousTheme.subscribe(function (properties) {
      theme.previousProperties = properties;
      theme._emitChange();
    });
  } else {
    theme.previousProperties = {};
  }

  return theme;
}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_bindings__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FelaTheme__ = __webpack_require__(52);





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_fela_bindings__["a" /* FelaComponentFactory */])(__WEBPACK_IMPORTED_MODULE_0_preact__["h"], __WEBPACK_IMPORTED_MODULE_2__FelaTheme__["a" /* default */]));

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_bindings__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_fela_bindings__["b" /* FelaThemeFactory */])(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]));

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = namedMediaQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isobject__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isobject__);


function resolveNamedMediaQuery(style, mediaQueryMap) {
  for (var property in style) {
    var value = style[property];

    if (__WEBPACK_IMPORTED_MODULE_0_isobject___default()(value)) {
      var resolvedValue = resolveNamedMediaQuery(value, mediaQueryMap);

      if (mediaQueryMap.hasOwnProperty(property)) {
        style[mediaQueryMap[property]] = resolvedValue;
        delete style[property];
      }
    }
  }

  return style;
}

function namedMediaQuery(mediaQueryMap) {
  return function (style) {
    return resolveNamedMediaQuery(style, mediaQueryMap);
  };
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _Core = __webpack_require__(10);

var _NavbarListLink = __webpack_require__(192);

var _NavbarListLink2 = _interopRequireDefault(_NavbarListLink);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var rules = function rules(_ref) {
  var inScroll = _ref.inScroll;
  return {
    nav: {
      width: '100%',
      borderTop: '1px solid #e0e0e0',
      desktop: _extends({
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'stretch',
        left: 0
      }, inScroll ? {
        width: 'auto',
        position: 'relative',
        top: 0,
        borderTop: 'none'
      } : {
        position: 'absolute',
        top: '100%',
        borderTopColor: 'rgba(255, 255, 255, 0.3)'
      })
    }
  };
};

var linksStyle = function linksStyle() {
  return {
    margin: '0 0 20px',
    position: 'relative',
    desktop: {
      flex: 1,
      margin: 0
    }
  };
};

var Links = (0, _preactFela.createComponent)(linksStyle);

var extend = {
  dropdownContent: {
    desktop: {
      left: '0',
      transform: 'none'
    }
  }
};

var NavbarList = function (_Component) {
  _inherits(NavbarList, _Component);

  function NavbarList() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, NavbarList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = NavbarList.__proto__ || Object.getPrototypeOf(NavbarList)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      open: {}
    }, _this.handleClickLink = function (event, menu) {
      _this.props.goMenu(event, menu);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavbarList, [{
    key: 'handleToggle',
    value: function handleToggle(index) {
      this.setState(function (state) {
        var open = state.open;

        open[index] = !(open[index] || false);
        return _extends({}, state, { open: open });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          inScroll = _props.inScroll,
          mobile = _props.mobile,
          menus = _props.menus,
          config = _props.config,
          styles = _props.styles,
          _props$clicktype = _props.clicktype,
          clicktype = _props$clicktype === undefined ? 'menu-lateral' : _props$clicktype,
          _props$login = _props.login,
          login = _props$login === undefined ? {} : _props$login,
          _props$signUp = _props.signUp,
          signUp = _props$signUp === undefined ? {} : _props$signUp;

      var isLoginAndSignUpDisabled = login.disabledInNavbar && signUp.disabledInNavbar;

      if (menus.length === 0) {
        return null;
      }

      var showDivider = !mobile && inScroll && !isLoginAndSignUpDisabled;

      return (0, _preact.h)(
        'nav',
        { className: styles.nav },
        menus.map(function (menu, index) {
          if (menu.items) {
            if (_this2.state.open[index] === undefined) {
              _this2.state.open[index] = false;
            }
            return (0, _preact.h)(
              _Core.Dropdown,
              { styleExtend: extend, open: _this2.state.open[index], toggle: function toggle() {
                  return _this2.handleToggle(index);
                }, key: 'dl' + (mobile && '-m') + (inScroll && '-s') + '-' + index, label: menu.label, inside: mobile, inScroll: inScroll, mobile: mobile, config: config, gtm: (0, _utils.getAttrsGtm)(menu.label, { clicktype: clicktype }) },
              (0, _preact.h)(
                Links,
                null,
                menu.items.map(function (item) {
                  return (0, _preact.h)(_NavbarListLink2.default, { mobile: mobile, menu: item, isSubmenu: true, config: config, handleClick: _this2.handleClickLink, clicktype: 'submenu' });
                })
              )
            );
          }

          return (0, _preact.h)(_NavbarListLink2.default, { mobile: mobile, menu: menu, config: config, handleClick: _this2.handleClickLink, clicktype: clicktype });
        }),
        showDivider && (0, _preact.h)(_Core.Dividir, null)
      );
    }
  }]);

  return NavbarList;
}(_preact.Component);

exports.default = (0, _preactFela.connect)(rules)(NavbarList);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var rule = function rule() {
  return {
    height: '24px',
    width: '1px',
    background: 'rgba(255,255,255,0.3)',
    display: 'inline-block'
  };
};

exports.default = (0, _preactFela.createComponent)(rule, 'span');

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var linkStyle = function linkStyle() {
  return {
    fontWeight: 'normal',
    lineHeight: 'normal',
    cursor: 'pointer',
    outline: 'none',
    textDecoration: 'none',
    boxSizing: 'border-box'
  };
};

exports.default = (0, _preactFela.createComponentWithProxy)(linkStyle, 'a');

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preactFela = __webpack_require__(1);

var wrapperStyles = function wrapperStyles(_ref) {
  var inside = _ref.inside;
  return {
    display: 'flex',
    height: '100%',
    width: inside ? '100%' : 'auto',
    flexDirection: 'column',
    borderBottom: inside ? '1px solid #e0e0e0' : null,
    desktop: {
      position: 'relative',
      margin: '0',
      width: 'auto',
      flexDirection: 'row',
      borderBottom: 'none'
    }
  };
};

exports.default = (0, _preactFela.createComponent)(wrapperStyles);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preactFela = __webpack_require__(1);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dropdownButton = function dropdownButton(_ref) {
  var open = _ref.open,
      color = _ref.color,
      inside = _ref.inside;
  return {
    width: '100%',
    height: '55px',
    padding: '0 16px',
    borderWidth: '2px 0',
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: '0',
    position: 'relative',
    justifyContent: 'flex-start',
    textTransform: 'none',
    fontSize: '14px',
    transition: 'color, background-color, border-bottom-color, opacity 0.2s ease-in-out',
    willChange: 'color, background-color, border-bottom-color, opacity',
    color: open && !inside ? color : inside ? '#666' : '#ffffff',
    borderBottomColor: open && !inside ? color : null,
    opacity: !open ? '1' : null,
    ':hover': {
      opacity: !open ? '0.75' : null,
      color: open && inside ? '#999' : null
    },
    desktop: {
      height: '100%',
      alignSelf: 'stretch',
      padding: '9px 10px 10px'
    }
  };
};

exports.default = (0, _preactFela.createComponentWithProxy)(dropdownButton, _Button2.default);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preactFela = __webpack_require__(1);

var _ChevronIcon = __webpack_require__(19);

var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dropdownButtonIcon = function dropdownButtonIcon(_ref) {
  var open = _ref.open,
      inside = _ref.inside,
      color = _ref.color;
  return {
    color: inside ? color : 'currentColor',
    marginLeft: inside ? 'auto' : '8px',
    transition: 'transform 0.2s ease-in-out',
    transform: open ? 'rotate(-180deg)' : null
  };
};

exports.default = (0, _preactFela.createComponent)(dropdownButtonIcon, _ChevronIcon2.default);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _actions = __webpack_require__(6);

var _Core = __webpack_require__(10);

var _Logo = __webpack_require__(193);

var _Logo2 = _interopRequireDefault(_Logo);

var _ChevronIcon = __webpack_require__(19);

var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var wrapperStyle = function wrapperStyle() {
  return {
    desktop: {
      display: 'flex',
      alignItems: 'center',
      height: '100%'
    }
  };
};

var pagesStyle = function pagesStyle() {
  return {
    margin: '4px 0 40px',
    position: 'relative',
    ':after': {
      content: '""',
      width: 'calc(100% - 44px)',
      height: '1px',
      left: '22px',
      bottom: '-20px',
      backgroundColor: '#e0e0e0',
      position: 'absolute'
    },
    desktop: {
      flex: 1,
      margin: 0,
      ':after': {
        width: '1px',
        height: '100%',
        top: '0',
        left: 'auto',
        right: '0'
      }
    }
  };
};

var productsStyle = function productsStyle() {
  return {
    margin: '12px 8px'
  };
};

var productNameStyle = function productNameStyle() {
  return {
    display: 'block',
    padding: '0 16px',
    margin: '0 0 6px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#666'
  };
};

var productSquareStyle = function productSquareStyle() {
  return {
    width: '32px',
    height: '32px',
    marginRight: '16px'
  };
};

var pageIconStyle = function pageIconStyle() {
  return {
    marginRight: '8px'
  };
};

var linkStyle = function linkStyle() {
  return {
    display: 'flex',
    alignItems: 'center',
    marginTop: '5px',
    padding: '6px 16px',
    textDecoration: 'none',
    color: '#666',
    outline: 'none',
    fontSize: '14px',
    transition: 'opacity 0.2s ease-in-out',
    willChange: 'opacity',
    opacity: '1',
    ':hover': {
      color: '#666',
      opacity: '0.75',
      textDecoration: 'none'
    },
    desktop: {
      marginTop: '10px'
    }
  };
};

var extend = {
  wrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    margin: '32px 0 16px',
    borderRadius: '3px',
    border: 'solid 1px #e0e0e0',
    flexDirection: 'column',
    desktop: {
      height: '100%',
      width: 'auto',
      margin: '0',
      border: 'none',
      flexDirection: 'row'
    }
  },
  dropdownContent: {
    border: 'none',
    desktop: {
      width: '536px',
      padding: '32px 16px 32px'
    }
  }
};

var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);
var Pages = (0, _preactFela.createComponent)(pagesStyle);
var PageIcon = (0, _preactFela.createComponent)(pageIconStyle, _ChevronIcon2.default, ['color', 'placement']);
var Products = (0, _preactFela.createComponent)(productsStyle);
var ProductName = (0, _preactFela.createComponent)(productNameStyle, 'span');
var ProductSquare = (0, _preactFela.createComponent)(productSquareStyle, _Logo2.default, ['product', 'square']);
var Link = (0, _preactFela.createComponentWithProxy)(linkStyle, 'a');

var NavbarSerasaConsumidor = function (_Component) {
  _inherits(NavbarSerasaConsumidor, _Component);

  function NavbarSerasaConsumidor() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavbarSerasaConsumidor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavbarSerasaConsumidor.__proto__ || Object.getPrototypeOf(NavbarSerasaConsumidor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.toggle = function () {
      _this.setState({ open: !_this.state.open });
    }, _this.handleClickPage = function (event, label) {
      var proxy = _this.props.config.proxy;


      (0, _actions.analyticsEvent)('oque-precisa-' + label);

      if (proxy) {
        proxy(event, function () {
          return _this.setState({ open: false });
        });
      }
    }, _this.handleClickProduct = function (event) {
      var proxy = _this.props.config.proxy;


      if (proxy) {
        proxy(event, function () {
          return _this.setState({ open: false });
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavbarSerasaConsumidor, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.inScroll !== prevProps.inScroll) {
        this.setState({ open: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mobile = _props.mobile,
          inScroll = _props.inScroll,
          hasMenus = _props.hasMenus,
          config = _props.config,
          heimdall = _props.heimdall,
          _props$login = _props.login,
          login = _props$login === undefined ? {} : _props$login,
          _props$signUp = _props.signUp,
          signUp = _props$signUp === undefined ? {} : _props$signUp;
      var pages = heimdall.pages,
          products = heimdall.products;


      if (!mobile && inScroll && hasMenus) {
        return null;
      }

      var isLoginAndSignUpDisabled = login.disabledInNavbar && signUp.disabledInNavbar;

      var firstDivider = !mobile && !isLoginAndSignUpDisabled && (0, _preact.h)(_Core.Dividir, null);
      var lastDivider = !mobile && !isLoginAndSignUpDisabled && (0, _preact.h)(_Core.Dividir, null);

      return (0, _preact.h)(
        Wrapper,
        null,
        firstDivider,
        (0, _preact.h)(
          _Core.Dropdown,
          { label: 'O que voc\xEA precisa?', mobile: mobile, config: config, styleExtend: extend, inside: mobile, open: this.state.open, toggle: this.toggle, gtm: (0, _utils.getAttrsGtm)("O que você precisa?", { clicktype: 'menu' }) },
          (0, _preact.h)(
            Pages,
            null,
            pages.map(function (_ref2) {
              var label = _ref2.label,
                  id = _ref2.id,
                  url = _ref2.url;
              return (0, _preact.h)(
                Link,
                _extends({ key: id, href: url, onClick: function onClick(event) {
                    return _this2.handleClickPage(event, label);
                  }, title: label }, (0, _utils.getAttrsGtm)(label, { clicktype: 'submenu' })),
                [(0, _preact.h)(PageIcon, { color: '#666', placement: 'left' }), label]
              );
            })
          ),
          (0, _preact.h)(
            Products,
            null,
            !mobile && (0, _preact.h)(
              ProductName,
              null,
              'Produtos'
            ),
            products.map(function (product) {
              return (0, _preact.h)(
                Link,
                _extends({ key: product.key, href: product.url, title: product.name, onClick: _this2.handleClickProduct }, (0, _utils.getAttrsGtm)(product.name, { clicktype: 'submenu' })),
                [(0, _preact.h)(ProductSquare, { product: product.key, square: true }), product.name]
              );
            })
          )
        ),
        lastDivider
      );
    }
  }]);

  return NavbarSerasaConsumidor;
}(_preact.Component);

exports.default = NavbarSerasaConsumidor;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _constants = __webpack_require__(9);

var _Core = __webpack_require__(10);

var _ArrowIcon = __webpack_require__(30);

var _ArrowIcon2 = _interopRequireDefault(_ArrowIcon);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var titleStyle = function titleStyle(_ref) {
  var collapsed = _ref.collapsed,
      showMore = _ref.showMore;
  return {
    display: 'block',
    fontSize: '18px',
    color: '#666',
    paddingLeft: '16px',
    margin: collapsed && !showMore ? '0 0 1rem' : '1rem 0'
  };
};

var Title = (0, _preactFela.createComponent)(titleStyle);

var notificationListStyle = function notificationListStyle(_ref2) {
  var mobile = _ref2.mobile,
      loading = _ref2.loading,
      collapsed = _ref2.collapsed,
      showMore = _ref2.showMore;
  return _extends({
    position: 'relative',
    width: !mobile ? '304px' : '100%',
    boxSizing: 'border-box',
    background: '#ffffff',
    overflowX: 'hidden',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch'
  }, collapsed && showMore && {
    position: 'absolute',
    top: '0',
    left: '0',
    height: '100%'
  }, loading && {
    '> *': {
      opacity: 0.5,
      pointerEvents: 'none'
    }
  }, {
    desktop: {
      maxHeight: '250px',
      /**  STYLE ScrollBar */
      '&::-webkit-scrollbar': {
        width: '7px',
        backgroundColor: '#f4f4f4'
      },
      '&::-webkit-scrollbar-track:active': {
        background: '#ffffff',
        border: '1px solid transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '10px',
        background: 'rgba(0,0,0,0.4)'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#888'
      },
      '&::-webkit-scrollbar-thumb:active': {
        background: '#999'
      }
    }
  });
};

var NotificationList = (0, _preactFela.createComponent)(notificationListStyle);

var notificationItemStyle = function notificationItemStyle(_ref3) {
  var isRead = _ref3.isRead;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    padding: '16px',
    cursor: 'pointer',
    background: isRead ? '#ffffff' : '#f4f4f4',
    borderTop: '2px solid ' + (!isRead ? '#ffffff' : '#f4f4f4'),
    boxSizing: 'border-box',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none'
    }
  };
};

var NotificationItem = (0, _preactFela.createComponentWithProxy)(notificationItemStyle, 'a');

var buttonBackStyle = function buttonBackStyle(_ref4) {
  var showMore = _ref4.showMore;
  return {
    display: showMore ? 'block' : 'none',
    fontSize: '12px',
    margin: '0.5rem 0 0'
  };
};

var ButtonBack = (0, _preactFela.createComponentWithProxy)(buttonBackStyle, _Core.Button);

var buttonShowMoreStyle = function buttonShowMoreStyle(_ref5) {
  var showMore = _ref5.showMore;
  return {
    display: showMore ? 'none' : 'block',
    fontSize: '12px',
    margin: '0.5rem auto'
  };
};

var ButtonShowMore = (0, _preactFela.createComponentWithProxy)(buttonShowMoreStyle, _Core.Button);

var rules = function rules() {
  return {
    itemBrand: {
      width: '16px',
      height: '16px'
    },
    itemContent: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      fontSize: '12px',
      color: '#949799',
      marginBottom: '8px'
    },
    itemTitle: {
      flex: '1 1 100%',
      marginRight: 'auto',
      padding: '0 8px'
    },
    itemDate: {
      whiteSpace: 'nowrap'
    },
    itemDescription: {
      fontSize: '14px',
      color: '#666'
    },
    noResult: {
      fontSize: '12px',
      color: '#949799',
      padding: '0 16px 16px'
    },
    iconBack: {
      transform: 'rotateY(180deg)'
    }
  };
};

var HeaderNotificationContent = function (_Component) {
  _inherits(HeaderNotificationContent, _Component);

  function HeaderNotificationContent(props) {
    _classCallCheck(this, HeaderNotificationContent);

    var _this = _possibleConstructorReturn(this, (HeaderNotificationContent.__proto__ || Object.getPrototypeOf(HeaderNotificationContent)).call(this, props));

    _this.setList = function (el) {
      if (el) {
        _this.list = el;
      }
    };

    _this.handleScroll = function () {
      if (!_this.props.notification.loading && _this.list.offsetHeight + _this.list.scrollTop + 10 >= _this.list.scrollHeight) {
        _this.state.offset = _this.props.notification.list.length;
        _this.props.notifications(_this.props.notification.list.length);
      }
    };

    _this.handleToggleShowMore = function () {
      _this.setState(function (state) {
        return { showMore: !state.showMore };
      }, function () {
        return _this.state.showMore && _this.handleScroll();
      });
    };

    _this.handleMarkRead = function (event, _ref6, index) {
      var url = _ref6.url,
          notificationId = _ref6.notificationId;

      event.preventDefault();
      _this.props.readNotifications(notificationId, url, index);
    };

    _this.setState({
      open: false,
      offset: _this.props.notification.list.length,
      showMore: false
    });
    return _this;
  }

  _createClass(HeaderNotificationContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.notification.list.length) {
        this.props.notifications(this.props.notification.list.length);
      }
      this.list.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          notification = _props.notification,
          styles = _props.styles,
          inScroll = _props.inScroll,
          mobile = _props.mobile,
          collapsed = _props.collapsed,
          config = _props.config;
      var showMore = this.state.showMore;

      var list = collapsed && !showMore ? notification.list.slice(0, 2) : notification.list;

      return (0, _preact.h)(
        NotificationList,
        {
          mobile: mobile,
          collapsed: collapsed,
          showMore: showMore,
          loading: notification.loading,
          innerRef: this.setList
        },
        collapsed && notification.list.length > 2 && (0, _preact.h)(
          ButtonBack,
          _extends({
            onClick: this.handleToggleShowMore,
            showMore: showMore,
            color: config.color
          }, (0, _utils.getAttrsGtm)('Voltar', { clicktype: 'menu' })),
          (0, _preact.h)(_ArrowIcon2.default, { color: config.color, className: styles.iconBack }),
          ' ',
          'Voltar'
        ),
        (0, _preact.h)(
          Title,
          { collapsed: collapsed, showMore: showMore },
          'Notifica\xE7\xF5es'
        ),
        (notification.loading && list.length === 0 || list.length === 0) && (0, _preact.h)(
          'p',
          { className: styles.noResult },
          notification.loading ? 'Carregando...' : 'Não há notificações no momento'
        ),
        (!notification.loading || list.length > 0) && list.map(function (notification, index) {
          return (0, _preact.h)(
            NotificationItem,
            _extends({
              href: notification.url,
              onClick: function onClick(event) {
                return _this2.handleMarkRead(event, notification, index);
              },
              isRead: notification.isRead,
              mobile: mobile
            }, (0, _utils.getAttrsGtm)(notification.description)),
            (0, _preact.h)(
              'span',
              { className: styles.itemContent },
              (0, _preact.h)('img', {
                src: _constants.PRODUCTS[notification.product].square,
                alt: _constants.PRODUCTS[notification.product].name,
                className: styles.itemBrand,
                inScroll: inScroll,
                mobile: mobile
              }),
              (0, _preact.h)(
                'span',
                { className: styles.itemTitle },
                notification.title || ''
              ),
              (0, _preact.h)(
                'span',
                { className: styles.itemDate },
                notification.date || ''
              )
            ),
            (0, _preact.h)(
              'span',
              { className: styles.itemDescription },
              notification.description
            )
          );
        }),
        collapsed && notification.list.length > 2 && (0, _preact.h)(
          ButtonShowMore,
          _extends({
            onClick: this.handleToggleShowMore,
            showMore: showMore,
            color: config.color
          }, (0, _utils.getAttrsGtm)('Ver mais', { clicktype: 'menu' })),
          'Ver mais'
        )
      );
    }
  }]);

  return HeaderNotificationContent;
}(_preact.Component);

exports.default = (0, _preactFela.connect)(rules)(HeaderNotificationContent);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _style = __webpack_require__(26);

var keyframeShow = function keyframeShow() {
  return {
    '0%': {
      transform: 'scale(0)'
    },
    '100%': {
      transform: 'scale(1)'
    }
  };
};

var rule = function rule(_ref) {
  var background = _ref.background,
      color = _ref.color,
      text = _ref.text;
  return {
    padding: !text ? '7px' : '2px 4px',
    background: background || 'red',
    fontSize: '10px',
    borderRadius: '8px',
    color: color || '#ffffff',
    display: 'inline-block',
    position: 'relative',
    top: '-10px',
    left: '-6px',
    margin: '0 -0.5rem',
    zIndex: 10,
    animationDuration: '0.6s',
    animationName: _style.renderer.renderKeyframe(keyframeShow)
  };
};

var Badge = (0, _preactFela.createComponentWithProxy)(rule, 'span');

exports.default = function (props) {
  return (0, _preact.h)(
    Badge,
    props,
    props.children
  );
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var UserIcon = function UserIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      className = _ref.className;
  return (0, _preact.h)(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 500 500", className: className },
    (0, _preact.h)("path", {
      fill: color,
      stroke: "white",
      "stroke-width": "0",
      d: "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm128 421.6c-35.9 26.5-80.1 42.4-128 42.4s-92.1-15.9-128-42.4V416c0-35.3 28.7-64 64-64 11.1 0 27.5 11.4 64 11.4 36.6 0 52.8-11.4 64-11.4 35.3 0 64 28.7 64 64v13.6zm30.6-27.5c-6.8-46.4-46.3-82.1-94.6-82.1-20.5 0-30.4 11.4-64 11.4S204.6 320 184 320c-48.3 0-87.8 35.7-94.6 82.1C53.9 363.6 32 312.4 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 56.4-21.9 107.6-57.4 146.1zM248 120c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 144c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
    })
  );
};

UserIcon.defaultProps = {
  width: 18,
  height: 19,
  color: 'currentColor'
};

exports.default = UserIcon;

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export analytic */
/* harmony export (immutable) */ __webpack_exports__["b"] = setCustomData;
function analytic(_ref,callback){var category=_ref.category,action=_ref.action,label=_ref.label,value=_ref.value;window.dataLayer.push({event:'event',category:category||'serasaecred',action:action,label:normalizeLabel(label),value:value,eventCallback:callback,eventTimeout:100});}function setCustomData(name,flow){window.customData={page:{name:name,flow:flow},site:{product:'​ecred',area:'credito',version:'​1.0',brand:'serasa',channel:'​web'},user:{logged:'false',connection:getConnection()}};}function getConnection(){try{return navigator.connection.effectiveType;}catch(error){return null;}}function normalizeLabel(label){return label.toLowerCase().replace(/\.|\?/g,'').replace('.','').replace(',','.').replace(' ','_').normalize('NFD').replace(/[\u0300-\u036f]/g,'');}/* harmony default export */ __webpack_exports__["a"] = (function(){function event(event){var _this=this;var callback=void 0;var dataset=this.dataset;if(dataset.ecsEvent!=='analytics'){return;}var label=dataset.ecsLabel;if(label==null||label==''){label=this.innerText;}if(this.href){event.preventDefault();callback=function callback(){window.location.href=_this.href;};}analytic({category:dataset.ecsCategory,action:dataset.ecsAction,label:label,value:dataset.ecsValue},callback);}[].forEach.call(document.querySelectorAll('[data-ecs-event="analytics"]'),function(element){element.addEventListener('click',event);});});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BOOSTER_USER_OFFERS_ECRED = exports.BOOSTER_USER_OFFERS_LIMPA_NOME = exports.BOOSTER_USER_SCORE = exports.BOOSTER_USER_DEBTS = exports.BOOSTER_USER_CREDIT = exports.BOOSTER_USER_COMPANY = exports.BOOSTER_USER_MOTIVATION = exports.BOOSTER_USER_ADVERTISING = exports.BOOSTER_USER_DATA_CREDIT = exports.BOOSTER_USER_SIGNUP = exports.BOOSTER_USER = exports.BOOSTER_PAGEVIEW = exports.BOOSTER_GA = exports.BOOSTER_GTM = exports.BoosterTypes = exports.BoosterEmit = exports.BoosterInitialize = exports.BoosterReady = void 0;

var _booster = __webpack_require__(68);

var types = _interopRequireWildcard(__webpack_require__(69));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BoosterReady = _booster.ready;
exports.BoosterReady = BoosterReady;
var BoosterInitialize = _booster.initialize;
exports.BoosterInitialize = BoosterInitialize;
var BoosterEmit = _booster.emit;
exports.BoosterEmit = BoosterEmit;
var BoosterTypes = types;
exports.BoosterTypes = BoosterTypes;
var BOOSTER_GTM = types.BOOSTER_GTM;
exports.BOOSTER_GTM = BOOSTER_GTM;
var BOOSTER_GA = types.BOOSTER_GA;
exports.BOOSTER_GA = BOOSTER_GA;
var BOOSTER_PAGEVIEW = types.BOOSTER_PAGEVIEW;
exports.BOOSTER_PAGEVIEW = BOOSTER_PAGEVIEW;
var BOOSTER_USER = types.BOOSTER_USER;
exports.BOOSTER_USER = BOOSTER_USER;
var BOOSTER_USER_SIGNUP = types.BOOSTER_USER_SIGNUP;
exports.BOOSTER_USER_SIGNUP = BOOSTER_USER_SIGNUP;
var BOOSTER_USER_DATA_CREDIT = types.BOOSTER_USER_DATA_CREDIT;
exports.BOOSTER_USER_DATA_CREDIT = BOOSTER_USER_DATA_CREDIT;
var BOOSTER_USER_ADVERTISING = types.BOOSTER_USER_ADVERTISING;
exports.BOOSTER_USER_ADVERTISING = BOOSTER_USER_ADVERTISING;
var BOOSTER_USER_MOTIVATION = types.BOOSTER_USER_MOTIVATION;
exports.BOOSTER_USER_MOTIVATION = BOOSTER_USER_MOTIVATION;
var BOOSTER_USER_COMPANY = types.BOOSTER_USER_COMPANY;
exports.BOOSTER_USER_COMPANY = BOOSTER_USER_COMPANY;
var BOOSTER_USER_CREDIT = types.BOOSTER_USER_CREDIT;
exports.BOOSTER_USER_CREDIT = BOOSTER_USER_CREDIT;
var BOOSTER_USER_DEBTS = types.BOOSTER_USER_DEBTS;
exports.BOOSTER_USER_DEBTS = BOOSTER_USER_DEBTS;
var BOOSTER_USER_SCORE = types.BOOSTER_USER_SCORE;
exports.BOOSTER_USER_SCORE = BOOSTER_USER_SCORE;
var BOOSTER_USER_OFFERS_LIMPA_NOME = types.BOOSTER_USER_OFFERS_LIMPA_NOME;
exports.BOOSTER_USER_OFFERS_LIMPA_NOME = BOOSTER_USER_OFFERS_LIMPA_NOME;
var BOOSTER_USER_OFFERS_ECRED = types.BOOSTER_USER_OFFERS_ECRED;
exports.BOOSTER_USER_OFFERS_ECRED = BOOSTER_USER_OFFERS_ECRED;
var _default = {
  ready: _booster.ready,
  initialize: _booster.initialize,
  emit: _booster.emit
};
exports["default"] = _default;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.images = undefined;

var _preact = __webpack_require__(0);

var _bifrost = __webpack_require__(32);

var _bifrost2 = _interopRequireDefault(_bifrost);

var _store = __webpack_require__(14);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(6);

var actions = _interopRequireWildcard(_actions);

var _root = __webpack_require__(101);

var _root2 = _interopRequireDefault(_root);

var _constants = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var images = exports.images = _constants.PRODUCTS;

exports.default = function (props, element) {
  var storeActions = _store2.default.actions(actions);

  storeActions.init({
    product: props.product,
    profile: props.profile,
    loggedIn: props.loggedIn,
    brand: props.brand,
    login: props.login,
    logout: props.logout,
    signUp: props.signUp,
    config: props.config,
    environment: props.environment,
    menus: props.menus,
    metric: props.metric,
    notification: props.notification
  });

  _bifrost2.default.initialize({ environment: props.environment });

  (0, _preact.render)((0, _preact.h)(_root2.default, null), element);

  delete storeActions.analyticsEvent;

  return storeActions;
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emit = exports.initialize = exports.ready = void 0;
var BOOSTER = "__BOOSTER__";
var isBrowser = typeof window !== 'undefined';

var initialize = function initialize() {};

exports.initialize = initialize;

var ready = function ready() {};

exports.ready = ready;

var emit = function emit() {};

exports.emit = emit;

if (isBrowser) {
  window[BOOSTER] = window[BOOSTER] || [];

  var callback = function callback(priority) {
    var args = [].slice.call(arguments);
    window[BOOSTER].push([priority, args.splice(1)]);
  };

  window.Booster = window.Booster || {
    initialize: callback.bind(null, 0),
    ready: callback.bind(null, 1),
    emit: callback.bind(null, 2)
  };

  exports.ready = ready = function ready() {
    var _window$Booster;

    return (_window$Booster = window.Booster).ready.apply(_window$Booster, arguments);
  };

  exports.initialize = initialize = function initialize() {
    var _window$Booster2;

    return (_window$Booster2 = window.Booster).initialize.apply(_window$Booster2, arguments);
  };

  exports.emit = emit = function emit() {
    var _window$Booster3;

    return (_window$Booster3 = window.Booster).emit.apply(_window$Booster3, arguments);
  };
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOOSTER_USER_OFFERS_ECRED = exports.BOOSTER_USER_OFFERS_LIMPA_NOME = exports.BOOSTER_USER_MOTIVATION = exports.BOOSTER_USER_SCORE = exports.BOOSTER_USER_DEBTS = exports.BOOSTER_USER_CREDIT = exports.BOOSTER_USER_COMPANY = exports.BOOSTER_USER_ADVERTISING = exports.BOOSTER_USER_DATA_CREDIT = exports.BOOSTER_USER_SIGNUP = exports.BOOSTER_USER = exports.BOOSTER_PAGEVIEW = exports.BOOSTER_GA = exports.BOOSTER_GTM = void 0;
var BOOSTER_GTM = 'BOOSTER_GTM';
exports.BOOSTER_GTM = BOOSTER_GTM;
var BOOSTER_GA = 'BOOSTER_GA';
exports.BOOSTER_GA = BOOSTER_GA;
var BOOSTER_PAGEVIEW = 'BOOSTER_PAGEVIEW';
exports.BOOSTER_PAGEVIEW = BOOSTER_PAGEVIEW;
var BOOSTER_USER = 'BOOSTER_USER';
exports.BOOSTER_USER = BOOSTER_USER;
var BOOSTER_USER_SIGNUP = 'BOOSTER_USER_SIGNUP';
exports.BOOSTER_USER_SIGNUP = BOOSTER_USER_SIGNUP;
var BOOSTER_USER_DATA_CREDIT = 'BOOSTER_USER_DATA_CREDIT';
exports.BOOSTER_USER_DATA_CREDIT = BOOSTER_USER_DATA_CREDIT;
var BOOSTER_USER_ADVERTISING = 'BOOSTER_USER_ADVERTISING';
exports.BOOSTER_USER_ADVERTISING = BOOSTER_USER_ADVERTISING;
var BOOSTER_USER_COMPANY = 'BOOSTER_USER_COMPANY';
exports.BOOSTER_USER_COMPANY = BOOSTER_USER_COMPANY;
var BOOSTER_USER_CREDIT = 'BOOSTER_USER_CREDIT';
exports.BOOSTER_USER_CREDIT = BOOSTER_USER_CREDIT;
var BOOSTER_USER_DEBTS = 'BOOSTER_USER_DEBTS';
exports.BOOSTER_USER_DEBTS = BOOSTER_USER_DEBTS;
var BOOSTER_USER_SCORE = 'BOOSTER_USER_SCORE';
exports.BOOSTER_USER_SCORE = BOOSTER_USER_SCORE;
var BOOSTER_USER_MOTIVATION = 'BOOSTER_USER_MOTIVATION';
exports.BOOSTER_USER_MOTIVATION = BOOSTER_USER_MOTIVATION;
var BOOSTER_USER_OFFERS_LIMPA_NOME = 'BOOSTER_USER_OFFERS_LIMPA_NOME';
exports.BOOSTER_USER_OFFERS_LIMPA_NOME = BOOSTER_USER_OFFERS_LIMPA_NOME;
var BOOSTER_USER_OFFERS_ECRED = 'BOOSTER_USER_OFFERS_ECRED';
exports.BOOSTER_USER_OFFERS_ECRED = BOOSTER_USER_OFFERS_ECRED;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (path, body, callback) {
  var config = (0, _config.getConfig)();
  var req = new XMLHttpRequest();

  req.open('GET', '' + config.host + path);
  req.setRequestHeader('Content-Type', 'application/json');
  req.setRequestHeader('X-Api-Key', config.apiKey);

  if (body && body.token) {
    req.setRequestHeader('X-Bifrost-Authorization', body.token);
  } else {
    var cookieToken = (0, _utils.getCookie)('Valgrind-AU');
    if (cookieToken != null && cookieToken !== '') {
      req.setRequestHeader('X-Bifrost-Authorization', cookieToken);
    }
  }

  if (config.applicationId) {
    req.setRequestHeader('X-ECS-APPLICATION-ID', config.applicationId);
  }

  req.withCredentials = true;

  req.onreadystatechange = function () {
    if (req.readyState < 4) {
      return;
    }

    callback(req.status < 200 || req.status > 299, {
      status: req.status,
      responseText: req.responseText,
      response: (0, _utils.parseJSON)(req.responseText)
    });
  };

  req.send();
};

var _utils = __webpack_require__(20);

var _config = __webpack_require__(33);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(72), __esModule: true };

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73);
module.exports = __webpack_require__(22).Object.entries;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(74);
var $entries = __webpack_require__(84)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var core = __webpack_require__(22);
var ctx = __webpack_require__(75);
var hide = __webpack_require__(77);
var has = __webpack_require__(35);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(76);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(78);
var createDesc = __webpack_require__(83);
module.exports = __webpack_require__(15) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(79);
var IE8_DOM_DEFINE = __webpack_require__(80);
var toPrimitive = __webpack_require__(82);
var dP = Object.defineProperty;

exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(15) && !__webpack_require__(34)(function () {
  return Object.defineProperty(__webpack_require__(81)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23);
var document = __webpack_require__(21).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(23);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(15);
var getKeys = __webpack_require__(85);
var toIObject = __webpack_require__(24);
var isEnum = __webpack_require__(98).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(86);
var enumBugKeys = __webpack_require__(97);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(35);
var toIObject = __webpack_require__(24);
var arrayIndexOf = __webpack_require__(90)(false);
var IE_PROTO = __webpack_require__(93)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(88);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(24);
var toLength = __webpack_require__(91);
var toAbsoluteIndex = __webpack_require__(92);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(36);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(36);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(94)('keys');
var uid = __webpack_require__(96);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(22);
var global = __webpack_require__(21);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(95) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 98 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function n(n,t){for(var r in t)n[r]=t[r];return n}/* harmony default export */ __webpack_exports__["default"] = (function(t){var r=[];function u(n){for(var t=[],u=0;u<r.length;u++)r[u]===n?n=null:t.push(r[u]);r=t}function e(u,e,f){t=e?u:n(n({},t),u);for(var i=r,o=0;o<i.length;o++)i[o](t,f)}return t=t||{},{action:function(n){function r(t){e(t,!1,n)}return function(){for(var u=arguments,e=[t],f=0;f<arguments.length;f++)e.push(u[f]);var i=n.apply(this,e);if(null!=i)return i.then?i.then(r):r(i)}},setState:e,subscribe:function(n){return r.push(n),function(){u(n)}},unsubscribe:u,getState:function(){return t}}});
//# sourceMappingURL=unistore.es.js.map


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _types = __webpack_require__(25);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _types.INIT:
    case _types.RESET:
      {
        var environment = payload.environment || 'development';

        return _extends({}, state, {
          product: payload.product,
          profile: payload.profile || {},
          loggedIn: payload.loggedIn || false,
          config: _extends({}, state.config, payload.config || {}),
          menus: payload.menus || [],
          notification: _extends({}, state.notification, payload.notification || {}),
          brand: _extends({}, state.brand, payload.brand || {}),
          login: _extends({}, state.login, payload.login || {}),
          logout: _extends({}, state.logout, payload.logout || {}),
          signUp: _extends({}, state.signUp, payload.signUp || {}),
          environment: environment,
          metric: payload.metric || state.metric,
          heimdall: _extends({}, state.heimdall, state.heimdall.environments[environment])
        });
      }
    case _types.PRODUCT:
      {
        return _extends({}, state, {
          product: payload
        });
      }
    case _types.GRADIENT:
      {
        return _extends({}, state, {
          config: _extends({}, state.config, {
            gradient: payload.gradient,
            gradientColor: payload.gradientColor || state.config.gradientColor
          })
        });
      }
    case _types.CONFIG:
      {
        return _extends({}, state, {
          config: _extends({}, state.config, payload)
        });
      }
    case _types.SIGNUP:
      {
        return _extends({}, state, {
          signUp: _extends({}, state.signUp, payload)
        });
      }
    case _types.MENUS:
      {
        return _extends({}, state, {
          menus: payload
        });
      }
    case _types.NOTIFICATION:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            active: payload
          })
        });
      }
    case _types.NOTIFICATIONS_UNREAD:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            unread: payload,
            loading: false,
            unreadLoaded: true
          })
        });
      }
    case _types.NOTIFICATIONS_READ:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            loading: false,
            list: payload
          })
        });
      }
    case _types.NOTIFICATIONS_SUCCESS:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            loading: false,
            list: state.notification.list.length > 0 ? state.notification.list.concat(payload) : payload
          })
        });
      }
    case _types.NOTIFICATIONS_ERROR:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            loading: false
          })
        });
      }
    case _types.NOTIFICATIONS_LOADING:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            loading: payload
          })
        });
      }
    case _types.LOGGED:
      {
        return _extends({}, state, {
          loggedIn: payload.logged,
          profile: payload.user
        });
      }
    case _types.LOGOUT:
      {
        return _extends({}, state, {
          loggedIn: false,
          profile: null
        });
      }
    case _types.BRAND:
      {
        return _extends({}, state, {
          brand: _extends({}, state.brand, payload)
        });
      }
    case _types.TOGGLE_DROPDOWN:
      {
        return _extends({}, state, {
          heimdall: _extends({}, state.heimdall, {
            dropdown: _extends({}, state.heimdall.dropdown, _defineProperty({}, payload, !state.heimdall.dropdown[payload]))
          })
        });
      }
    case _types.METRIC:
      {
        return _extends({}, state, {
          metric: payload.metric
        });
      }
  }
  return state;
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _preact2 = __webpack_require__(7);

var _store = __webpack_require__(14);

var _store2 = _interopRequireDefault(_store);

var _style = __webpack_require__(26);

var _style2 = _interopRequireDefault(_style);

var _Container = __webpack_require__(182);

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Root = function Root() {
  return (0, _preact.h)(
    _preact2.Provider,
    { store: _store2.default },
    (0, _preact.h)(
      _style2.default,
      null,
      (0, _preact.h)(_Container2.default, null)
    )
  );
};

exports.default = Root;

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyDeclaration__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyDeclaration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyDeclaration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayEach__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isobject__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fela_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cssifyFontFace__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cssifyKeyframe__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cssifyStaticStyle__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generateAnimationName__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__generateClassName__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__generateFontSource__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__generateStaticReference__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getFontFormat__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getFontLocals__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__getFontUrl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__isSafeClassName__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__toCSSString__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__validateSelectorPrefix__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sortObjectKeys__ = __webpack_require__(133);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






















function createRenderer() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var renderer = {
    listeners: [],
    keyframePrefixes: config.keyframePrefixes || ['-webkit-', '-moz-'],
    plugins: config.plugins || [],
    mediaQueryOrder: config.mediaQueryOrder || [],
    supportQueryOrder: config.supportQueryOrder || [],
    ruleOrder: [/^:link/, /^:visited/, /^:hover/, /^:focus-within/, /^:focus/, /^:active/],

    selectorPrefix: Object(__WEBPACK_IMPORTED_MODULE_16__validateSelectorPrefix__["a" /* default */])(config.selectorPrefix),
    filterClassName: config.filterClassName || __WEBPACK_IMPORTED_MODULE_14__isSafeClassName__["a" /* default */],
    devMode: config.devMode || false,

    uniqueRuleIdentifier: 0,
    uniqueKeyframeIdentifier: 0,

    nodes: {},
    // use a flat cache object with pure string references
    // to achieve maximal lookup performance and memoization speed
    cache: {},

    getNextRuleIdentifier: function getNextRuleIdentifier() {
      return ++renderer.uniqueRuleIdentifier;
    },
    renderRule: function renderRule(rule) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return renderer._renderStyle(rule(props, renderer), props);
    },
    renderKeyframe: function renderKeyframe(keyframe) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var resolvedKeyframe = keyframe(props, renderer);
      var keyframeReference = JSON.stringify(resolvedKeyframe);

      if (!renderer.cache.hasOwnProperty(keyframeReference)) {
        // use another unique identifier to ensure minimal css markup
        var animationName = Object(__WEBPACK_IMPORTED_MODULE_7__generateAnimationName__["a" /* default */])(++renderer.uniqueKeyframeIdentifier);

        var processedKeyframe = Object(__WEBPACK_IMPORTED_MODULE_3_fela_utils__["r" /* processStyleWithPlugins */])(renderer, resolvedKeyframe, __WEBPACK_IMPORTED_MODULE_3_fela_utils__["c" /* KEYFRAME_TYPE */], props);

        var cssKeyframe = Object(__WEBPACK_IMPORTED_MODULE_5__cssifyKeyframe__["a" /* default */])(processedKeyframe, animationName, renderer.keyframePrefixes);

        var change = {
          type: __WEBPACK_IMPORTED_MODULE_3_fela_utils__["c" /* KEYFRAME_TYPE */],
          keyframe: cssKeyframe,
          name: animationName
        };

        renderer.cache[keyframeReference] = change;
        renderer._emitChange(change);
      }

      return renderer.cache[keyframeReference].name;
    },
    renderFont: function renderFont(family, files) {
      var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var localAlias = properties.localAlias,
          otherProperties = _objectWithoutProperties(properties, ['localAlias']);

      var fontReference = family + JSON.stringify(properties);
      var fontLocals = Object(__WEBPACK_IMPORTED_MODULE_12__getFontLocals__["a" /* default */])(localAlias);

      if (!renderer.cache.hasOwnProperty(fontReference)) {
        var fontFamily = Object(__WEBPACK_IMPORTED_MODULE_15__toCSSString__["a" /* default */])(family);

        var fontFace = _extends({}, otherProperties, {
          src: Object(__WEBPACK_IMPORTED_MODULE_9__generateFontSource__["a" /* default */])(files, fontLocals),
          fontFamily: fontFamily
        });

        var cssFontFace = Object(__WEBPACK_IMPORTED_MODULE_4__cssifyFontFace__["a" /* default */])(fontFace);

        var change = {
          type: __WEBPACK_IMPORTED_MODULE_3_fela_utils__["b" /* FONT_TYPE */],
          fontFace: cssFontFace,
          fontFamily: fontFamily
        };

        renderer.cache[fontReference] = change;
        renderer._emitChange(change);
      }

      return renderer.cache[fontReference].fontFamily;
    },
    renderStatic: function renderStatic(staticStyle, selector) {
      var staticReference = Object(__WEBPACK_IMPORTED_MODULE_10__generateStaticReference__["a" /* default */])(staticStyle, selector);

      if (!renderer.cache.hasOwnProperty(staticReference)) {
        var cssDeclarations = Object(__WEBPACK_IMPORTED_MODULE_6__cssifyStaticStyle__["a" /* default */])(staticStyle, renderer);

        var change = {
          type: __WEBPACK_IMPORTED_MODULE_3_fela_utils__["e" /* STATIC_TYPE */],
          css: cssDeclarations,
          selector: selector
        };

        renderer.cache[staticReference] = change;
        renderer._emitChange(change);
      }
    },
    subscribe: function subscribe(callback) {
      renderer.listeners.push(callback);

      return {
        unsubscribe: function unsubscribe() {
          return renderer.listeners.splice(renderer.listeners.indexOf(callback), 1);
        }
      };
    },
    clear: function clear() {
      renderer.uniqueRuleIdentifier = 0;
      renderer.uniqueKeyframeIdentifier = 0;
      renderer.cache = {};

      renderer._emitChange({
        type: __WEBPACK_IMPORTED_MODULE_3_fela_utils__["a" /* CLEAR_TYPE */]
      });
    },
    _renderStyle: function _renderStyle() {
      var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var processedStyle = Object(__WEBPACK_IMPORTED_MODULE_3_fela_utils__["r" /* processStyleWithPlugins */])(renderer, style, __WEBPACK_IMPORTED_MODULE_3_fela_utils__["d" /* RULE_TYPE */], props);

      return renderer._renderStyleToClassNames(processedStyle).slice(1);
    },
    _renderStyleToClassNames: function _renderStyleToClassNames(_ref) {
      var pseudo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var media = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var support = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      var _className = _ref._className,
          style = _objectWithoutProperties(_ref, ['_className']);

      var classNames = _className ? ' ' + _className : '';
      var sortedStyle = Object(__WEBPACK_IMPORTED_MODULE_17__sortObjectKeys__["a" /* default */])(style);

      for (var property in sortedStyle) {
        var value = sortedStyle[property];

        if (__WEBPACK_IMPORTED_MODULE_2_isobject___default()(value)) {
          if (Object(__WEBPACK_IMPORTED_MODULE_3_fela_utils__["m" /* isNestedSelector */])(property)) {
            classNames += renderer._renderStyleToClassNames(value, pseudo + Object(__WEBPACK_IMPORTED_MODULE_3_fela_utils__["q" /* normalizeNestedProperty */])(property), media, support);
          } else if (Object(__WEBPACK_IMPORTED_MODULE_3_fela_utils__["l" /* isMediaQuery */])(property)) {
            var combinedMediaQuery = Object(__WEBPACK_IMPORTED_MODULE_3_fela_utils__["k" /* generateCombinedMediaQuery */])(media, property.slice(6).trim());
            classNames += renderer._renderStyleToClassNames(value, pseudo, combinedMediaQuery, support);
          } else if (Object(__WEBPACK_IMPORTED_MODULE_3_fela_utils__["n" /* isSupport */])(property)) {
            var combinedSupport = Object(__WEBPACK_IMPORTED_MODULE_3_fela_utils__["k" /* generateCombinedMediaQuery */])(support, property.slice(9).trim());
            classNames += renderer._renderStyleToClassNames(value, pseudo, media, combinedSupport);
          } else {
            console.warn('The object key "' + property + '" is not a valid nested key in Fela. \nMaybe you forgot to add a plugin to resolve it? \nCheck http://fela.js.org/docs/basics/Rules.html#styleobject for more information.');
          }
        } else {
          var declarationReference = support + media + pseudo + property + value;

          if (!renderer.cache.hasOwnProperty(declarationReference)) {
            // we remove undefined values to enable
            // usage of optional props without side-effects
            if (Object(__WEBPACK_IMPORTED_MODULE_3_fela_utils__["o" /* isUndefinedValue */])(value)) {
              renderer.cache[declarationReference] = {
                className: ''
                /* eslint-disable no-continue */
              };continue;
              /* eslint-enable */
            }

            var className = renderer.selectorPrefix + Object(__WEBPACK_IMPORTED_MODULE_8__generateClassName__["a" /* default */])(renderer.getNextRuleIdentifier, renderer.filterClassName);

            var declaration = __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyDeclaration___default()(property, value);
            var selector = Object(__WEBPACK_IMPORTED_MODULE_3_fela_utils__["i" /* generateCSSSelector */])(className, pseudo);

            var change = {
              type: __WEBPACK_IMPORTED_MODULE_3_fela_utils__["d" /* RULE_TYPE */],
              className: className,
              selector: selector,
              declaration: declaration,
              pseudo: pseudo,
              media: media,
              support: support
            };

            renderer.cache[declarationReference] = change;
            renderer._emitChange(change);
          }

          var cachedClassName = renderer.cache[declarationReference].className;

          // only append if we got a class cached
          if (cachedClassName) {
            classNames += ' ' + cachedClassName;
          }
        }
      }

      return classNames;
    },
    _emitChange: function _emitChange(change) {
      __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayEach___default()(renderer.listeners, function (listener) {
        return listener(change);
      });
    }
  };

  // initial setup
  renderer.keyframePrefixes.push('');

  if (config.enhancers) {
    __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayEach___default()(config.enhancers, function (enhancer) {
      renderer = enhancer(renderer);
    });
  }

  return renderer;
}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(104);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2["default"])(property);
}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clusterCache;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__applyKeysInOrder__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generateCSSRule__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objectSortByScore__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getRuleScore__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styleTypes__ = __webpack_require__(27);
var _handlers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var handlers = (_handlers = {}, _defineProperty(_handlers, __WEBPACK_IMPORTED_MODULE_6__styleTypes__["d" /* RULE_TYPE */], function (cluster, _ref) {
  var selector = _ref.selector,
      declaration = _ref.declaration,
      support = _ref.support,
      media = _ref.media;

  var cssRule = Object(__WEBPACK_IMPORTED_MODULE_3__generateCSSRule__["a" /* default */])(selector, declaration);

  if (support) {
    if (media) {
      if (!cluster.supportMediaRules[media]) {
        cluster.supportMediaRules[media] = {};
      }

      if (!cluster.supportMediaRules[media][support]) {
        cluster.supportMediaRules[media][support] = '';
      }

      cluster.supportMediaRules[media][support] += cssRule;
    } else {
      if (!cluster.supportRules[support]) {
        cluster.supportRules[support] = '';
      }

      cluster.supportRules[support] += cssRule;
    }
  } else {
    if (media) {
      if (!cluster.mediaRules[media]) {
        cluster.mediaRules[media] = '';
      }

      cluster.mediaRules[media] += cssRule;
    } else {
      cluster.rules += cssRule;
    }
  }
}), _defineProperty(_handlers, __WEBPACK_IMPORTED_MODULE_6__styleTypes__["b" /* FONT_TYPE */], function (cluster, _ref2) {
  var fontFace = _ref2.fontFace;

  cluster.fontFaces += fontFace;
}), _defineProperty(_handlers, __WEBPACK_IMPORTED_MODULE_6__styleTypes__["c" /* KEYFRAME_TYPE */], function (cluster, _ref3) {
  var keyframe = _ref3.keyframe;

  cluster.keyframes += keyframe;
}), _defineProperty(_handlers, __WEBPACK_IMPORTED_MODULE_6__styleTypes__["e" /* STATIC_TYPE */], function (cluster, _ref4) {
  var css = _ref4.css,
      selector = _ref4.selector;

  if (selector) {
    cluster.statics += Object(__WEBPACK_IMPORTED_MODULE_3__generateCSSRule__["a" /* default */])(selector, css);
  } else {
    cluster.statics += css;
  }
}), _handlers);

function clusterCache(cache) {
  var mediaQueryOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var supportQueryOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var ruleOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  var sortedCache = Object(__WEBPACK_IMPORTED_MODULE_4__objectSortByScore__["a" /* default */])(cache, function (value) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__getRuleScore__["a" /* default */])(ruleOrder, value.pseudo);
  });

  var mediaRules = Object(__WEBPACK_IMPORTED_MODULE_2__applyKeysInOrder__["a" /* default */])(mediaQueryOrder);
  var supportRules = Object(__WEBPACK_IMPORTED_MODULE_2__applyKeysInOrder__["a" /* default */])(supportQueryOrder);

  var supportMediaRules = __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(mediaQueryOrder, function (supportRules, media) {
    supportRules[media] = Object(__WEBPACK_IMPORTED_MODULE_2__applyKeysInOrder__["a" /* default */])(supportQueryOrder);
    return supportRules;
  }, Object(__WEBPACK_IMPORTED_MODULE_2__applyKeysInOrder__["a" /* default */])(mediaQueryOrder, {}));

  return __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce___default()(sortedCache, function (cluster, entry, key) {
    var handler = handlers[entry.type];

    if (handler) {
      handler(cluster, entry);
    }

    return cluster;
  }, {
    mediaRules: mediaRules,
    supportRules: supportRules,
    supportMediaRules: supportMediaRules,
    fontFaces: '',
    statics: '',
    keyframes: '',
    rules: ''
  });
}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = objectSortByScore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__insertAtIndex__ = __webpack_require__(107);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






// TODO: we can further improve this one
function objectSortByScore(obj, getScore) {
  var sortedKeys = __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce___default()(obj, function (sortedKeys, value, key) {
    var index = sortedKeys.findIndex(function (el) {
      return getScore(obj[el], el) > getScore(value, key);
    });

    if (index !== -1) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__insertAtIndex__["a" /* default */])(sortedKeys, key, index);
    }

    return [].concat(_toConsumableArray(sortedKeys), [key]);
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(sortedKeys, function (sortedObj, key) {
    sortedObj[key] = obj[key];
    return sortedObj;
  }, {});
}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = insertAtIndex;
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function insertAtIndex(arr, el, index) {
  return [].concat(_toConsumableArray(arr.slice(0, index)), [el], _toConsumableArray(arr.slice(index, arr.length)));
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cssifySupportRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCSSSupportRule__ = __webpack_require__(42);




function cssifySupportRules(supportRules) {
  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default()(supportRules, function (css, cssRules, support) {
    if (cssRules.length > 0) {
      css += Object(__WEBPACK_IMPORTED_MODULE_1__generateCSSSupportRule__["a" /* default */])(support, cssRules);
    }

    return css;
  }, '');
}

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateCombinedMediaQuery;
function generateCombinedMediaQuery(currentMediaQuery, nestedMediaQuery) {
  if (currentMediaQuery.length === 0) {
    return nestedMediaQuery;
  }

  return currentMediaQuery + " and " + nestedMediaQuery;
}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateCSSSelector;
function generateCSSSelector(className) {
  var pseudo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return '.' + className + pseudo;
}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_string_hash__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_string_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_string_hash__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var collisionBuffer = {};

function generateUniqueHash(reference) {
  var result = (typeof reference === 'undefined' ? 'undefined' : _typeof(reference)) === 'object' ? JSON.stringify(reference) : reference;
  var prevResult = void 0;

  do {
    prevResult = result;
    result = __WEBPACK_IMPORTED_MODULE_0_string_hash___default()(prevResult).toString(36);
  } while (collisionBuffer[result] && collisionBuffer[result] !== prevResult);

  collisionBuffer[result] = prevResult;

  return '_' + result;
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function hash(str) {
  var hash = 5381,
      i    = str.length;

  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

module.exports = hash;


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMediaQuery;
function isMediaQuery(property) {
  return property.substr(0, 6) === '@media';
}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNestedSelector;
var regex = /^(:|\[|>|&)/;

function isNestedSelector(property) {
  return regex.test(property);
}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSupport;
function isSupport(property) {
  return property.substr(0, 9) === '@supports';
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isUndefinedValue;
function isUndefinedValue(value) {
  return value === undefined || value === null || typeof value === 'string' && value.match(/(undefined|null)/) !== null;
}

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidHTMLElement;
function isValidHTMLElement(mountNode) {
  return mountNode && mountNode.nodeType === 1;
}

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeNestedProperty;
function normalizeNestedProperty(nestedProperty) {
  if (nestedProperty.charAt(0) === '&') {
    return nestedProperty.slice(1);
  }

  return nestedProperty;
}

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = processStyleWithPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);


function processStyleWithPlugins(renderer, style, type) {
  var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (renderer.plugins.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(renderer.plugins, function (processedStyle, plugin) {
      return plugin(processedStyle, type, renderer, props);
    }, style);
  }

  return style;
}

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styleTypes__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  fontFaces: __WEBPACK_IMPORTED_MODULE_0__styleTypes__["b" /* FONT_TYPE */],
  statics: __WEBPACK_IMPORTED_MODULE_0__styleTypes__["e" /* STATIC_TYPE */],
  keyframes: __WEBPACK_IMPORTED_MODULE_0__styleTypes__["c" /* KEYFRAME_TYPE */],
  rules: __WEBPACK_IMPORTED_MODULE_0__styleTypes__["d" /* RULE_TYPE */]
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cssifyFontFace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyObject__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyObject__);


function cssifyFontFace(fontFace) {
  return '@font-face{' + __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyObject___default()(fontFace) + '}';
}

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cssifyKeyframe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_css_in_js_utils_lib_cssifyObject__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_css_in_js_utils_lib_cssifyObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_css_in_js_utils_lib_cssifyObject__);




function cssifyKeyframe(frames, animationName) {
  var prefixes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [''];

  var keyframe = __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce___default()(frames, function (css, frame, percentage) {
    return '' + css + percentage + '{' + __WEBPACK_IMPORTED_MODULE_2_css_in_js_utils_lib_cssifyObject___default()(frame) + '}';
  }, '');

  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(prefixes, function (cssKeyframe, prefix) {
    return cssKeyframe + '@' + prefix + 'keyframes ' + animationName + '{' + keyframe + '}';
  }, '');
}

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cssifyStaticStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyObject__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__minifyCSSString__ = __webpack_require__(124);





function cssifyStaticStyle(staticStyle, renderer) {
  if (typeof staticStyle === 'string') {
    return Object(__WEBPACK_IMPORTED_MODULE_2__minifyCSSString__["a" /* default */])(staticStyle);
  }

  var processedStaticStyle = Object(__WEBPACK_IMPORTED_MODULE_1_fela_utils__["r" /* processStyleWithPlugins */])(renderer, staticStyle, __WEBPACK_IMPORTED_MODULE_1_fela_utils__["e" /* STATIC_TYPE */]);

  return __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_cssifyObject___default()(processedStaticStyle);
}

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = minifyCSSString;
function minifyCSSString(style) {
  return style.replace(/\s{2,}/g, '');
}

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateAnimationName;
function generateAnimationName(id) {
  return "k" + id;
}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateClassName;
var chars = 'abcdefghijklmnopqrstuvwxyz';
var charLength = chars.length;

function generateClassName(getId) {
  var filterClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };

  var startId = getId();
  var generatedClassName = generateUniqueClassName(startId);

  if (!filterClassName(generatedClassName)) {
    return generateClassName(getId, filterClassName);
  }

  return generatedClassName;
}

function generateUniqueClassName(id) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (id <= charLength) {
    return chars[id - 1] + className;
  }

  // Bitwise floor as safari performs much faster
  // https://jsperf.com/math-floor-vs-math-round-vs-parseint/55
  return generateUniqueClassName(id / charLength | 0, chars[id % charLength] + className);
}

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateFontSource;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getFontUrl__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getFontFormat__ = __webpack_require__(45);





function generateFontSource() {
  var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fontLocals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var localSource = __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(fontLocals, function (src, local) {
    var localUrl = Object(__WEBPACK_IMPORTED_MODULE_1__getFontUrl__["a" /* default */])(local);
    return '{src} local(' + localUrl + '), ';
  }, '');

  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(files, function (src, fileSource, index) {
    var prefix = index > 0 ? ',' : '';
    var fileFormat = Object(__WEBPACK_IMPORTED_MODULE_2__getFontFormat__["a" /* default */])(fileSource);
    var fileUrl = Object(__WEBPACK_IMPORTED_MODULE_1__getFontUrl__["a" /* default */])(fileSource);

    return '' + src + prefix + 'url(' + fileUrl + ') format(\'' + fileFormat + '\')';
  }, localSource);
}

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateStaticReference;
function generateStaticReference(style, selector) {
  if (typeof style === 'string') {
    return style;
  }

  if (selector) {
    return selector + JSON.stringify(style);
  }

  return '';
}

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFontLocals;
function getFontLocals(localAlias) {
  if (typeof localAlias === 'string') {
    return [localAlias];
  }

  if (Array.isArray(localAlias)) {
    return localAlias.slice();
  }

  return [];
}

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSafeClassName;
function isSafeClassName(className) {
  return className.indexOf('ad') === -1;
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toCSSString;
function toCSSString(value) {
  if (value.charAt(0) === '"') {
    return value;
  }

  return '"' + value + '"';
}

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateSelectorPrefix;
var PREFIX_SYNTAX = /^[a-z_][a-z0-9-_]*$/gi;

function validateSelectorPrefix() {
  var selectorPrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (selectorPrefix.length > 0 && selectorPrefix.match(selectorPrefix) === null) {
    console.error('An invalid selectorPrefix (' + selectorPrefix + ') has been used to create a new Fela renderer.\nIt must only contain a-Z, 0-9, - and _ while it must start with either _ or a-Z.\nSee http://fela.js.org/docs/advanced/RendererConfiguration.html');
  }

  return selectorPrefix;
}

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortObjectKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);


function sortObjectKeys(input) {
  var keys = Object.keys(input);
  var sortedKeys = keys.sort(function (a, b) {
    return a.localeCompare(b);
  });

  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(sortedKeys, function (output, key) {
    output[key] = input[key];

    return output;
  }, {});
}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_assignStyle__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_assignStyle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_assignStyle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayReduce__);



function combineRules() {
  for (var _len = arguments.length, rules = Array(_len), _key = 0; _key < _len; _key++) {
    rules[_key] = arguments[_key];
  }

  return function (props, renderer) {
    return __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayReduce___default()(rules, function (style, rule) {
      return __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_assignStyle___default()(style, rule(props, renderer));
    }, {});
  };
}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assignStyle;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function filterUniqueArray(arr) {
  return arr.filter(function (val, index) {
    return arr.lastIndexOf(val) === index;
  });
}

function assignStyle(base) {
  for (var i = 0, len = arguments.length <= 1 ? 0 : arguments.length - 1; i < len; ++i) {
    var style = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

    for (var property in style) {
      var value = style[property];
      var baseValue = base[property];

      if (baseValue && value) {
        if (Array.isArray(baseValue)) {
          base[property] = filterUniqueArray(baseValue.concat(value));
          continue;
        }

        if (Array.isArray(value)) {
          base[property] = filterUniqueArray([baseValue].concat(_toConsumableArray(value)));
          continue;
        }

        if (_typeof(value) === 'object') {
          base[property] = assignStyle({}, baseValue, value);
          continue;
        }
      }

      base[property] = value;
    }
  }

  return base;
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = enhance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);


function enhance() {
  for (var _len = arguments.length, enhancers = Array(_len), _key = 0; _key < _len; _key++) {
    enhancers[_key] = arguments[_key];
  }

  return function (createRenderer) {
    return function (config) {
      return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(enhancers, function (enhancedRenderer, enhancer) {
        enhancedRenderer = enhancer(enhancedRenderer);
        return enhancedRenderer;
      }, createRenderer(config));
    };
  };
}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_bindings__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withTheme__ = __webpack_require__(18);





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_fela_bindings__["e" /* connectFactory */])(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"], __WEBPACK_IMPORTED_MODULE_0_preact__["h"], __WEBPACK_IMPORTED_MODULE_2__withTheme__["a" /* default */]));

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fela_tools__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_shallow_compare__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__generateDisplayName__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoistStatics__ = __webpack_require__(29);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var defaultConfig = {
  pure: true
};

function connectFactory(BaseComponent, createElement, withTheme, contextTypes) {
  return function connect(rules) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var connectConfig = _extends({}, defaultConfig, config);

    return function (component) {
      var EnhancedComponent = function (_BaseComponent) {
        _inherits(EnhancedComponent, _BaseComponent);

        function EnhancedComponent() {
          _classCallCheck(this, EnhancedComponent);

          return _possibleConstructorReturn(this, (EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).apply(this, arguments));
        }

        _createClass(EnhancedComponent, [{
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps, nextState) {
            if (connectConfig.pure) {
              return __WEBPACK_IMPORTED_MODULE_3_react_addons_shallow_compare___default()(this, nextProps, nextState);
            }
            return true;
          }
        }, {
          key: 'render',
          value: function render() {
            var renderer = this.context.renderer;

            var _props = this.props,
                extend = _props.extend,
                _felaTheme = _props._felaTheme,
                _felaRules = _props._felaRules,
                otherProps = _objectWithoutProperties(_props, ['extend', '_felaTheme', '_felaRules']);

            var allRules = [rules];
            if (_felaRules) {
              allRules.push(_felaRules);
            }
            if (extend) {
              allRules.push(extend);
            }

            var combinedRules = __WEBPACK_IMPORTED_MODULE_2_fela_tools__["a" /* combineMultiRules */].apply(undefined, allRules);
            var preparedRules = combinedRules(_extends({}, otherProps, {
              theme: _felaTheme
            }), renderer);

            // improve developer experience with monolithic renderer
            if (false) {
              var componentName = typeof component === 'string' ? component : component.displayName || component.name || '';

              objectEach(preparedRules, function (rule, name) {
                var displayName = rule.name ? rule.name : 'FelaComponent';
                rule.selectorPrefix = displayName + '_' + componentName + '_' + name + '_';
              });
            }

            if (component._isFelaComponent) {
              return createElement(component, _extends({
                _felaRules: combinedRules
              }, otherProps));
            }

            var styles = __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default()(preparedRules, function (styleMap, rule, name) {
              styleMap[name] = renderer.renderRule(rule, _extends({}, otherProps, {
                theme: _felaTheme
              }));

              return styleMap;
            }, {});

            var boundRules = __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default()(preparedRules, function (ruleMap, rule, name) {
              ruleMap[name] = function (props) {
                return rule(_extends({
                  theme: _felaTheme
                }, props), renderer);
              };

              return ruleMap;
            }, {});

            return createElement(component, _extends({}, otherProps, {
              styles: styles,
              rules: boundRules
            }));
          }
        }]);

        return EnhancedComponent;
      }(BaseComponent);

      EnhancedComponent.displayName = Object(__WEBPACK_IMPORTED_MODULE_4__generateDisplayName__["a" /* default */])(component);
      EnhancedComponent._isFelaComponent = true;


      if (contextTypes) {
        EnhancedComponent.contextTypes = contextTypes;
      }

      var themedComponent = withTheme(EnhancedComponent, '_felaTheme');
      return Object(__WEBPACK_IMPORTED_MODULE_5__hoistStatics__["a" /* default */])(themedComponent, component);
    };
  };
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapValueToMediaQuery__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renderToElement__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__renderToString__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__combineMultiRules__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleSheet__ = __webpack_require__(144);
/* unused harmony reexport mapValueToMediaQuery */
/* unused harmony reexport renderToElement */
/* unused harmony reexport renderToString */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__combineMultiRules__["a"]; });
/* unused harmony reexport StyleSheet */








/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function mapValueToMediaQuery() {
  var queryValueMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mapper = arguments[1];

  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default()(queryValueMap, function (style, value, query) {
    if (typeof mapper === 'string') {
      style[query] = _defineProperty({}, mapper, value);
    } else {
      style[query] = mapper(value);
    }

    return style;
  }, {});
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fela_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renderToString__ = __webpack_require__(46);




function renderToElement(renderer, mountNode) {
  // mountNode must be a valid HTML element to be able
  // to set mountNode.textContent later on
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_fela_utils__["p" /* isValidHTMLElement */])(mountNode)) {
    throw new Error('You need to specify a valid element node (mountNode.nodeType = 1) to render into.');
  }

  var css = Object(__WEBPACK_IMPORTED_MODULE_1__renderToString__["a" /* default */])(renderer);

  if (mountNode.textContent !== css) {
    // render currently rendered styles to the DOM once
    mountNode.textContent = css;
  }

  return renderer.subscribe(function () {
    mountNode.textContent = Object(__WEBPACK_IMPORTED_MODULE_1__renderToString__["a" /* default */])(renderer);
  });
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cssifyMediaQueryRules;
function cssifyMediaQueryRules(mediaQuery, mediaQueryRules) {
  if (mediaQueryRules) {
    return '@media ' + mediaQuery + '{' + mediaQueryRules + '}';
  }

  return '';
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineMultiRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fela__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function safeRule(ruleOrObject) {
  return typeof ruleOrObject === 'function' ? ruleOrObject : function () {
    return ruleOrObject;
  };
}

function combineMultiRules() {
  for (var _len = arguments.length, multiRules = Array(_len), _key = 0; _key < _len; _key++) {
    multiRules[_key] = arguments[_key];
  }

  return function (props, renderer) {
    return __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayReduce___default()(multiRules, function (resultStyleMap, multiRule) {
      return _extends({}, resultStyleMap, __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default()(safeRule(multiRule)(props, renderer), function (styleMap, rule, name) {
        return _extends({}, styleMap, _defineProperty({}, name, resultStyleMap[name] ? Object(__WEBPACK_IMPORTED_MODULE_2_fela__["combineRules"])(resultStyleMap[name], safeRule(rule)) : safeRule(rule)));
      }, {}));
    }, {});
  };
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__);


/* unused harmony default export */ var _unused_webpack_default_export = ({
  create: function create(styleSheet) {
    return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default()(styleSheet, function (ruleSheet, rule, ruleName) {
      if (typeof rule === 'function') {
        ruleSheet[ruleName] = rule;
      } else {
        ruleSheet[ruleName] = function () {
          return rule;
        };
        ruleSheet[ruleName].ruleName = ruleName;
      }

      return ruleSheet;
    }, {});
  }
});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowCompare
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */
function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

module.exports = shallowCompare;


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateDisplayName;
function generateDisplayName(component) {
  var displayName = component.displayName || component.name;

  if (displayName) {
    return 'Fela' + displayName;
  }

  return 'ConnectedFelaComponent';
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createComponentFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fela__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoistStatics__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extractPassThroughProps__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extractUsedProps__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resolvePassThrough__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resolveUsedProps__ = __webpack_require__(151);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









function createComponentFactory(createElement, withTheme, contextTypes) {
  var withProxy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var alwaysPassThroughProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  return function createComponent(rule) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
    var passThroughProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = rule.name ? rule.name : 'FelaComponent';

    var FelaComponent = function FelaComponent(_ref, _ref2) {
      var renderer = _ref2.renderer;

      var children = _ref.children,
          _felaTheme = _ref._felaTheme,
          _felaRule = _ref._felaRule,
          extend = _ref.extend,
          innerRef = _ref.innerRef,
          id = _ref.id,
          style = _ref.style,
          as = _ref.as,
          className = _ref.className,
          _ref$passThrough = _ref.passThrough,
          passThrough = _ref$passThrough === undefined ? [] : _ref$passThrough,
          otherProps = _objectWithoutProperties(_ref, ['children', '_felaTheme', '_felaRule', 'extend', 'innerRef', 'id', 'style', 'as', 'className', 'passThrough']);

      if (!renderer) {
        throw new Error("createComponent() can't render styles without the renderer in the context. Missing react-fela's <Provider /> at the app root?");
      }

      var usedProps = withProxy ? Object(__WEBPACK_IMPORTED_MODULE_3__extractUsedProps__["a" /* default */])(rule, _felaTheme) : [];

      var rules = [rule];
      if (_felaRule) {
        rules.push(_felaRule);
      }
      if (extend) {
        typeof extend === 'function' ? rules.push(extend) : rules.push(function () {
          return extend;
        });
      }
      var combinedRule = __WEBPACK_IMPORTED_MODULE_0_fela__["combineRules"].apply(undefined, rules);

      // improve developer experience with monolithic renderer
      if (false) {
        var componentName = typeof type === 'string' ? type : type.displayName || type.name || '';

        combinedRule.selectorPrefix = displayName + '_' + componentName + '_';
      }
      // compose passThrough props from arrays or functions
      var resolvedPassThrough = [].concat(_toConsumableArray(alwaysPassThroughProps), _toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_4__resolvePassThrough__["a" /* default */])(passThroughProps, otherProps)), _toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_4__resolvePassThrough__["a" /* default */])(passThrough, otherProps)), _toConsumableArray(withProxy ? Object(__WEBPACK_IMPORTED_MODULE_5__resolveUsedProps__["a" /* default */])(usedProps, otherProps) : []));

      var ruleProps = _extends({}, otherProps, {
        theme: _felaTheme,
        as: as,
        id: id

        // if the component renders into another Fela component
        // we pass down the combinedRule as well as both
      });if (type._isFelaComponent) {
        return createElement(type, _extends({
          _felaRule: combinedRule,
          passThrough: resolvedPassThrough,
          innerRef: innerRef,
          style: style,
          className: className,
          as: as,
          id: id
        }, otherProps), children);
      }

      var componentProps = Object(__WEBPACK_IMPORTED_MODULE_2__extractPassThroughProps__["a" /* default */])(resolvedPassThrough, otherProps);

      // fela-native support
      if (renderer.isNativeRenderer) {
        var felaStyle = renderer.renderRule(combinedRule, ruleProps);
        componentProps.style = style ? [style, felaStyle] : felaStyle;
      } else {
        if (style) {
          componentProps.style = style;
        }

        var cls = className ? className + ' ' : '';
        componentProps.className = cls + renderer.renderRule(combinedRule, ruleProps);
      }

      if (id) {
        componentProps.id = id;
      }

      if (innerRef) {
        componentProps.ref = innerRef;
      }

      var customType = as || type;
      return createElement(customType, componentProps, children);
    };

    if (contextTypes) {
      FelaComponent.contextTypes = contextTypes;
    }

    // use the rule name as display name to better debug with react inspector
    FelaComponent.displayName = displayName;
    FelaComponent._isFelaComponent = true;

    var themedComponent = withTheme(FelaComponent, '_felaTheme');
    return Object(__WEBPACK_IMPORTED_MODULE_1__hoistStatics__["a" /* default */])(themedComponent, type);
  };
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractPassThroughProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);


function extractPassThroughProps(passThrough, ruleProps) {
  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(passThrough, function (output, property) {
    if (ruleProps.hasOwnProperty(property)) {
      output[property] = ruleProps[property];
    }

    return output;
  }, {});
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractUsedProps;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function extractUsedProps(rule) {
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var usedProps = [];

  // if the browser doesn't support proxies
  // we simply return an empty props object
  // see https://github.com/rofrischmann/fela/issues/468
  if (typeof Proxy === 'undefined') {
    return usedProps;
  }

  var handler = function handler(props) {
    return {
      get: function get(target, key) {
        if (_typeof(target[key]) === 'object' && target[key] !== null) {
          props.push(key);
          return target[key];
        }
        props.push(key);
        return target[key];
      }
    };
  };

  var proxy = new Proxy({ theme: theme }, handler(usedProps));
  rule(proxy);
  return usedProps;
}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resolvePassThrough;
function resolvePassThrough(passThrough, ruleProps) {
  if (typeof passThrough === 'function') {
    return passThrough(ruleProps);
  }

  return passThrough;
}

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resolveUsedProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce__);


function resolveUsedProps(props, src) {
  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectReduce___default()(src, function (output, value, prop) {
    if (props.indexOf(prop) === -1 && prop !== 'innerRef' && prop !== 'is') {
      output.push(prop);
    }

    return output;
  }, []);
}

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FelaComponentFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resolveRule__ = __webpack_require__(153);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function FelaComponentFactory(createElement, FelaTheme, contextTypes) {
  function FelaComponent(_ref, _ref2) {
    var renderer = _ref2.renderer;

    var children = _ref.children,
        customClass = _ref.customClass,
        _ref$render = _ref.render,
        _render = _ref$render === undefined ? 'div' : _ref$render,
        rule = _ref.rule,
        style = _ref.style,
        restProps = _objectWithoutProperties(_ref, ['children', 'customClass', 'render', 'rule', 'style']);

    return createElement(FelaTheme, {
      render: function render(theme) {
        var props = rule ? _extends({ theme: theme }, restProps) : theme;

        var className = '' + (customClass ? customClass + ' ' : '') + renderer._renderStyle(Object(__WEBPACK_IMPORTED_MODULE_0__resolveRule__["a" /* default */])(rule || style, props, renderer), props);

        if (_render instanceof Function) {
          return _render({
            className: className,
            theme: theme
          });
        }

        return createElement(_render, { className: className }, children);
      }
    });
  }

  if (contextTypes) {
    FelaComponent.contextTypes = contextTypes;
  }

  return FelaComponent;
}

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resolveRule;
function resolveRule(rule) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var renderer = arguments[2];

  if (rule instanceof Function) {
    return rule(props, renderer);
  }

  return rule;
}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FelaThemeFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeChannel__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



function FelaThemeFactory(BaseComponent, contextTypes) {
  var FelaTheme = function (_BaseComponent) {
    _inherits(FelaTheme, _BaseComponent);

    function FelaTheme(props, context) {
      _classCallCheck(this, FelaTheme);

      var _this = _possibleConstructorReturn(this, (FelaTheme.__proto__ || Object.getPrototypeOf(FelaTheme)).call(this, props, context));

      _this.state = {
        theme: context[__WEBPACK_IMPORTED_MODULE_0__themeChannel__["a" /* THEME_CHANNEL */]] ? context[__WEBPACK_IMPORTED_MODULE_0__themeChannel__["a" /* THEME_CHANNEL */]].get() : {}
      };
      return _this;
    }

    _createClass(FelaTheme, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        if (this.context[__WEBPACK_IMPORTED_MODULE_0__themeChannel__["a" /* THEME_CHANNEL */]]) {
          this.unsubscribe = this.context[__WEBPACK_IMPORTED_MODULE_0__themeChannel__["a" /* THEME_CHANNEL */]].subscribe(function (properties) {
            return _this2.setState({
              theme: properties
            });
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return this.props.render(this.state.theme);
      }
    }]);

    return FelaTheme;
  }(BaseComponent);

  if (contextTypes) {
    FelaTheme.contextTypes = contextTypes;
  }

  return FelaTheme;
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProviderFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fela_dom__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function hasDOM(renderer) {
  return renderer && !renderer.isNativeRenderer && typeof window !== 'undefined' && window.document && window.document.createElement;
}

function ProviderFactory(BaseComponent, renderChildren, statics) {
  var Provider = function (_BaseComponent) {
    _inherits(Provider, _BaseComponent);

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props, context));

      if (props.rehydrate && hasDOM(props.renderer)) {
        Object(__WEBPACK_IMPORTED_MODULE_0_fela_dom__["a" /* rehydrate */])(props.renderer);
      }
      return _this;
    }

    _createClass(Provider, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (this.props.renderToDOM && hasDOM(this.props.renderer)) {
          Object(__WEBPACK_IMPORTED_MODULE_0_fela_dom__["b" /* render */])(this.props.renderer);
        }
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          renderer: this.props.renderer
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return renderChildren(this.props.children);
      }
    }]);

    return Provider;
  }(BaseComponent);

  if (statics) {
    __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach___default()(statics, function (value, key) {
      Provider[key] = value;
    });
  }

  return Provider;
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_render__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_rehydration_rehydrate__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__server_renderToMarkup__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__server_renderToSheetList__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__dom_render__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__dom_rehydration_rehydrate__["a"]; });
/* unused harmony reexport renderToMarkup */
/* unused harmony reexport renderToSheetList */








/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = render;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createDOMSubscription__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connectDOMNodes__ = __webpack_require__(161);



function render(renderer) {
  if (!renderer.updateSubscription) {
    Object(__WEBPACK_IMPORTED_MODULE_1__connectDOMNodes__["a" /* default */])(renderer);

    renderer.updateSubscription = Object(__WEBPACK_IMPORTED_MODULE_0__createDOMSubscription__["a" /* default */])(renderer.nodes);
    renderer.subscribe(renderer.updateSubscription);
  }
}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDOMSubscription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectEach__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDOMNode__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generateRule__ = __webpack_require__(160);
var _changeHandlers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable consistent-return */






var changeHandlers = (_changeHandlers = {}, _defineProperty(_changeHandlers, __WEBPACK_IMPORTED_MODULE_1_fela_utils__["d" /* RULE_TYPE */], function (node, _ref) {
  var selector = _ref.selector,
      declaration = _ref.declaration,
      support = _ref.support;

  var cssRule = Object(__WEBPACK_IMPORTED_MODULE_3__generateRule__["a" /* default */])(selector, declaration, support);

  // only use insertRule in production as browser devtools might have
  // weird behavior if used together with insertRule at runtime
  if (false) {
    node.textContent += cssRule;
    return;
  }

  try {
    node.sheet.insertRule(cssRule, node.sheet.cssRules.length);
  } catch (e) {
    // TODO: warning?
  }
}), _defineProperty(_changeHandlers, __WEBPACK_IMPORTED_MODULE_1_fela_utils__["c" /* KEYFRAME_TYPE */], function (node, _ref2) {
  var keyframe = _ref2.keyframe;

  node.textContent += keyframe;
}), _defineProperty(_changeHandlers, __WEBPACK_IMPORTED_MODULE_1_fela_utils__["b" /* FONT_TYPE */], function (node, _ref3) {
  var fontFace = _ref3.fontFace;

  node.textContent += fontFace;
}), _defineProperty(_changeHandlers, __WEBPACK_IMPORTED_MODULE_1_fela_utils__["e" /* STATIC_TYPE */], function (node, _ref4) {
  var selector = _ref4.selector,
      css = _ref4.css;

  if (selector) {
    node.textContent += Object(__WEBPACK_IMPORTED_MODULE_1_fela_utils__["h" /* generateCSSRule */])(selector, css);
  } else {
    node.textContent += css;
  }
}), _changeHandlers);

function createDOMSubscription(nodes) {
  var baseNode = nodes[__WEBPACK_IMPORTED_MODULE_1_fela_utils__["d" /* RULE_TYPE */]];

  return function changeSubscription(change) {
    if (change.type === __WEBPACK_IMPORTED_MODULE_1_fela_utils__["a" /* CLEAR_TYPE */]) {
      return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectEach___default()(nodes, function (node) {
        node.textContent = '';
      });
    }

    var handleChange = changeHandlers[change.type];

    if (handleChange) {
      var node = Object(__WEBPACK_IMPORTED_MODULE_2__getDOMNode__["a" /* default */])(nodes, baseNode, change.type, change.media, !!change.support);

      handleChange(node, change);
    }
  };
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDOMNode;
function getDocumentHead() {
  return document.head || {};
}

function createDOMNode(type, anchorNode) {
  var media = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var support = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var head = getDocumentHead();

  var node = document.createElement('style');
  node.setAttribute('data-fela-type', type);
  node.type = 'text/css';

  if (support) {
    node.setAttribute('data-fela-support', 'true');
  }

  if (media.length > 0) {
    node.media = media;
  }

  var parentNode = anchorNode ? anchorNode.parentNode : head;

  if (support || media.length > 0) {
    parentNode.appendChild(node);
  } else if (anchorNode) {
    parentNode.insertBefore(node, anchorNode);
  } else {
    parentNode.appendChild(node);
  }

  return node;
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fela_utils__ = __webpack_require__(4);


function generateRule(selector, declaration) {
  var support = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var rule = Object(__WEBPACK_IMPORTED_MODULE_0_fela_utils__["h" /* generateCSSRule */])(selector, declaration);

  if (support.length > 0) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_fela_utils__["j" /* generateCSSSupportRule */])(support, rule);
  }

  return rule;
}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectDOMNodes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectEach__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayEach__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fela_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__initDOMNode__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__findDOMNodes__ = __webpack_require__(163);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function connectDOMNodes(renderer) {
  renderer.nodes = Object(__WEBPACK_IMPORTED_MODULE_4__findDOMNodes__["a" /* default */])();

  var cacheCluster = Object(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["f" /* clusterCache */])(renderer.cache, renderer.mediaQueryOrder, renderer.supportQueryOrder);

  var baseNode = renderer.nodes[__WEBPACK_IMPORTED_MODULE_2_fela_utils__["d" /* RULE_TYPE */]];

  __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_objectEach___default()(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["s" /* sheetMap */], function (type, key) {
    if (cacheCluster[key].length > 0) {
      Object(__WEBPACK_IMPORTED_MODULE_3__initDOMNode__["a" /* default */])(renderer.nodes, baseNode, cacheCluster[key], type);
    }
  });

  var support = Object(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["g" /* cssifySupportRules */])(cacheCluster.supportRules);

  if (support) {
    Object(__WEBPACK_IMPORTED_MODULE_3__initDOMNode__["a" /* default */])(renderer.nodes, baseNode, support, __WEBPACK_IMPORTED_MODULE_2_fela_utils__["d" /* RULE_TYPE */], '', true);
  }

  var mediaKeys = Object.keys(_extends({}, cacheCluster.supportMediaRules, cacheCluster.mediaRules));

  __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_arrayEach___default()(mediaKeys, function (media) {
    if (cacheCluster.mediaRules[media] && cacheCluster.mediaRules[media].length > 0) {
      Object(__WEBPACK_IMPORTED_MODULE_3__initDOMNode__["a" /* default */])(renderer.nodes, baseNode, cacheCluster.mediaRules[media], __WEBPACK_IMPORTED_MODULE_2_fela_utils__["d" /* RULE_TYPE */], media);
    }

    if (cacheCluster.supportMediaRules[media]) {
      var mediaSupport = Object(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["g" /* cssifySupportRules */])(cacheCluster.supportMediaRules[media]);

      if (mediaSupport.length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_3__initDOMNode__["a" /* default */])(renderer.nodes, baseNode, mediaSupport, __WEBPACK_IMPORTED_MODULE_2_fela_utils__["d" /* RULE_TYPE */], media, true);
      }
    }
  });
}

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initDOMNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getDOMNode__ = __webpack_require__(47);


function initDOMNode(nodes, baseNode, css, type) {
  var media = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var support = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  var node = Object(__WEBPACK_IMPORTED_MODULE_0__getDOMNode__["a" /* default */])(nodes, baseNode, type, media, support);
  // in case that there is a node coming from server already
  // but rules are not matchnig
  if (node.textContent !== css) {
    node.textContent = css;
  }
}

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findDOMNodes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);


function findDOMNodes() {
  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(document.querySelectorAll('[data-fela-type]'), function (nodes, node) {
    var type = node.getAttribute('data-fela-type') || '';
    var media = node.getAttribute('media') || '';
    var support = node.getAttribute('support') ? 'support' : '';

    nodes[type + media + support] = node;
    return nodes;
  }, {});
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rehydrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rehydrateSupportRules__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rehydrateRules__ = __webpack_require__(48);






// rehydration (WIP)
// TODO: static, keyframe, font
function rehydrate(renderer) {
  __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayEach___default()(document.querySelectorAll('[data-fela-type]'), function (node) {
    var rehydrationAttribute = node.getAttribute('data-fela-rehydration') || -1;
    var rehydrationIndex = renderer.uniqueRuleIdentifier || parseInt(rehydrationAttribute, 10);

    // skip rehydration if no rehydration index is set
    // this index is set to -1 if something blocks rehydration
    if (rehydrationIndex !== -1) {
      var type = node.getAttribute('data-fela-type') || '';
      var media = node.getAttribute('media') || '';
      var support = node.getAttribute('data-fela-support');
      var css = node.textContent;

      renderer.uniqueRuleIdentifier = rehydrationIndex;

      if (type === __WEBPACK_IMPORTED_MODULE_1_fela_utils__["d" /* RULE_TYPE */]) {
        if (support) {
          Object(__WEBPACK_IMPORTED_MODULE_2__rehydrateSupportRules__["a" /* default */])(css, media, renderer.cache);
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_3__rehydrateRules__["a" /* default */])(css, media, '', renderer.cache);
        }
      }
    }
  });

  renderer._emitChange({ type: 'REHYDRATATION_FINISHED' });
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rehydrateSupportRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractSupportQuery__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rehydrateRules__ = __webpack_require__(48);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




var SUPPORT_REGEX = /@supports[^{]+\{([\s\S]+?})\s*}/gi;

function rehydrateSupportRules(css) {
  var media = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var cache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var decl = void 0;

  while (decl = SUPPORT_REGEX.exec(css)) {
    var _decl = decl,
        _decl2 = _slicedToArray(_decl, 2),
        ruleSet = _decl2[0],
        cssRules = _decl2[1];

    var supportQuery = Object(__WEBPACK_IMPORTED_MODULE_0__extractSupportQuery__["a" /* default */])(ruleSet);
    Object(__WEBPACK_IMPORTED_MODULE_1__rehydrateRules__["a" /* default */])(cssRules, media, supportQuery, cache);
  }

  return cache;
}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractSupportQuery;
function extractSupportQuery(ruleSet) {
  return ruleSet.split('{')[0].slice(9).trim();
}

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateCacheEntry;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fela_utils__ = __webpack_require__(4);


function generateCacheEntry(type, className, property, value) {
  var pseudo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var media = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var support = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';

  return {
    type: type,
    className: className,
    selector: Object(__WEBPACK_IMPORTED_MODULE_0_fela_utils__["i" /* generateCSSSelector */])(className, pseudo),
    declaration: property + ':' + value,
    pseudo: pseudo,
    media: media,
    support: support
  };
}

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateDeclarationReference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_camelCaseProperty__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_camelCaseProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_camelCaseProperty__);


function generateDeclarationReference(property, value) {
  var pseudo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var media = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var support = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

  return support + media + pseudo + __WEBPACK_IMPORTED_MODULE_0_css_in_js_utils_lib_camelCaseProperty___default()(property) + value;
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelCaseProperty;
var dashRegex = /-([a-z])/g;
var msRegex = /^Ms/g;

function camelCaseProperty(property) {
  return property.replace(dashRegex, function (match) {
    return match[1].toUpperCase();
  }).replace(msRegex, 'ms');
}
module.exports = exports['default'];

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fela_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createStyleTagMarkup__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRehydrationIndex__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function renderToMarkup(renderer) {
  var cacheCluster = Object(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["f" /* clusterCache */])(renderer.cache, renderer.mediaQueryOrder, renderer.supportQueryOrder);

  var rehydrationIndex = Object(__WEBPACK_IMPORTED_MODULE_4__getRehydrationIndex__["a" /* default */])(renderer);

  var styleMarkup = __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce___default()(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["s" /* sheetMap */], function (markup, type, key) {
    if (cacheCluster[key].length > 0) {
      markup += Object(__WEBPACK_IMPORTED_MODULE_3__createStyleTagMarkup__["a" /* default */])(cacheCluster[key], type, '', rehydrationIndex);
    }

    return markup;
  }, '');

  var support = Object(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["g" /* cssifySupportRules */])(cacheCluster.supportRules);

  if (support) {
    styleMarkup += Object(__WEBPACK_IMPORTED_MODULE_3__createStyleTagMarkup__["a" /* default */])(support, __WEBPACK_IMPORTED_MODULE_2_fela_utils__["d" /* RULE_TYPE */], '', rehydrationIndex, true);
  }

  var mediaKeys = Object.keys(_extends({}, cacheCluster.supportMediaRules, cacheCluster.mediaRules));

  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(mediaKeys, function (markup, media) {
    // basic media query rules
    if (cacheCluster.mediaRules[media] && cacheCluster.mediaRules[media].length > 0) {
      markup += Object(__WEBPACK_IMPORTED_MODULE_3__createStyleTagMarkup__["a" /* default */])(cacheCluster.mediaRules[media], __WEBPACK_IMPORTED_MODULE_2_fela_utils__["d" /* RULE_TYPE */], media, rehydrationIndex);
    }

    // support media rules
    if (cacheCluster.supportMediaRules[media]) {
      var mediaSupport = Object(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["g" /* cssifySupportRules */])(cacheCluster.supportMediaRules[media]);

      if (mediaSupport.length > 0) {
        markup += Object(__WEBPACK_IMPORTED_MODULE_3__createStyleTagMarkup__["a" /* default */])(mediaSupport, __WEBPACK_IMPORTED_MODULE_2_fela_utils__["d" /* RULE_TYPE */], media, rehydrationIndex, true);
      }
    }

    return markup;
  }, styleMarkup);
}

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStyleMarkup;


function createStyleMarkup(css, type) {
  var media = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var rehydrationIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
  var support = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var mediaAttribute = media.length > 0 ? ' media="' + media + '"' : '';
  var supportAttribute = support ? ' data-fela-support="true"' : '';

  return '<style type="text/css" data-fela-rehydration="' + rehydrationIndex + '" data-fela-type="' + type + '"' + supportAttribute + mediaAttribute + '>' + css + '</style>';
}

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fela_utils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRehydrationIndex__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function renderToSheetList(renderer) {
  var cacheCluster = Object(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["f" /* clusterCache */])(renderer.cache, renderer.mediaQueryOrder, renderer.supportQueryOrder);

  var rehydrationIndex = Object(__WEBPACK_IMPORTED_MODULE_3__getRehydrationIndex__["a" /* default */])(renderer);

  var sheetList = __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectReduce___default()(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["s" /* sheetMap */], function (list, type, key) {
    if (cacheCluster[key].length > 0) {
      list.push({
        css: cacheCluster[key],
        rehydration: rehydrationIndex,
        type: type
      });
    }

    return list;
  }, []);

  var support = Object(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["g" /* cssifySupportRules */])(cacheCluster.supportRules);

  if (support) {
    sheetList.push({
      css: support,
      type: __WEBPACK_IMPORTED_MODULE_2_fela_utils__["d" /* RULE_TYPE */],
      rehydration: rehydrationIndex,
      support: true
    });
  }

  var mediaKeys = Object.keys(_extends({}, cacheCluster.supportMediaRules, cacheCluster.mediaRules));

  return __WEBPACK_IMPORTED_MODULE_0_fast_loops_lib_arrayReduce___default()(mediaKeys, function (list, media) {
    // basic media query rules
    if (cacheCluster.mediaRules[media] && cacheCluster.mediaRules[media].length > 0) {
      list.push({
        css: cacheCluster.mediaRules[media],
        type: __WEBPACK_IMPORTED_MODULE_2_fela_utils__["d" /* RULE_TYPE */],
        rehydration: rehydrationIndex,
        media: media
      });
    }

    // support media rules
    if (cacheCluster.supportMediaRules[media]) {
      var mediaSupport = Object(__WEBPACK_IMPORTED_MODULE_2_fela_utils__["g" /* cssifySupportRules */])(cacheCluster.supportMediaRules[media]);

      if (mediaSupport.length > 0) {
        list.push({
          css: mediaSupport,
          type: __WEBPACK_IMPORTED_MODULE_2_fela_utils__["d" /* RULE_TYPE */],
          rehydration: rehydrationIndex,
          support: true,
          media: media
        });
      }
    }

    return list;
  }, sheetList);
}

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ThemeProviderFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shallow_equal_objects__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shallow_equal_objects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shallow_equal_objects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createTheme__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themeChannel__ = __webpack_require__(17);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function ThemeProviderFactory(BaseComponent, renderChildren, statics) {
  var ThemeProvider = function (_BaseComponent) {
    _inherits(ThemeProvider, _BaseComponent);

    function ThemeProvider(props, context) {
      _classCallCheck(this, ThemeProvider);

      var _this = _possibleConstructorReturn(this, (ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call(this, props, context));

      var previousTheme = !props.overwrite && _this.context[__WEBPACK_IMPORTED_MODULE_3__themeChannel__["a" /* THEME_CHANNEL */]];
      _this.theme = Object(__WEBPACK_IMPORTED_MODULE_2__createTheme__["a" /* default */])(props.theme, previousTheme);
      return _this;
    }

    _createClass(ThemeProvider, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_0_shallow_equal_objects___default()(this.props.theme, nextProps.theme)) {
          this.theme.update(nextProps.theme);
        }
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__themeChannel__["a" /* THEME_CHANNEL */], this.theme);
      }
    }, {
      key: 'render',
      value: function render() {
        return renderChildren(this.props.children);
      }
    }]);

    return ThemeProvider;
  }(BaseComponent);

  if (statics) {
    __WEBPACK_IMPORTED_MODULE_1_fast_loops_lib_objectEach___default()(statics, function (value, key) {
      ThemeProvider[key] = value;
    });
  }

  return ThemeProvider;
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function shallowEqualObjects(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (!objA || !objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var len = aKeys.length;

  if (bKeys.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqualObjects;


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withThemeFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hoistStatics__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themeChannel__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function withThemeFactory(BaseComponent, createElement, contextTypes) {
  return function withTheme(component) {
    var propName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'theme';

    var WithTheme = function (_BaseComponent) {
      _inherits(WithTheme, _BaseComponent);

      function WithTheme(props, context) {
        _classCallCheck(this, WithTheme);

        var _this = _possibleConstructorReturn(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props, context));

        _this.state = {
          theme: context[__WEBPACK_IMPORTED_MODULE_1__themeChannel__["a" /* THEME_CHANNEL */]] ? context[__WEBPACK_IMPORTED_MODULE_1__themeChannel__["a" /* THEME_CHANNEL */]].get() : {}
        };
        return _this;
      }

      _createClass(WithTheme, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var _this2 = this;

          if (this.context[__WEBPACK_IMPORTED_MODULE_1__themeChannel__["a" /* THEME_CHANNEL */]]) {
            this.unsubscribe = this.context[__WEBPACK_IMPORTED_MODULE_1__themeChannel__["a" /* THEME_CHANNEL */]].subscribe(function (properties) {
              return _this2.setState({
                theme: properties
              });
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.unsubscribe) {
            this.unsubscribe();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return createElement(component, _extends({}, this.props, _defineProperty({}, propName, this.state.theme)));
        }
      }]);

      return WithTheme;
    }(BaseComponent);

    if (contextTypes) {
      WithTheme.contextTypes = contextTypes;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__hoistStatics__["a" /* default */])(WithTheme, component);
  };
}

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = feFactory;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Fe was heavily inspired by glam, both the code as well as the name
// https://github.com/threepointone/glam/blob/master/packages/glam/src/index.js#L83
function feFactory(createElement, FelaComponent) {
  return function fe(type) {
    for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      children[_key - 2] = arguments[_key];
    }

    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var css = props.css,
        className = props.className,
        otherProps = _objectWithoutProperties(props, ["css", "className"]);

    if (css) {
      return createElement(FelaComponent, {
        style: css,
        customClass: className,
        render: function render(renderProps) {
          return createElement.apply(undefined, [type, _extends({}, otherProps, {
            className: renderProps.className
          })].concat(_toConsumableArray(children)));
        }
      });
    }

    return createElement.apply(undefined, [type, props].concat(_toConsumableArray(children)));
  };
}

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_bindings__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withTheme__ = __webpack_require__(18);





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_fela_bindings__["f" /* createComponentFactory */])(__WEBPACK_IMPORTED_MODULE_0_preact__["h"], __WEBPACK_IMPORTED_MODULE_2__withTheme__["a" /* default */]));

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_bindings__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withTheme__ = __webpack_require__(18);





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_fela_bindings__["f" /* createComponentFactory */])(__WEBPACK_IMPORTED_MODULE_0_preact__["h"], __WEBPACK_IMPORTED_MODULE_2__withTheme__["a" /* default */], undefined, true));

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_bindings__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_fela_bindings__["c" /* ProviderFactory */])(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"], function (children) {
  return children[0];
}, {
  defaultProps: {
    renderToDOM: true,
    rehydrate: true
  }
}));

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_bindings__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_fela_bindings__["d" /* ThemeProviderFactory */])(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"], function (children) {
  return children[0];
}, {
  defaultProps: {
    overwrite: false
  }
}));

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fela_bindings__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FelaComponent__ = __webpack_require__(51);





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_fela_bindings__["g" /* feFactory */])(__WEBPACK_IMPORTED_MODULE_0_preact__["h"], __WEBPACK_IMPORTED_MODULE_2__FelaComponent__["a" /* default */]));

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _constants = __webpack_require__(9);

var _Header = __webpack_require__(183);

var _Header2 = _interopRequireDefault(_Header);

var _style = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var keyframeSlideDown = function keyframeSlideDown(_ref) {
  var size = _ref.size;
  return {
    '0%': {
      transform: 'translateY(' + size + ')'
    },
    '100%': {
      transform: 'translateY(0px)'
    }
  };
};

var keyframeOpacityIn = function keyframeOpacityIn() {
  return {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  };
};

var wrapper = function wrapper(_ref2) {
  var inScroll = _ref2.inScroll,
      mobile = _ref2.mobile;
  return _extends({
    position: inScroll ? 'fixed' : 'absolute',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    fontWeight: 'normal',
    lineHeight: 'normal',
    zIndex: 1030,
    transition: 'top 0.2s ease-in-out',
    willChange: 'top',
    boxShadow: inScroll ? '0 2px 4px 0 rgba(0, 0, 0, 0.1)' : 'none'
  }, !mobile && {
    animationDuration: '0.3s',
    animationName: _style.renderer.renderKeyframe(inScroll ? keyframeSlideDown : keyframeOpacityIn, { size: '-200px' })
  });
};

var Wrapper = (0, _preactFela.createComponent)(wrapper);

var Container = function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref3, [this].concat(args))), _this), _this.delta = 5, _this.lastScrollTop = window.scrollY, _this.state = {
      mobile: window.matchMedia('(max-width: ' + _constants.BREAKPOINT.DESKTOP + ')').matches,
      inScroll: _this.lastScrollTop > 104,
      windowHeight: window.innerHeight * 0.8
    }, _this.handleMedia = function (_ref4) {
      var matches = _ref4.matches;

      _this.setState({ mobile: matches });
    }, _this.handleScroll = function () {
      var scrollY = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY;
      var inScroll = scrollY > 104;

      if (_this.state.inScroll && !inScroll) {
        _this.setState({ inScroll: false });
      } else if (!_this.state.inScroll && inScroll) {
        _this.setState({ inScroll: true });
      }
    }, _this.handleResize = function () {
      _this.setState({ windowHeight: window.innerHeight * 0.8 });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Container, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var media = window.matchMedia('(max-width: ' + _constants.BREAKPOINT.DESKTOP + ')');
      media.addListener(this.handleMedia);

      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      return (0, _preact.h)(
        Wrapper,
        { inScroll: this.state.inScroll },
        (0, _preact.h)(_Header2.default, this.state)
      );
    }
  }]);

  return Container;
}(_preact.Component);

exports.default = Container;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(184);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Header).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _preact2 = __webpack_require__(7);

var _preactFela = __webpack_require__(1);

var _actions = __webpack_require__(6);

var _keyframes = __webpack_require__(185);

var _Navbar = __webpack_require__(187);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _HeaderProfile = __webpack_require__(199);

var _HeaderProfile2 = _interopRequireDefault(_HeaderProfile);

var _HeaderMenu = __webpack_require__(204);

var _HeaderMenu2 = _interopRequireDefault(_HeaderMenu);

var _HeaderBrand = __webpack_require__(206);

var _HeaderBrand2 = _interopRequireDefault(_HeaderBrand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var rules = function rules(_ref) {
  var inScroll = _ref.inScroll,
      menus = _ref.menus,
      theme = _ref.theme,
      loggedIn = _ref.loggedIn;

  var background = inScroll ? theme.backgroundInScroll : theme.gradient == 'true' ? theme.gradientColor : theme.background;
  background = background || theme.background || theme.color;
  var hasMenus = menus.length;
  return {
    header: {
      height: '48px',
      background: background,
      desktop: {
        minHeight: inScroll ? 'auto' : hasMenus ? '109px' : '68px',
        height: inScroll ? '56px' : undefined
      }
    },
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: !inScroll || loggedIn ? 'center' : 'space-between',

      desktop: {
        position: 'relative',
        boxSizing: 'border-box',
        justifyContent: 'space-between',
        maxWidth: theme.full ? '100%' : '1170px',
        padding: '0 15px 0 0',
        margin: 'auto',
        height: inScroll ? '100%' : '68px'
      }
    }
  };
};

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.mobile === false && props.heimdall.dropdown.menu) {
        this.props.handleOpenMenu('menu');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          mobile = _props.mobile,
          inScroll = _props.inScroll,
          loggedIn = _props.loggedIn,
          product = _props.product,
          brand = _props.brand,
          config = _props.config,
          heimdall = _props.heimdall,
          styles = _props.styles;

      var defaultProps = { mobile: mobile, inScroll: inScroll, loggedIn: loggedIn, config: config };

      return (0, _preact.h)(
        'header',
        { className: styles.header },
        (0, _preact.h)(
          'div',
          { className: styles.container },
          (0, _preact.h)(_HeaderMenu2.default, _extends({}, defaultProps, { onOpenMenu: this.props.handleOpenMenu })),
          (0, _preact.h)(_HeaderBrand2.default, _extends({}, defaultProps, { brand: brand, product: product, heimdall: heimdall })),
          (0, _preact.h)(_Navbar2.default, _extends({}, defaultProps, { goMenu: this.props.goMenu })),
          (0, _preact.h)(_HeaderProfile2.default, defaultProps)
        )
      );
    }
  }]);

  return Header;
}(_preact.Component);

exports.default = (0, _preact2.connect)('product,loggedIn,menus,brand,config,heimdall', {
  handleOpenMenu: function handleOpenMenu(menu) {
    return (0, _actions.toggleMenuDropdown)(menu);
  },
  goMenu: _actions.goMenu
})((0, _preactFela.connect)(rules)(Header));

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.opacityIn = exports.slideDown = exports.scaleUp = undefined;

var _styles = __webpack_require__(186);

var keyframeShow = function keyframeShow() {
  return {
    '0%': {
      transform: 'scale(0)'
    },
    '100%': {
      transform: 'scale(1)'
    }
  };
};

var keyframeSlideDown = function keyframeSlideDown(_ref) {
  var size = _ref.size;
  return {
    '0%': {
      transform: 'translateY(' + size + ')'
    },
    '100%': {
      transform: 'translateY(0px)'
    }
  };
};

var keyframeOpacityIn = function keyframeOpacityIn() {
  return {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  };
};

var scaleUp = exports.scaleUp = function scaleUp(props) {
  return _styles.renderer.renderKeyframe(keyframeShow, props);
};
var slideDown = exports.slideDown = function slideDown(props) {
  return _styles.renderer.renderKeyframe(keyframeSlideDown, props);
};
var opacityIn = exports.opacityIn = function opacityIn(props) {
  return _styles.renderer.renderKeyframe(keyframeOpacityIn, props);
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _fela = __webpack_require__(16);

var _preactFela = __webpack_require__(1);

var _preact2 = __webpack_require__(7);

var _felaPluginNamedKeys = __webpack_require__(53);

var _felaPluginNamedKeys2 = _interopRequireDefault(_felaPluginNamedKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import './style.scss'

var namedKeysPlugin = (0, _felaPluginNamedKeys2.default)({
  desktop: '@media (min-width: 1024px)'
});

var renderer = exports.renderer = (0, _fela.createRenderer)({
  selectorPrefix: 'ecs_hl_',
  plugins: [namedKeysPlugin]
});

var Styled = function (_Component) {
  _inherits(Styled, _Component);

  function Styled() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Styled);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Styled.__proto__ || Object.getPrototypeOf(Styled)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      theme: {}
    }, _this.handleTheme = function () {
      var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.product;
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.config;

      _this.setState({
        theme: {
          key: product,
          full: config.full,
          background: config.background,
          backgroundInScroll: config.backgroundInScroll,
          color: config.color,
          gradient: (config.gradient || false).toString(),
          gradientColor: config.gradientColor,
          inverseColor: config.inverseColor
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Styled, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleTheme();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.handleTheme(props.product, props.config);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var theme = this.state.theme;


      return (0, _preact.h)(
        _preactFela.Provider,
        { renderer: renderer },
        (0, _preact.h)(
          _preactFela.ThemeProvider,
          { theme: theme },
          children
        )
      );
    }
  }]);

  return Styled;
}(_preact.Component);

exports.default = (0, _preact2.connect)(function (_ref2) {
  var product = _ref2.product,
      config = _ref2.config;
  return {
    product: product,
    config: config
  };
})(Styled);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Navbar = __webpack_require__(188);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Navbar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _preact2 = __webpack_require__(7);

var _NavbarDesktop = __webpack_require__(189);

var _NavbarDesktop2 = _interopRequireDefault(_NavbarDesktop);

var _NavbarMobile = __webpack_require__(196);

var _NavbarMobile2 = _interopRequireDefault(_NavbarMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _preact2.connect)('menus,loggedIn,profile')(function (props) {
  var mobile = props.mobile,
      inScroll = props.inScroll,
      menus = props.menus,
      profile = props.profile,
      loggedIn = props.loggedIn,
      config = props.config,
      goMenu = props.goMenu;


  if (mobile) {
    return (0, _preact.h)(_NavbarMobile2.default, { menus: menus, loggedIn: loggedIn, profile: profile });
  }

  return (0, _preact.h)(_NavbarDesktop2.default, { menus: menus, config: config, inScroll: inScroll, goMenu: goMenu });
});

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _preact2 = __webpack_require__(7);

var _preactFela = __webpack_require__(1);

var _NavbarList = __webpack_require__(54);

var _NavbarList2 = _interopRequireDefault(_NavbarList);

var _NavbarSerasaConsumidor = __webpack_require__(60);

var _NavbarSerasaConsumidor2 = _interopRequireDefault(_NavbarSerasaConsumidor);

var _HeaderNotification = __webpack_require__(194);

var _HeaderNotification2 = _interopRequireDefault(_HeaderNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapperStyle = function wrapperStyle() {
  return {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  };
};

var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);

exports.default = (0, _preact2.connect)('menus,heimdall,notification,brand,product,loggedIn,login,signUp')(function (props) {
  var inScroll = props.inScroll,
      menus = props.menus,
      config = props.config,
      heimdall = props.heimdall,
      goMenu = props.goMenu,
      notification = props.notification,
      brand = props.brand,
      product = props.product,
      loggedIn = props.loggedIn,
      login = props.login,
      signUp = props.signUp;


  return (0, _preact.h)(
    Wrapper,
    null,
    (0, _preact.h)(_NavbarList2.default, {
      inScroll: inScroll,
      menus: menus,
      config: config,
      goMenu: goMenu,
      login: login,
      signUp: signUp,
      clicktype: 'menu'
    }),
    loggedIn && notification.active && (0, _preact.h)(_HeaderNotification2.default, {
      inScroll: inScroll,
      config: config,
      brand: brand,
      product: product
    }),
    (0, _preact.h)(_NavbarSerasaConsumidor2.default, {
      inScroll: inScroll,
      hasMenus: menus && menus.length,
      heimdall: heimdall,
      config: config,
      login: login,
      signUp: signUp
    })
  );
});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dropdown = __webpack_require__(191);

Object.defineProperty(exports, 'Dropdown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Dropdown).default;
  }
});

var _DropdownButton = __webpack_require__(58);

Object.defineProperty(exports, 'DropdownButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropdownButton).default;
  }
});

var _DropdownButtonIcon = __webpack_require__(59);

Object.defineProperty(exports, 'DropdownButtonIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropdownButtonIcon).default;
  }
});

var _DropdownWrapper = __webpack_require__(57);

Object.defineProperty(exports, 'DropdownWrapper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropdownWrapper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _DropdownWrapper = __webpack_require__(57);

var _DropdownWrapper2 = _interopRequireDefault(_DropdownWrapper);

var _DropdownButton = __webpack_require__(58);

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _DropdownButtonIcon = __webpack_require__(59);

var _DropdownButtonIcon2 = _interopRequireDefault(_DropdownButtonIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dropdownContentStyles = function dropdownContentStyles(_ref) {
  var open = _ref.open,
      inside = _ref.inside,
      mobile = _ref.mobile;
  return _extends({
    position: !inside ? 'fixed' : null,
    display: open ? 'block' : 'none',
    top: '48px',
    left: 0,
    width: '100%',
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    padding: !inside ? mobile && '16px' || '24px' : null,
    boxShadow: !inside ? '0 2px 4px 0 rgba(0, 0, 0, 0.1)' : null
  }, mobile && {
    overflowX: 'hidden',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch'

  }, {
    desktop: {
      position: 'absolute',
      top: '100%',
      left: '50%',
      width: 'auto',
      borderRadius: '3px',
      overflow: 'hidden',
      transform: 'translateX(-50%)',
      display: open ? 'flex' : 'none',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'flex-start'
    }
  });
};
var DropdownContent = (0, _preactFela.createComponent)(dropdownContentStyles);

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.ref = null;

    _this.toggleDropdown = function () {
      return _this.props.toggle();
    };

    _this.handleDocumentClick = function (e) {
      var container = _this.getContainer();
      if (container.contains(e.target) && container !== e.target) {
        return;
      }
      _this.toggleDropdown();
    };

    _this.handleClick = function (e) {
      var container = _this.getContainer();
      if (container.contains(e.target)) {
        _this.toggleDropdown();
      }
    };

    _this.handleRef = function (ref) {
      _this.ref = ref;
    };

    return _this;
  }

  _createClass(Dropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this2 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.open) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      return this.ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          mobile = _props.mobile,
          label = _props.label,
          ariaLabel = _props.ariaLabel,
          inside = _props.inside,
          config = _props.config,
          children = _props.children,
          inScroll = _props.inScroll,
          styleExtend = _props.styleExtend,
          loggedIn = _props.loggedIn,
          open = _props.open,
          _props$gtm = _props.gtm,
          gtm = _props$gtm === undefined ? {} : _props$gtm;


      var color = config.color;
      var inverseColor = config.inverseColor;

      return (0, _preact.h)(
        _DropdownWrapper2.default,
        {
          mobile: mobile,
          inScroll: inScroll,
          inside: inside,
          extend: styleExtend && styleExtend.wrapper,
          innerRef: this.handleRef
        },
        (0, _preact.h)(
          _DropdownButton2.default,
          _extends({
            open: open,
            'aria-haspopup': 'true',
            'aria-expanded': open ? 'true' : 'false',
            inside: inside,
            mobile: mobile,
            color: open && color,
            inScroll: inScroll,
            background: open && inverseColor,
            onClick: this.handleClick
          }, gtm),
          label,
          (0, _preact.h)(_DropdownButtonIcon2.default, { open: open, color: color, inside: inside })
        ),
        (0, _preact.h)(
          DropdownContent,
          { open: open, mobile: mobile, inside: inside, loggedIn: loggedIn, extend: styleExtend && styleExtend.dropdownContent },
          children
        )
      );
    }
  }]);

  return Dropdown;
}(_preact.Component);

exports.default = (0, _preactFela.connect)()(Dropdown);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _Core = __webpack_require__(10);

var _ChevronIcon = __webpack_require__(19);

var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);

var _ArrowIcon = __webpack_require__(30);

var _ArrowIcon2 = _interopRequireDefault(_ArrowIcon);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rules = function rules(_ref) {
  var isSubmenu = _ref.isSubmenu,
      mobile = _ref.mobile;

  var styleLink = {
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    borderBottom: 'none',
    padding: '6px 0 6px 16px',
    height: 'auto',
    alignSelf: 'stretch',
    justifyContent: 'flex-start',
    color: isSubmenu || mobile ? '#666' : '#ffffff',
    width: isSubmenu ? '100%' : 'auto'
  };
  return {
    arrow: { marginLeft: 'auto' },
    navLink: _extends({
      display: 'flex',
      alignItems: 'center',
      height: '55px',
      padding: '0 16px',
      color: '#666',
      opacity: '1',
      outline: 'none',
      position: 'relative',
      fontSize: '14px',
      textAlign: 'left',
      fontWeight: 'normal',
      borderBottom: '1px solid #e0e0e0',
      textDecoration: 'none',
      transition: 'opacity 0.3s ease-in-out'
    }, isSubmenu && mobile ? styleLink : {}, {
      desktop: _extends({}, styleLink, {
        padding: '10px',
        marginRight: '5px'
      }),
      ':hover': {
        color: isSubmenu || mobile ? '#666' : '#ffffff',
        opacity: '0.75',
        textDecoration: 'none'
      },
      ':focus': {
        color: isSubmenu || mobile ? '#666' : '#ffffff',
        opacity: '0.9',
        textDecoration: 'none'
      }
    })
  };
};

var linkIconStyle = function linkIconStyle() {
  return {
    marginRight: '8px'
  };
};

var LinkIcon = (0, _preactFela.createComponent)(linkIconStyle, _ChevronIcon2.default, ['color', 'placement']);

var NavbarListLink = function NavbarListLink(props) {
  var mobile = props.mobile,
      menu = props.menu,
      config = props.config,
      styles = props.styles,
      isSubmenu = props.isSubmenu,
      handleClick = props.handleClick,
      _props$clicktype = props.clicktype,
      clicktype = _props$clicktype === undefined ? 'menu-lateral' : _props$clicktype;


  return (0, _preact.h)(
    _Core.Link,
    _extends({
      key: menu.key,
      href: menu.url,
      className: styles.navLink,
      onClick: function onClick(event) {
        return handleClick(event, menu);
      }
    }, (0, _utils.getAttrsGtm)(menu.label, { clicktype: clicktype })),
    [isSubmenu && (0, _preact.h)(LinkIcon, { color: '#666', placement: 'left' }), menu.label],
    menu.content && (0, _preact.h)(
      'div',
      { style: menu.content.style },
      menu.content.text
    ),
    mobile && !isSubmenu && (0, _preact.h)(_ArrowIcon2.default, { className: styles.arrow, color: config.color })
  );
};

exports.default = (0, _preactFela.connect)(rules)(NavbarListLink);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preact2 = __webpack_require__(7);

var _constants = __webpack_require__(9);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Logo = function Logo(props) {
  var product = props.product,
      square = props.square,
      host = props.host,
      children = props.children,
      outherProps = _objectWithoutProperties(props, ['product', 'square', 'host', 'children']);

  if (square) {
    return (0, _preact.h)('img', _extends({ src: '' + host + _constants.PRODUCTS[product].square, 'aria-hidden': true, alt: 'Logo ' + _constants.PRODUCTS[product].name }, outherProps));
  }

  return (0, _preact.h)('img', _extends({ src: '' + host + _constants.PRODUCTS[product].logoWhite, 'aria-hidden': true, alt: 'Logo ' + _constants.PRODUCTS[product].name }, outherProps));
};

exports.default = (0, _preact2.connect)(function (_ref) {
  var heimdall = _ref.heimdall;
  return {
    host: heimdall.host
  };
})(Logo);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _preact2 = __webpack_require__(7);

var _preactFela = __webpack_require__(1);

var _actions = __webpack_require__(6);

var _Core = __webpack_require__(10);

var _BellIcon = __webpack_require__(195);

var _BellIcon2 = _interopRequireDefault(_BellIcon);

var _HeaderNotificationContent = __webpack_require__(61);

var _HeaderNotificationContent2 = _interopRequireDefault(_HeaderNotificationContent);

var _Badge = __webpack_require__(62);

var _Badge2 = _interopRequireDefault(_Badge);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var wrapperStyle = function wrapperStyle() {
  return {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  };
};

var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);

var extend = {
  dropdownContent: {
    flexWrap: 'wrap',
    padding: '0',
    desktop: {
      width: '304px'
    }
  }
};

var HeaderNotification = function (_Component) {
  _inherits(HeaderNotification, _Component);

  function HeaderNotification() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HeaderNotification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderNotification.__proto__ || Object.getPrototypeOf(HeaderNotification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.toggle = function () {
      _this.setState({ open: !_this.state.open });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HeaderNotification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.unreadNotifications();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          inScroll = _props.inScroll,
          mobile = _props.mobile,
          config = _props.config,
          notification = _props.notification,
          notifications = _props.notifications,
          readNotifications = _props.readNotifications,
          unreadNotifications = _props.unreadNotifications;


      return (0, _preact.h)(
        Wrapper,
        null,
        (0, _preact.h)(
          _Core.Dropdown,
          {
            label: (0, _preact.h)(
              'div',
              null,
              (0, _preact.h)(_BellIcon2.default, null),
              notification.unread > 0 && (0, _preact.h)(_Badge2.default, null)
            ),
            mobile: mobile,
            config: config,
            styleExtend: extend,
            dropdownIcon: false,
            toggle: this.toggle,
            open: this.state.open,
            gtm: (0, _utils.getAttrsGtm)('notificacao', { clicktype: 'menu' })
          },
          this.state.open && (0, _preact.h)(_HeaderNotificationContent2.default, {
            inScroll: inScroll,
            mobile: mobile,
            config: config,
            notification: notification,
            notifications: notifications,
            readNotifications: readNotifications,
            unreadNotifications: unreadNotifications
          })
        ),
        inScroll && (0, _preact.h)(_Core.Dividir, null)
      );
    }
  }]);

  return HeaderNotification;
}(_preact.Component);

exports.default = (0, _preact2.connect)('notification', {
  readNotifications: _actions.readNotifications,
  unreadNotifications: _actions.unreadNotifications,
  notifications: _actions.notifications
})(HeaderNotification);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _preact = __webpack_require__(0);

var BellIcon = function BellIcon(_ref) {
    var width = _ref.width,
        height = _ref.height,
        className = _ref.className;
    return (0, _preact.h)(
        "svg",
        { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 22 24", className: className },
        (0, _preact.h)(
            "g",
            { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            (0, _preact.h)(
                "g",
                { transform: "translate(-912.000000, -20.000000)", stroke: "currentColor" },
                (0, _preact.h)(
                    "g",
                    { id: "ic-bell", transform: "translate(912.000000, 20.000000)" },
                    (0, _preact.h)(
                        "g",
                        { id: "Group-4" },
                        (0, _preact.h)("path", { d: "M10.8,23.5 C12.5120827,23.5 13.9,22.1120827 13.9,20.4 C13.9,19.9468238 13.8486441,19.8559987 13.7516245,19.8369597 C13.5776463,19.8028186 13.4455813,19.8274954 12.5295281,20.0501619 C11.8312634,20.2198903 11.3420985,20.3 10.8,20.3 C10.2579015,20.3 9.76873661,20.2198903 9.07047186,20.0501619 C8.1544187,19.8274954 8.02235366,19.8028186 7.84837548,19.8369597 C7.7513559,19.8559987 7.7,19.9468238 7.7,20.4 C7.7,22.1120827 9.08791728,23.5 10.8,23.5 Z", id: "Oval-4", fill: "currentColor" }),
                        (0, _preact.h)("path", { d: "M0.652187339,18.7213312 C7.87348823,20.2947329 13.6333707,20.2903648 20.9358933,18.7234783 C20.6153579,18.4038234 19.8097068,17.6775312 19.7928695,17.6614353 C18.9681658,16.8730488 18.4570169,16.1714585 18.2580688,15.370285 C17.7242122,13.2204189 17.5652204,11.9171119 17.3399154,8.86607392 C17.1287272,6.00620252 16.870442,4.84764471 15.9458717,3.47885453 C14.6458382,1.55420565 12.9470255,0.572269409 10.8510607,0.499359264 C8.65649779,0.610567121 6.93704272,1.59512264 5.65213553,3.48056145 C4.74006212,4.81891382 4.48117871,5.97173415 4.26491968,8.8157423 C4.0318742,11.880508 3.87297986,13.1703673 3.34109651,15.3122871 C3.14093135,16.1183618 2.6316926,16.8267648 1.81063129,17.6248643 C1.80002912,17.6351699 0.96323125,18.4029192 0.652187339,18.7213312 Z", id: "Rectangle-14" })
                    )
                )
            )
        )
    );
};

BellIcon.defaultProps = {
    width: 20,
    height: 20,
    color: '#ffffff'
};

exports.default = BellIcon;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preact2 = __webpack_require__(7);

var _preactFela = __webpack_require__(1);

var _actions = __webpack_require__(6);

var _constants = __webpack_require__(9);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _NavbarProfile = __webpack_require__(197);

var _NavbarProfile2 = _interopRequireDefault(_NavbarProfile);

var _NavbarList = __webpack_require__(54);

var _NavbarList2 = _interopRequireDefault(_NavbarList);

var _NavbarSerasaConsumidor = __webpack_require__(60);

var _NavbarSerasaConsumidor2 = _interopRequireDefault(_NavbarSerasaConsumidor);

var _CloseIcon = __webpack_require__(198);

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

var _Core = __webpack_require__(10);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapperStyle = function wrapperStyle(_ref) {
  var open = _ref.open;
  return {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 2,
    background: '#ffffff',
    display: open ? 'block' : 'none',
    padding: '0 16px 22px',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch ',
    textAlign: 'center'
  };
};

var navbarHeaderStyle = function navbarHeaderStyle() {
  return {
    display: 'flex',
    justifyContent: 'center',
    margin: 0
  };
};

var closeButtonStyle = function closeButtonStyle(_ref2) {
  var theme = _ref2.theme;
  return {
    position: 'absolute',
    top: '7px',
    left: '0px',
    fontWeight: '500',
    color: theme.color
  };
};

var CloseButtonIconStyles = function CloseButtonIconStyles() {
  return {
    marginRight: '5px'
  };
};

var brandStyle = function brandStyle() {
  return {
    height: '24px'
  };
};

var Brand = (0, _preactFela.createComponent)(brandStyle, 'img', ['src', 'alt']);

var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);
var NavbarHeader = (0, _preactFela.createComponent)(navbarHeaderStyle, 'section');
var CloseButton = (0, _preactFela.createComponent)(closeButtonStyle, _Button2.default);
var CloseButtonIcon = (0, _preactFela.createComponent)(CloseButtonIconStyles, _CloseIcon2.default, ['color']);

exports.default = (0, _preact2.connect)('brand,login,signUp,config,heimdall', {
  goMenu: function goMenu(evt, menu) {
    return (0, _actions.goMenu)(evt, menu);
  },
  closeMenu: function closeMenu() {
    return (0, _actions.toggleMenuDropdown)('menu');
  },
  logout: _actions.logout
})(function (props) {
  var brand = props.brand,
      config = props.config,
      heimdall = props.heimdall,
      menus = props.menus,
      loggedIn = props.loggedIn,
      login = props.login,
      signUp = props.signUp,
      profile = props.profile;

  return (0, _preact.h)(
    Wrapper,
    { open: heimdall.dropdown.menu },
    (0, _preact.h)(
      NavbarHeader,
      null,
      (0, _preact.h)(
        CloseButton,
        _extends({ onClick: props.closeMenu }, (0, _utils.getAttrsGtm)("fechar", { clicktype: 'menu-lateral' })),
        [(0, _preact.h)(CloseButtonIcon, { color: config.color }), 'fechar']
      ),
      (0, _preact.h)(
        _Button2.default,
        { padding: '12px 16px 8px' },
        (0, _preact.h)(Brand, { src: brand.logo.default, alt: brand.logo.alt })
      )
    ),
    (0, _preact.h)(_NavbarProfile2.default, {
      loggedIn: loggedIn,
      profile: profile,
      login: login,
      signUp: signUp,
      logout: props.logout,
      closeMenu: props.closeMenu,
      config: config
    }),
    (0, _preact.h)(_NavbarList2.default, { menus: menus, config: config, mobile: true, goMenu: function goMenu(evt, menu) {
        props.closeMenu();
        props.goMenu(evt, menu);
      } }),
    (0, _preact.h)(_NavbarSerasaConsumidor2.default, { config: config, heimdall: heimdall, mobile: true }),
    (0, _preact.h)(Brand, { src: '' + heimdall.host + _constants.PRODUCTS[_constants.SERASA].logoGray, alt: 'SerasaConsumidor' })
  );
});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _ProfileFirstName = __webpack_require__(31);

var _ProfileFirstName2 = _interopRequireDefault(_ProfileFirstName);

var _actions = __webpack_require__(6);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var rules = function rules() {
  return {
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      margin: '30px 0 25px',
      boxSizing: 'border-box'
    },
    profile: {
      display: 'flex',
      width: '100%'
    },
    profileContainer: {
      marginLeft: '24px'
    },
    profileAvatar: {
      width: '48px',
      height: '48px',
      marginLeft: '6px',
      borderRadius: '50%',
      backgroundColor: '#d8d8d8',
      overflow: 'hidden'
    },
    profileCTA: {
      margin: '0 5px',
      fontSize: '12px',
      minWidth: '110px'
    },
    profilePicture: {
      maxWidth: '100%',
      maxHeight: '100%'
    },
    profileButton: {
      fontSize: '12px',
      border: '1px solid currentColor',
      marginRight: '8px'
    },
    profileName: {
      textAlign: 'left',
      marginBottom: '16px',
      color: '#666',
      fontSize: '18px'
    },
    spacer: {
      marginBottom: '1rem'
    }
  };
};

var NavbarProfile = function (_Component) {
  _inherits(NavbarProfile, _Component);

  function NavbarProfile() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavbarProfile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavbarProfile.__proto__ || Object.getPrototypeOf(NavbarProfile)).call.apply(_ref, [this].concat(args))), _this), _this.handleLogout = function (event) {
      event.preventDefault();

      _this.props.logout();
      _this.props.closeMenu();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavbarProfile, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loggedIn = _props.loggedIn,
          login = _props.login,
          signUp = _props.signUp,
          profile = _props.profile,
          config = _props.config,
          styles = _props.styles;


      var loginDisabled = login.disabledInProfile;
      var loginText = login.text;
      var loginAccessibleLabel = login.loginAccessibleLabel;
      var loginPath = login.path;
      var loginCallback = login.callback;
      var loginEl = typeof loginCallback === 'function' ? 'button' : 'a';

      var signUpDisabled = signUp.disabledInProfile;
      var signUpText = signUp.textInMenu || signUp.text;
      var accessibleTextLabel = signUp.accessibleTextLabel;
      var signUpPath = signUp.path;
      var signUpCallback = signUp.callback;
      var signUpEl = typeof signUpCallback === 'function' ? 'button' : 'a';

      var color = config.color;
      var inverseColor = config.inverseColor;

      var navbarGoSignUp = function navbarGoSignUp(evt) {
        (0, _actions.goSignUp)(evt, 'menu');
      };

      if (!loggedIn && loginDisabled && signUpDisabled) {
        return (0, _preact.h)('div', { className: styles.spacer });
      }

      return (0, _preact.h)(
        'div',
        { className: styles.wrapper },
        loggedIn ? (0, _preact.h)(
          'div',
          { className: styles.profile },
          (0, _preact.h)(
            'div',
            { className: styles.profileAvatar },
            profile.picture && (0, _preact.h)('img', { src: profile.picture, className: styles.profilePicture })
          ),
          (0, _preact.h)(
            'div',
            { className: styles.profileContainer },
            (0, _preact.h)(
              'div',
              { className: styles.profileName },
              (0, _preact.h)(_ProfileFirstName2.default, { name: profile.name })
            ),
            (0, _preact.h)(
              _Button2.default,
              _extends({ href: '/meus-dados/alterar-dados/', as: 'a', color: color, dense: true, className: styles.profileButton }, (0, _utils.getAttrsGtm)("Editar dados", { clicktype: 'menu' })),
              'Editar dados'
            ),
            (0, _preact.h)(
              _Button2.default,
              _extends({ onClick: this.handleLogout, color: color, dense: true, className: styles.profileButton }, (0, _utils.getAttrsGtm)("Sair", { clicktype: 'menu' })),
              'Sair'
            )
          )
        ) : [(0, _preact.h)(
          _Button2.default,
          _extends({
            href: signUpPath,
            onClick: navbarGoSignUp,
            color: color,
            as: signUpEl,
            'aria-label': accessibleTextLabel,
            className: styles.profileCTA
          }, (0, _utils.getAttrsGtm)(signUpText, { clicktype: 'menu' })),
          signUpText
        ), (0, _preact.h)(
          _Button2.default,
          _extends({
            href: loginPath,
            onClick: _actions.goLogin,
            color: inverseColor,
            background: color,
            as: loginEl,
            className: styles.profileCTA
          }, (0, _utils.getAttrsGtm)(loginText, { clicktype: 'menu' }), {
            'aria-label': loginAccessibleLabel
          }),
          loginText
        )]
      );
    }
  }]);

  return NavbarProfile;
}(_preact.Component);

exports.default = (0, _preactFela.connect)(rules)(NavbarProfile);

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var CloseIcon = function CloseIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      className = _ref.className;
  return (0, _preact.h)(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 10 10", className: className },
    (0, _preact.h)("path", { fill: color, "fill-rule": "evenodd", d: "M4.535 3.628L8.163 0l.907.907-3.628 3.628L9.07 8.163l-.907.907-3.628-3.628L.907 9.07 0 8.163l3.628-3.628L0 .907.907 0l3.628 3.628z" })
  );
};

CloseIcon.defaultProps = {
  width: 10,
  height: 10,
  color: '#ffffff'
};

exports.default = CloseIcon;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preact2 = __webpack_require__(7);

var _actions = __webpack_require__(6);

var _Core = __webpack_require__(10);

var _HeaderProfileCTA = __webpack_require__(200);

var _HeaderProfileCTA2 = _interopRequireDefault(_HeaderProfileCTA);

var _HeaderProfileAvatar = __webpack_require__(201);

var _HeaderProfileAvatar2 = _interopRequireDefault(_HeaderProfileAvatar);

var _HeaderProfileIcon = __webpack_require__(202);

var _HeaderProfileIcon2 = _interopRequireDefault(_HeaderProfileIcon);

var _HeaderProfileNav = __webpack_require__(203);

var _HeaderProfileNav2 = _interopRequireDefault(_HeaderProfileNav);

var _HeaderNotificationContent = __webpack_require__(61);

var _HeaderNotificationContent2 = _interopRequireDefault(_HeaderNotificationContent);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var extend = {
  wrapper: function wrapper(_ref) {
    var inScroll = _ref.inScroll,
        mobile = _ref.mobile;
    return _extends({}, mobile && {
      position: 'absolute',
      top: 0,
      right: 0
    });
  },
  dropdownContent: function dropdownContent(_ref2) {
    var loggedIn = _ref2.loggedIn,
        mobile = _ref2.mobile;
    return _extends({
      padding: 0
    }, mobile && loggedIn && {
      height: '100%',
      maxHeight: 'calc(100% - 48px)'
    }, {
      desktop: {
        width: '240px'
      }
    });
  }
};

var Profile = function (_Component) {
  _inherits(Profile, _Component);

  function Profile() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Profile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Profile.__proto__ || Object.getPrototypeOf(Profile)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.handleClickLinkProfileNav = function (profile) {
      return function (event) {
        var proxy = _this.props.config.proxy;
        var logout = _this.props.logout;


        if (profile.logout) {
          event.preventDefault();
          logout();
          _this.setState({ open: false });
        } else if (proxy) {
          proxy(event, function () {
            return _this.setState({ open: false });
          });
        }
      };
    }, _this.toggle = function () {
      _this.setState({ open: !_this.state.open });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Profile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.notification.active && this.props.loggedIn) {
        this.props.unreadNotifications();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _h;

      var _props = this.props,
          mobile = _props.mobile,
          inScroll = _props.inScroll,
          loggedIn = _props.loggedIn,
          profile = _props.profile,
          login = _props.login,
          signUp = _props.signUp,
          config = _props.config,
          heimdall = _props.heimdall,
          notification = _props.notification;


      if (config.profileDisabled) return null;

      if (!loggedIn) {
        if (!mobile || inScroll) {
          return (0, _preact.h)(_HeaderProfileCTA2.default, {
            inScroll: inScroll,
            mobile: mobile,
            login: login,
            signUp: signUp,
            config: config
          });
        }

        if (config.singleCTA) {
          return (0, _preact.h)(_HeaderProfileIcon2.default, { signUp: signUp });
        }
      }

      return (0, _preact.h)(
        _Core.Dropdown,
        {
          label: (0, _preact.h)(_HeaderProfileAvatar2.default, { mobile: mobile, notification: notification, loggedIn: loggedIn, profile: profile }),
          styleExtend: extend,
          mobile: mobile,
          config: config,
          loggedIn: loggedIn,
          inScroll: inScroll,
          toggle: this.toggle,
          open: this.state.open,
          gtm: (0, _utils.getAttrsGtm)("Minha conta", { clicktype: 'menu' })
        },
        loggedIn ? [(0, _preact.h)(_HeaderProfileNav2.default, { mobile: mobile, profile: profile, config: config, heimdall: heimdall, onClickLink: this.handleClickLinkProfileNav }), notification.active && mobile && this.state.open && (0, _preact.h)(_HeaderNotificationContent2.default, (_h = {
          collapsed: true,
          inScroll: inScroll, mobile: mobile,
          notification: notification,
          config: config
        }, _defineProperty(_h, 'notification', notification), _defineProperty(_h, 'notifications', _actions.notifications), _defineProperty(_h, 'readNotifications', _actions.readNotifications), _defineProperty(_h, 'unreadNotifications', _actions.unreadNotifications), _h))] : (0, _preact.h)(_HeaderProfileCTA2.default, { inside: true, inScroll: inScroll, login: login, signUp: signUp, config: config })
      );
    }
  }]);

  return Profile;
}(_preact.Component);

exports.default = (0, _preact2.connect)('loggedIn,profile,login,signUp,heimdall,notification,profileDisabled', {
  logout: _actions.logout,
  notifications: _actions.notifications,
  unreadNotifications: _actions.unreadNotifications,
  readNotifications: _actions.readNotifications
})(Profile);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _actions = __webpack_require__(6);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ctaButtonStyle = function ctaButtonStyle(_ref) {
  var shadow = _ref.shadow,
      order = _ref.order;
  return {
    boxShadow: shadow ? '0 2px 2px 0 rgba(18, 37, 79, 0.3)' : undefined,
    order: order
  };
};

var wrapperStyle = function wrapperStyle(_ref2) {
  var mobile = _ref2.mobile,
      inside = _ref2.inside;
  return _extends({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    marginRight: !inside && mobile ? '8px' : undefined
  }, inside ? {
    padding: '16px',
    boxSizing: 'border-box',
    flexDirection: 'column',
    width: '100%',
    '& > *': {
      width: '100%',
      fontSize: '14px',
      margin: '0',
      padding: '14px 0',
      marginTop: '10px'
    }
  } : {}, {
    desktop: {
      '& > *': {
        marginLeft: '8px',
        fontSize: '12px',
        '&:first-child': {
          marginLeft: '16px'
        }
      }
    }
  });
};

var CTAButton = (0, _preactFela.createComponentWithProxy)(ctaButtonStyle, _Button2.default);
var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);

exports.default = function (props) {
  var mobile = props.mobile,
      inside = props.inside,
      login = props.login,
      signUp = props.signUp,
      config = props.config;


  var loginDisabled = login.disabledInNavbar;
  var loginText = login.text;
  var loginAccessibleLabel = login.loginAccessibleLabel;
  var loginPath = login.path;
  var loginEl = typeof login.callback === 'function' ? 'button' : 'a';

  var signUpDisabled = signUp.disabledInNavbar;
  var signUpText = signUp.text;
  var signUpAccessibleLabel = signUp.signUpAccessibleLabel;
  var signUpPath = signUp.path;
  var signUpEl = typeof signUp.callback === 'function' ? 'button' : 'a';

  var color = config.color;
  var inverseColor = config.inverseColor;

  var loginColor = inside ? color : inverseColor;

  var singUpColor = inside ? inverseColor : color;
  var singUpInverseColor = inside ? color : inverseColor;

  var headerGoSignUp = function headerGoSignUp(evt) {
    (0, _actions.goSignUp)(evt, 'navbar');
  };

  return (0, _preact.h)(
    Wrapper,
    { mobile: mobile, inside: inside },
    !loginDisabled && (inside || !mobile) && (0, _preact.h)(
      CTAButton,
      _extends({
        href: loginPath,
        color: loginColor,
        onClick: _actions.goLogin,
        order: inside ? 2 : 1,
        as: loginEl
      }, (0, _utils.getAttrsGtm)(loginText, { clicktype: 'menu' }), {
        'aria-label': loginAccessibleLabel
      }),
      loginText
    ),
    !signUpDisabled && (0, _preact.h)(
      CTAButton,
      _extends({
        href: signUpPath,
        onClick: headerGoSignUp,
        order: inside ? 1 : 2,
        color: singUpColor,
        background: singUpInverseColor,
        shadow: !inside && mobile,
        as: signUpEl
      }, (0, _utils.getAttrsGtm)(signUpText, { clicktype: 'menu' }), {
        'aria-label': signUpAccessibleLabel
      }),
      signUpText
    )
  );
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _ProfileFirstName = __webpack_require__(31);

var _ProfileFirstName2 = _interopRequireDefault(_ProfileFirstName);

var _UserIcon = __webpack_require__(63);

var _UserIcon2 = _interopRequireDefault(_UserIcon);

var _Badge = __webpack_require__(62);

var _Badge2 = _interopRequireDefault(_Badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rules = function rules() {
  return {
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    avatar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      color: 'currentColor',
      fontSize: '14px',
      textTransform: 'none',
      fontWeight: 'normal'
    },
    avatarContainer: {
      display: 'none',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginLeft: '14px',
      desktop: {
        display: 'flex'
      }
    },
    avatarDescription: {
      fontSize: '12px',
      textDecoration: 'underline'
    },
    avatarWrapperPicture: {
      display: 'inline-block',
      borderRadius: '50%',
      width: '22px',
      height: '22px',
      backgroundColor: '#d8d8d8',
      overflow: 'hidden',
      desktop: {
        width: '32px',
        height: '32px'
      }
    },
    avatarPicture: {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  };
};

var HeaderProfileAvatar = function HeaderProfileAvatar(props) {
  var loggedIn = props.loggedIn,
      profile = props.profile,
      styles = props.styles,
      mobile = props.mobile,
      notification = props.notification;


  return (0, _preact.h)(
    'div',
    { className: styles.wrapper },
    loggedIn ? (0, _preact.h)(
      'span',
      { className: styles.avatar },
      (0, _preact.h)(
        'span',
        { className: styles.avatarWrapperPicture },
        profile.picture && (0, _preact.h)('img', { src: profile.picture, className: styles.avatarPicture })
      ),
      (0, _preact.h)(
        'span',
        { className: styles.avatarContainer },
        (0, _preact.h)(
          'span',
          null,
          (0, _preact.h)(_ProfileFirstName2.default, { name: profile.name })
        ),
        (0, _preact.h)(
          'span',
          { className: styles.avatarDescription },
          'Minha conta'
        )
      )
    ) : (0, _preact.h)(_UserIcon2.default, null),
    loggedIn && notification.active && mobile && notification.unread > 0 && (0, _preact.h)(_Badge2.default, null)
  );
};

exports.default = (0, _preactFela.connect)(rules)(HeaderProfileAvatar);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _actions = __webpack_require__(6);

var _UserIcon = __webpack_require__(63);

var _UserIcon2 = _interopRequireDefault(_UserIcon);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapperStyle = function wrapperStyle() {
  return {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%'
  };
};

var buttonStyle = function buttonStyle() {
  return {
    width: '100%',
    height: '100%',
    padding: '0 16px',
    border: 'none',
    borderRadius: '0',
    position: 'relative',
    textTransform: 'none',
    fontSize: '14px',
    color: '#fff',
    display: 'inline-flex',
    alignItems: 'center',
    opacity: 1,
    outline: 'none',
    '&:hover, &:focus': {
      textDecoration: 'none',
      color: '#fff'
    }
  };
};

var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);
var Button = (0, _preactFela.createComponentWithProxy)(buttonStyle);

var headerGoSignUp = function headerGoSignUp(evt) {
  (0, _actions.goSignUp)(evt, 'perfil');
};

var HeaderProfileIcon = function HeaderProfileIcon(props) {
  var signUp = props.signUp;


  var signUpPath = signUp.path;
  var signUpAccessibleLabel = signUp.signUpAccessibleLabel;
  var signUpEl = typeof signUp.callback === 'function' ? 'button' : 'a';

  return (0, _preact.h)(
    Wrapper,
    null,
    (0, _preact.h)(
      Button,
      _extends({
        href: signUpPath,
        onClick: headerGoSignUp,
        as: signUpEl,
        'aria-label': signUpAccessibleLabel
      }, (0, _utils.getAttrsGtm)(signUpEl, { clicktype: 'menu' })),
      (0, _preact.h)(_UserIcon2.default, { width: 22, height: 22 })
    )
  );
};

exports.default = HeaderProfileIcon;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _ProfileFirstName = __webpack_require__(31);

var _ProfileFirstName2 = _interopRequireDefault(_ProfileFirstName);

var _Link = __webpack_require__(56);

var _Link2 = _interopRequireDefault(_Link);

var _ArrowIcon = __webpack_require__(30);

var _ArrowIcon2 = _interopRequireDefault(_ArrowIcon);

var _ChevronIcon = __webpack_require__(19);

var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rules = function rules() {
  return {
    wrapper: {
      width: '100%',
      boxSizing: 'border-box',
      display: 'block',
      padding: '16px',
      desktop: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        padding: '24px',
        '& > *:last-child': {
          marginBottom: '0'
        }
      }
    },
    profileName: {
      display: 'block',
      width: '100%',
      marginBottom: '30px',
      fontSize: '18px',
      textAlign: 'left',
      color: '#666',
      desktop: {
        display: 'none'
      }
    },
    navLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      height: '56px',
      padding: '0 16px',
      color: '#666',
      position: 'relative',
      fontSize: '14px',
      textAlign: 'left',
      borderTop: '1px solid #e0e0e0',
      transition: 'opacity 0.2s ease-in-out',
      willChange: 'opacity',
      ':hover': {
        color: '#666666',
        opacity: '0.75',
        textDecoration: 'none'
      },
      desktop: {
        height: 'auto',
        width: '200px',
        justifyContent: 'flex-start',
        padding: '6px 0',
        marginBottom: '12px',
        border: 'none'
      }
    },
    navLinkChevronIcon: {
      marginRight: '10px'
    }
  };
};

var HeaderProfileNav = function HeaderProfileNav(props) {
  var mobile = props.mobile,
      profile = props.profile,
      config = props.config,
      heimdall = props.heimdall,
      styles = props.styles,
      onClickLink = props.onClickLink;


  return (0, _preact.h)(
    'div',
    { className: styles.wrapper },
    (0, _preact.h)(
      'span',
      { className: styles.profileName },
      (0, _preact.h)(_ProfileFirstName2.default, { name: profile.name })
    ),
    heimdall.profiles.map(function (profile) {
      return (0, _preact.h)(
        _Link2.default,
        _extends({ key: profile.key, href: profile.path, onClick: onClickLink(profile), title: profile.label, className: styles.navLink }, (0, _utils.getAttrsGtm)(profile.label, { clicktype: 'submenu' })),
        [!mobile && (0, _preact.h)(_ChevronIcon2.default, { placement: 'left', className: styles.navLinkChevronIcon }), profile.label, mobile && (0, _preact.h)(_ArrowIcon2.default, { color: config.color })]
      );
    })
  );
};

exports.default = (0, _preactFela.connect)(rules)(HeaderProfileNav);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _HamburgerIcon = __webpack_require__(205);

var _HamburgerIcon2 = _interopRequireDefault(_HamburgerIcon);

var _Core = __webpack_require__(10);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonExtend = function buttonExtend(_ref) {
  var mobile = _ref.mobile;
  return _extends({
    height: '100%'
  }, mobile && {
    position: 'absolute',
    top: 0,
    left: 0
  });
};

var text = function text() {
  return {
    marginLeft: '5px',
    textTransform: 'uppercase',
    fontSize: '10px',
    color: '#ffffff',
    fontWeight: 500
  };
};

var Text = (0, _preactFela.createComponent)(text, 'span');

exports.default = function (_ref2) {
  var mobile = _ref2.mobile,
      inScroll = _ref2.inScroll,
      loggedIn = _ref2.loggedIn,
      onOpenMenu = _ref2.onOpenMenu;

  if (!mobile) {
    return null;
  }

  return (0, _preact.h)(
    'div',
    null,
    (0, _preact.h)(
      _Button2.default,
      _extends({ onClick: function onClick() {
          return onOpenMenu('menu');
        }, inScroll: inScroll, mobile: mobile, extend: buttonExtend, 'aria-label': 'Abrir Menu com op\xE7\xF5es adicionais' }, (0, _utils.getAttrsGtm)("abrir", { clicktype: 'menu-lateral' })),
      (0, _preact.h)(_HamburgerIcon2.default, null),
      (loggedIn || !inScroll) && (0, _preact.h)(
        Text,
        null,
        'menu'
      )
    )
  );
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var HamburgerIcon = function HamburgerIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;
  return (0, _preact.h)(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 " + width + " " + height },
    (0, _preact.h)("path", { fill: color, "fill-rule": "evenodd", d: "M0 0h12v2H0V0zm0 6h10v2H0V6zm0 6h8v2H0v-2z" })
  );
};

HamburgerIcon.defaultProps = {
  width: 12,
  height: 14,
  color: '#ffffff'
};

exports.default = HamburgerIcon;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _preactFela = __webpack_require__(1);

var _actions = __webpack_require__(6);

var _constants = __webpack_require__(9);

var _Button = __webpack_require__(11);

var _Button2 = _interopRequireDefault(_Button);

var _Dividir = __webpack_require__(55);

var _Dividir2 = _interopRequireDefault(_Dividir);

var _SerasaConsumidorIcon = __webpack_require__(207);

var _SerasaConsumidorIcon2 = _interopRequireDefault(_SerasaConsumidorIcon);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var rules = function rules(_ref) {
  var loggedIn = _ref.loggedIn,
      mobile = _ref.mobile,
      inScroll = _ref.inScroll;
  return {
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      flex: !loggedIn && mobile && inScroll ? 1 : undefined,
      desktop: {
        flex: 1
      }
    },
    brandButton: {
      padding: mobile && !inScroll ? '0' : undefined
    },
    brand: {
      verticalAlign: 'bottom',
      height: inScroll || mobile ? '24px' : '28px',
      desktop: {
        height: '32px'
      }
    }
  };
};

var brandButton = function brandButton() {
  return {
    display: 'inline-block'
  };
};

var BrandButton = (0, _preactFela.createComponentWithProxy)(brandButton, _Button2.default);

var divider = function divider(_ref2) {
  var inScroll = _ref2.inScroll,
      mobile = _ref2.mobile;
  return _extends({}, inScroll && mobile && {
    marginLeft: '44px'
  });
};

var Divider = (0, _preactFela.createComponentWithProxy)(divider, _Dividir2.default);

var HeaderBrand = function (_Component) {
  _inherits(HeaderBrand, _Component);

  function HeaderBrand() {
    _classCallCheck(this, HeaderBrand);

    return _possibleConstructorReturn(this, (HeaderBrand.__proto__ || Object.getPrototypeOf(HeaderBrand)).apply(this, arguments));
  }

  _createClass(HeaderBrand, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          product = _props.product,
          mobile = _props.mobile,
          loggedIn = _props.loggedIn,
          inScroll = _props.inScroll,
          brand = _props.brand,
          heimdall = _props.heimdall,
          styles = _props.styles;

      var fullWidth = !loggedIn && mobile && inScroll;

      var brandPath = brand.path;
      var brandCallback = brand.callback;
      var brandEl = typeof brandCallback === 'function' ? 'button' : 'a';

      var showIconSC = product !== _constants.SERASA;
      var brandTitle = product !== _constants.SERASA ? _constants.EXTERNAL_SITE_MESSAGE : undefined;
      var productName = _constants.PRODUCTS[product].name;

      var brandImage = void 0;
      var brandAlt = void 0;

      if (brand.logo && (brand.logo.negative || brand.logo.default)) {
        brandImage = brand.logo.negative || brand.logo.default;
        brandAlt = brand.logo.alt || productName;
      } else {
        brandImage = '' + heimdall.host + _constants.PRODUCTS[product].logoWhite;
        brandAlt = productName;
      }

      return (0, _preact.h)(
        'div',
        { className: styles.wrapper },
        !mobile && showIconSC && (0, _preact.h)(
          _Button2.default,
          _extends({ href: '/', onClick: _actions.goSerasaConsumidor, as: 'a', title: brandTitle }, (0, _utils.getAttrsGtm)("Serasa")),
          (0, _preact.h)(_SerasaConsumidorIcon2.default, null)
        ),
        (fullWidth || !mobile && showIconSC) && (0, _preact.h)(Divider, { inScroll: inScroll, mobile: mobile }),
        (0, _preact.h)(
          BrandButton,
          _extends({ href: brandPath, onClick: _actions.goBrandPath, 'aria-label': 'Ir para a p\xE1gina inicial da Serasa', className: styles.brandButton, as: brandEl }, (0, _utils.getAttrsGtm)(productName)),
          (0, _preact.h)('img', { src: brandImage, alt: brandAlt, 'aria-hidden': true, className: styles.brand })
        )
      );
    }
  }]);

  return HeaderBrand;
}(_preact.Component);

exports.default = (0, _preactFela.connect)(rules)(HeaderBrand);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = __webpack_require__(0);

var SerasaConsumidorIcon = function SerasaConsumidorIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      className = _ref.className;
  return (0, _preact.h)(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 22 28", className: className },
    (0, _preact.h)(
      "g",
      { fill: color, "fill-rule": "nonzero" },
      (0, _preact.h)("path", { d: "M13.72 6.608h-3.192c-.952 0-1.68-.784-1.68-1.68V1.736c0-.952.784-1.68 1.68-1.68h3.192c.952 0 1.68.784 1.68 1.68v3.192c0 .896-.784 1.68-1.68 1.68M5.488 13.72H1.904C.84 13.72 0 12.824 0 11.76V8.176c0-1.064.84-1.904 1.904-1.904h3.584c1.064 0 1.904.84 1.904 1.904v3.584c0 1.064-.84 1.96-1.904 1.96M5.152 21.112H2.968a1.148 1.148 0 0 1-1.176-1.176v-2.184c0-.672.504-1.176 1.176-1.176h2.184c.672 0 1.176.504 1.176 1.176v2.184c0 .672-.504 1.176-1.176 1.176M10.976 28H8.4c-.784 0-1.4-.616-1.4-1.4v-2.576c0-.784.616-1.4 1.4-1.4h2.576c.784 0 1.4.616 1.4 1.4V26.6c0 .784-.616 1.4-1.4 1.4M20.44 7.896h-1.792a.981.981 0 0 1-.952-.952V5.152c0-.504.448-.952.952-.952h1.792c.504 0 .952.448.952.952v1.792a.944.944 0 0 1-.952.952M14.504 15.176c-.616-.336-1.288-.672-1.904-1.008a8.192 8.192 0 0 1-.728-.504c-.504-.504-.392-1.232.168-1.512a1.08 1.08 0 0 1 .56-.168c.56-.056 1.12.056 1.624.392.28.168.56.28.84.336.28.056.56-.056.728-.336.168-.224.168-.504.056-.784a1.322 1.322 0 0 0-.448-.504c-.728-.56-1.512-.784-2.408-.784-.672 0-1.288.168-1.848.448-1.232.672-1.68 2.016-1.176 3.304.28.616.728 1.064 1.288 1.4.504.28 1.064.56 1.568.784.448.224.84.448 1.232.84.448.448.504.952.224 1.344-.224.336-.504.448-.896.504-.728.112-1.344-.056-1.96-.448-.224-.112-.392-.28-.672-.336-.672-.224-1.232.224-1.12.896.056.28.224.504.448.672 1.12.952 3.136 1.232 4.536.56 1.456-.728 1.96-2.296 1.232-3.696-.28-.728-.784-1.12-1.344-1.4" })
    )
  );
};

SerasaConsumidorIcon.defaultProps = {
  width: 22,
  height: 28,
  color: '#ffffff'
};

exports.default = SerasaConsumidorIcon;

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCookie */
/* unused harmony export isSafari */
/* harmony export (immutable) */ __webpack_exports__["a"] = isStorageAvailable;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return menusPersonalLoan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return menusCreditCard; });
function getCookie(cname){var name=cname+'=';var ca=document.cookie.split(';');for(var i=0;i<ca.length;i++){var c=ca[i];while(c.charAt(0)==' '){c=c.substring(1);}if(c.indexOf(name)==0){return c.substring(name.length,c.length);}}return'';}function isSafari(){return navigator.userAgent.indexOf('Safari')!=-1&&navigator.userAgent.indexOf('Chrome')==-1;}function isStorageAvailable(){try{var value='test';var key='TEST';localStorage.setItem(key,value);var recoveredValue=localStorage.getItem(key);localStorage.removeItem(key);return recoveredValue===value;}catch(e){return false;}}var menusPersonalLoan=[{url:'/ecred/emprestimo-pessoal',key:'emprestimo-pessoal',label:'Empréstimo pessoal online'},{url:'/ecred/emprestimo-com-garantia-de-imovel',key:'emprestimo-com-garantia-de-imovel',label:'Empréstimo com garantia de imóvel'},{url:'/ecred/parceiros/emprestimo-com-garantia-de-celular',key:'emprestimo-com-garantia-de-celular',label:'Empréstimo com garantia de celular'},{url:'/ecred/emprestimos/emprestimo-com-garantia-de-veiculo',key:'emprestimo-com-garantia-de-veiculo',label:'Empréstimo com garantia de veículo'},{url:'/ecred/emprestimo-para-autonomo',key:'emprestimo-para-autonomo',label:'Empréstimo para autônomo'},{url:'/ecred/emprestimo-para-autonomo-negativado',key:'emprestimo-para-autonomo-negativado',label:'Empréstimo para autônomo negativado'},{url:'/ecred/emprestimo-sem-comprovacao-de-renda',key:'emprestimo-sem-comprovacao-de-renda',label:'Empréstimo sem comprovação de renda'},{url:'/ecred/emprestimo-para-negativado',key:'emprestimo-para-negativado',label:'Empréstimo para negativado'},{url:'/ecred/simulador',key:'simulador',label:'Simulador de empréstimo online'}];var menusCreditCard=[{url:'/ecred/cartao-de-credito',key:'cartao-de-credito',label:'Cartão de crédito'},{url:'/ecred/cartao-de-credito-consignado',key:'cartao-de-credito-consignado',label:'Cartão de crédito consignado'},{url:'/ecred/cartao-pre-pago',key:'cartao-pre-pago',label:'Cartão pré-pago'}];

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ecs_booster__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ecs_booster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ecs_booster__);
__WEBPACK_IMPORTED_MODULE_0__ecs_booster___default.a.initialize({page:{product:'ecred'}});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_index_scss__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analytics__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_footer_footer__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_header_header__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__booster__ = __webpack_require__(209);
/* harmony default export */ __webpack_exports__["a"] = (function(pages){Object(__WEBPACK_IMPORTED_MODULE_3__partials_header_header__["a" /* default */])(pages);Object(__WEBPACK_IMPORTED_MODULE_2__partials_footer_footer__["a" /* default */])();Object(__WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* default */])();});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var toggleAccordion=function toggleAccordion(event){var toggle=event.target;var content=toggle.nextElementSibling;if(!content)return;event.preventDefault();if(toggle.classList.contains('active')){toggle.classList.remove('active');content.style.maxHeight=null;return;}[].forEach.call(document.querySelectorAll('.ecs_footer__map-title.active'),function(accordion){accordion.classList.remove('active');accordion.nextElementSibling.style.maxHeight=null;});content.style.maxHeight=content.scrollHeight+'px';toggle.classList.toggle('active');};/* harmony default export */ __webpack_exports__["a"] = (function(){if(window.innerWidth>=992){return;}[].forEach.call(document.getElementsByClassName('ecs_footer__map-title'),function(accordion){accordion.addEventListener('click',toggleAccordion);});});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ecs_heimdall__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ecs_heimdall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ecs_heimdall__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(208);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var REDIRECT_URL='redirectUrl='+"/area-cliente/solucoes/area-credito";var menusHome=function menusHome(pages){if(pages){return[{url:'/ecred',key:'ir-para-home',label:'Ir para home'}];}return[];};/* harmony default export */ __webpack_exports__["a"] = (function(pages){__WEBPACK_IMPORTED_MODULE_0__ecs_heimdall___default()({product:'ecred',menus:[].concat(_toConsumableArray(menusHome(pages)),[{url:'/ecred/como-funciona-credito-on-line',key:'como-funciona-credito-on-line',label:'Como funciona'},{label:'Empréstimo',key:'emprestimo',withIconMenu:true,items:__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* menusPersonalLoan */]},{label:'Cartão',key:'cartao',withIconMenu:true,items:__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* menusCreditCard */]},{url:'/ecred/parceiros',key:'partners',label:'Parceiros'},{url:'/ecred/como-funciona-o-ecred',key:'como-funciona-o-ecred',label:'O eCred'},{label:'Ajuda',key:'ajuda',withIconMenu:true,items:[{url:'/ecred/canais-de-atendimento',key:'canais-de-atendimento',label:'Canais de atendimento'},{url:'/ecred/por-que-meu-credito-foi-negado',key:'por-que-meu-credito-foi-negado',label:'Por que meu crédito foi negado?'},{url:'/ecred/faq',key:'faq',label:'Tire suas dúvidas'}]}]),brand:{path:"/ecred",logo:{default:__WEBPACK_IMPORTED_MODULE_0__ecs_heimdall__["images"]['ecred'].logo,negative:__WEBPACK_IMPORTED_MODULE_0__ecs_heimdall__["images"]['ecred'].logoWhite},callback:function callback(){return window.location.href="/ecred";}},login:{path:'/entrar?'+REDIRECT_URL},signUp:{path:'/cadastrar?'+REDIRECT_URL},config:{color:'#e40781',background:pages?'#e40781':'transparent',backgroundInScroll:'#e40781'}},document.getElementById('heimdall'));});

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_scss__);
var STORAGE_AVAILABLE=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* isStorageAvailable */])();function main(){Object(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(true);Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* setCustomData */])('emprestimo-sem-comprovacao-de-rend','conteudo interno');}main();

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[242]);


// WEBPACK FOOTER //
// static/js/unsecured_loan.06931528.js